/** Get a list of all font awesome 6 icon's name list */
export function getFontAwesome6IconList(): string[] {
    return [
        "0",
        "00",
        "1",
        "2",
        "3",
        "360-degrees",
        "4",
        "42-group",
        "5",
        "500px",
        "6",
        "7",
        "8",
        "9",
        "a",
        "abacus",
        "accent-grave",
        "accessible-icon",
        "accusoft",
        "acorn",
        "address-book",
        "address-card",
        "adn",
        "adversal",
        "affiliatetheme",
        "air-conditioner",
        "airbnb",
        "airplay",
        "alarm-clock",
        "alarm-exclamation",
        "alarm-plus",
        "alarm-snooze",
        "album",
        "album-circle-plus",
        "album-circle-user",
        "album-collection",
        "album-collection-circle-plus",
        "album-collection-circle-user",
        "algolia",
        "alicorn",
        "alien",
        "alien-8bit",
        "align-center",
        "align-justify",
        "align-left",
        "align-right",
        "align-slash",
        "alipay",
        "alt",
        "amazon",
        "amazon-pay",
        "amilia",
        "amp-guitar",
        "ampersand",
        "anchor",
        "anchor-circle-check",
        "anchor-circle-exclamation",
        "anchor-circle-xmark",
        "anchor-lock",
        "android",
        "angel",
        "angellist",
        "angle",
        "angle-90",
        "angle-down",
        "angle-left",
        "angle-right",
        "angle-up",
        "angles-down",
        "angles-left",
        "angles-right",
        "angles-up",
        "angles-up-down",
        "angrycreative",
        "angular",
        "ankh",
        "apartment",
        "aperture",
        "apostrophe",
        "app-store",
        "app-store-ios",
        "apper",
        "apple",
        "apple-core",
        "apple-pay",
        "apple-whole",
        "archway",
        "arrow-down",
        "arrow-down-1-9",
        "arrow-down-9-1",
        "arrow-down-a-z",
        "arrow-down-arrow-up",
        "arrow-down-big-small",
        "arrow-down-from-arc",
        "arrow-down-from-dotted-line",
        "arrow-down-from-line",
        "arrow-down-left",
        "arrow-down-left-and-arrow-up-right-to-center",
        "arrow-down-long",
        "arrow-down-right",
        "arrow-down-short-wide",
        "arrow-down-small-big",
        "arrow-down-square-triangle",
        "arrow-down-to-arc",
        "arrow-down-to-bracket",
        "arrow-down-to-dotted-line",
        "arrow-down-to-line",
        "arrow-down-to-square",
        "arrow-down-triangle-square",
        "arrow-down-up-across-line",
        "arrow-down-up-lock",
        "arrow-down-wide-short",
        "arrow-down-z-a",
        "arrow-left",
        "arrow-left-from-arc",
        "arrow-left-from-line",
        "arrow-left-long",
        "arrow-left-long-to-line",
        "arrow-left-to-arc",
        "arrow-left-to-line",
        "arrow-pointer",
        "arrow-progress",
        "arrow-right",
        "arrow-right-arrow-left",
        "arrow-right-from-arc",
        "arrow-right-from-bracket",
        "arrow-right-from-line",
        "arrow-right-long",
        "arrow-right-long-to-line",
        "arrow-right-to-arc",
        "arrow-right-to-bracket",
        "arrow-right-to-city",
        "arrow-right-to-line",
        "arrow-rotate-left",
        "arrow-rotate-right",
        "arrow-trend-down",
        "arrow-trend-up",
        "arrow-turn-down",
        "arrow-turn-down-left",
        "arrow-turn-down-right",
        "arrow-turn-up",
        "arrow-up",
        "arrow-up-1-9",
        "arrow-up-9-1",
        "arrow-up-a-z",
        "arrow-up-arrow-down",
        "arrow-up-big-small",
        "arrow-up-from-arc",
        "arrow-up-from-bracket",
        "arrow-up-from-dotted-line",
        "arrow-up-from-ground-water",
        "arrow-up-from-line",
        "arrow-up-from-square",
        "arrow-up-from-water-pump",
        "arrow-up-left",
        "arrow-up-left-from-circle",
        "arrow-up-long",
        "arrow-up-right",
        "arrow-up-right-and-arrow-down-left-from-center",
        "arrow-up-right-dots",
        "arrow-up-right-from-square",
        "arrow-up-short-wide",
        "arrow-up-small-big",
        "arrow-up-square-triangle",
        "arrow-up-to-arc",
        "arrow-up-to-dotted-line",
        "arrow-up-to-line",
        "arrow-up-triangle-square",
        "arrow-up-wide-short",
        "arrow-up-z-a",
        "arrows-cross",
        "arrows-down-to-line",
        "arrows-down-to-people",
        "arrows-from-dotted-line",
        "arrows-from-line",
        "arrows-left-right",
        "arrows-left-right-to-line",
        "arrows-maximize",
        "arrows-minimize",
        "arrows-repeat",
        "arrows-repeat-1",
        "arrows-retweet",
        "arrows-rotate",
        "arrows-spin",
        "arrows-split-up-and-left",
        "arrows-to-circle",
        "arrows-to-dot",
        "arrows-to-dotted-line",
        "arrows-to-eye",
        "arrows-to-line",
        "arrows-turn-right",
        "arrows-turn-to-dots",
        "arrows-up-down",
        "arrows-up-down-left-right",
        "arrows-up-to-line",
        "artstation",
        "asterisk",
        "asymmetrik",
        "at",
        "atlassian",
        "atom",
        "atom-simple",
        "audible",
        "audio-description",
        "audio-description-slash",
        "austral-sign",
        "autoprefixer",
        "avianex",
        "aviato",
        "avocado",
        "award",
        "award-simple",
        "aws",
        "axe",
        "axe-battle",
        "b",
        "baby",
        "baby-carriage",
        "backpack",
        "backward",
        "backward-fast",
        "backward-step",
        "bacon",
        "bacteria",
        "bacterium",
        "badge",
        "badge-check",
        "badge-dollar",
        "badge-percent",
        "badge-sheriff",
        "badger-honey",
        "badminton",
        "bag-seedling",
        "bag-shopping",
        "bagel",
        "bags-shopping",
        "baguette",
        "bahai",
        "baht-sign",
        "ball-pile",
        "balloon",
        "balloons",
        "ballot",
        "ballot-check",
        "ban",
        "ban-bug",
        "ban-parking",
        "ban-smoking",
        "banana",
        "bandage",
        "bandcamp",
        "bangladeshi-taka-sign",
        "banjo",
        "barcode",
        "barcode-read",
        "barcode-scan",
        "bars",
        "bars-filter",
        "bars-progress",
        "bars-sort",
        "bars-staggered",
        "baseball",
        "baseball-bat-ball",
        "basket-shopping",
        "basket-shopping-simple",
        "basketball",
        "basketball-hoop",
        "bat",
        "bath",
        "battery-bolt",
        "battery-empty",
        "battery-exclamation",
        "battery-full",
        "battery-half",
        "battery-low",
        "battery-quarter",
        "battery-slash",
        "battery-three-quarters",
        "battle-net",
        "bed",
        "bed-bunk",
        "bed-empty",
        "bed-front",
        "bed-pulse",
        "bee",
        "beer-mug",
        "beer-mug-empty",
        "behance",
        "bell",
        "bell-concierge",
        "bell-exclamation",
        "bell-on",
        "bell-plus",
        "bell-school",
        "bell-school-slash",
        "bell-slash",
        "bells",
        "bench-tree",
        "bezier-curve",
        "bicycle",
        "bilibili",
        "billboard",
        "bimobject",
        "bin-bottles",
        "bin-bottles-recycle",
        "bin-recycle",
        "binary",
        "binary-circle-check",
        "binary-lock",
        "binary-slash",
        "binoculars",
        "biohazard",
        "bird",
        "bitbucket",
        "bitcoin",
        "bitcoin-sign",
        "bity",
        "black-tie",
        "blackberry",
        "blanket",
        "blanket-fire",
        "blender",
        "blender-phone",
        "blinds",
        "blinds-open",
        "blinds-raised",
        "block",
        "block-brick",
        "block-brick-fire",
        "block-question",
        "block-quote",
        "blog",
        "blogger",
        "blogger-b",
        "blueberries",
        "bluetooth",
        "bluetooth-b",
        "bold",
        "bolt",
        "bolt-auto",
        "bolt-lightning",
        "bolt-slash",
        "bomb",
        "bone",
        "bone-break",
        "bong",
        "book",
        "book-arrow-right",
        "book-arrow-up",
        "book-atlas",
        "book-bible",
        "book-blank",
        "book-bookmark",
        "book-circle-arrow-right",
        "book-circle-arrow-up",
        "book-copy",
        "book-font",
        "book-heart",
        "book-journal-whills",
        "book-medical",
        "book-open",
        "book-open-cover",
        "book-open-reader",
        "book-quran",
        "book-section",
        "book-skull",
        "book-sparkles",
        "book-tanakh",
        "book-user",
        "bookmark",
        "bookmark-slash",
        "books",
        "books-medical",
        "boombox",
        "boot",
        "boot-heeled",
        "booth-curtain",
        "bootstrap",
        "border-all",
        "border-bottom",
        "border-bottom-right",
        "border-center-h",
        "border-center-v",
        "border-inner",
        "border-left",
        "border-none",
        "border-outer",
        "border-right",
        "border-top",
        "border-top-left",
        "bore-hole",
        "bots",
        "bottle-droplet",
        "bottle-water",
        "bow-arrow",
        "bowl-chopsticks",
        "bowl-chopsticks-noodles",
        "bowl-food",
        "bowl-hot",
        "bowl-rice",
        "bowl-scoop",
        "bowl-scoops",
        "bowl-soft-serve",
        "bowl-spoon",
        "bowling-ball",
        "bowling-ball-pin",
        "bowling-pins",
        "box",
        "box-archive",
        "box-ballot",
        "box-check",
        "box-circle-check",
        "box-dollar",
        "box-heart",
        "box-open",
        "box-open-full",
        "box-taped",
        "box-tissue",
        "boxes-packing",
        "boxes-stacked",
        "boxing-glove",
        "bracket-curly",
        "bracket-curly-right",
        "bracket-round",
        "bracket-round-right",
        "bracket-square",
        "bracket-square-right",
        "brackets-curly",
        "brackets-round",
        "brackets-square",
        "braille",
        "brain",
        "brain-arrow-curved-right",
        "brain-circuit",
        "brake-warning",
        "brazilian-real-sign",
        "bread-loaf",
        "bread-slice",
        "bread-slice-butter",
        "bridge",
        "bridge-circle-check",
        "bridge-circle-exclamation",
        "bridge-circle-xmark",
        "bridge-lock",
        "bridge-suspension",
        "bridge-water",
        "briefcase",
        "briefcase-arrow-right",
        "briefcase-blank",
        "briefcase-medical",
        "brightness",
        "brightness-low",
        "bring-forward",
        "bring-front",
        "broccoli",
        "broom",
        "broom-ball",
        "broom-wide",
        "browser",
        "browsers",
        "brush",
        "btc",
        "bucket",
        "buffer",
        "bug",
        "bug-slash",
        "bugs",
        "building",
        "building-circle-arrow-right",
        "building-circle-check",
        "building-circle-exclamation",
        "building-circle-xmark",
        "building-columns",
        "building-flag",
        "building-lock",
        "building-ngo",
        "building-shield",
        "building-un",
        "building-user",
        "building-wheat",
        "buildings",
        "bullhorn",
        "bullseye",
        "bullseye-arrow",
        "bullseye-pointer",
        "buoy",
        "buoy-mooring",
        "burger",
        "burger-cheese",
        "burger-fries",
        "burger-glass",
        "burger-lettuce",
        "burger-soda",
        "buromobelexperte",
        "burrito",
        "burst",
        "bus",
        "bus-school",
        "bus-simple",
        "business-time",
        "butter",
        "buy-n-large",
        "buysellads",
        "c",
        "cabin",
        "cabinet-filing",
        "cable-car",
        "cactus",
        "cake-candles",
        "cake-slice",
        "calculator",
        "calculator-simple",
        "calendar",
        "calendar-arrow-down",
        "calendar-arrow-up",
        "calendar-check",
        "calendar-circle-exclamation",
        "calendar-circle-minus",
        "calendar-circle-plus",
        "calendar-circle-user",
        "calendar-clock",
        "calendar-day",
        "calendar-days",
        "calendar-exclamation",
        "calendar-heart",
        "calendar-image",
        "calendar-lines",
        "calendar-lines-pen",
        "calendar-minus",
        "calendar-pen",
        "calendar-plus",
        "calendar-range",
        "calendar-star",
        "calendar-users",
        "calendar-week",
        "calendar-xmark",
        "calendars",
        "camcorder",
        "camera",
        "camera-cctv",
        "camera-movie",
        "camera-polaroid",
        "camera-retro",
        "camera-rotate",
        "camera-security",
        "camera-slash",
        "camera-viewfinder",
        "camera-web",
        "camera-web-slash",
        "campfire",
        "campground",
        "can-food",
        "canadian-maple-leaf",
        "candle-holder",
        "candy",
        "candy-bar",
        "candy-cane",
        "candy-corn",
        "cannabis",
        "capsules",
        "car",
        "car-battery",
        "car-bolt",
        "car-building",
        "car-bump",
        "car-burst",
        "car-bus",
        "car-circle-bolt",
        "car-garage",
        "car-mirrors",
        "car-on",
        "car-rear",
        "car-side",
        "car-side-bolt",
        "car-tilt",
        "car-tunnel",
        "car-wash",
        "car-wrench",
        "caravan",
        "caravan-simple",
        "card-club",
        "card-diamond",
        "card-heart",
        "card-spade",
        "cards",
        "cards-blank",
        "caret-down",
        "caret-left",
        "caret-right",
        "caret-up",
        "carrot",
        "cars",
        "cart-arrow-down",
        "cart-arrow-up",
        "cart-circle-arrow-down",
        "cart-circle-arrow-up",
        "cart-circle-check",
        "cart-circle-exclamation",
        "cart-circle-plus",
        "cart-circle-xmark",
        "cart-flatbed",
        "cart-flatbed-boxes",
        "cart-flatbed-empty",
        "cart-flatbed-suitcase",
        "cart-minus",
        "cart-plus",
        "cart-shopping",
        "cart-shopping-fast",
        "cart-xmark",
        "cash-register",
        "cassette-betamax",
        "cassette-tape",
        "cassette-vhs",
        "castle",
        "cat",
        "cat-space",
        "cauldron",
        "cc-amazon-pay",
        "cc-amex",
        "cc-apple-pay",
        "cc-diners-club",
        "cc-discover",
        "cc-jcb",
        "cc-mastercard",
        "cc-paypal",
        "cc-stripe",
        "cc-visa",
        "cedi-sign",
        "cent-sign",
        "centercode",
        "centos",
        "certificate",
        "chair",
        "chair-office",
        "chalkboard",
        "chalkboard-user",
        "champagne-glass",
        "champagne-glasses",
        "charging-station",
        "chart-area",
        "chart-bar",
        "chart-bullet",
        "chart-candlestick",
        "chart-column",
        "chart-gantt",
        "chart-line",
        "chart-line-down",
        "chart-line-up",
        "chart-line-up-down",
        "chart-mixed",
        "chart-mixed-up-circle-currency",
        "chart-mixed-up-circle-dollar",
        "chart-network",
        "chart-pie",
        "chart-pie-simple",
        "chart-pie-simple-circle-currency",
        "chart-pie-simple-circle-dollar",
        "chart-pyramid",
        "chart-radar",
        "chart-scatter",
        "chart-scatter-3d",
        "chart-scatter-bubble",
        "chart-simple",
        "chart-simple-horizontal",
        "chart-tree-map",
        "chart-user",
        "chart-waterfall",
        "check",
        "check-double",
        "check-to-slot",
        "cheese",
        "cheese-swiss",
        "cherries",
        "chess",
        "chess-bishop",
        "chess-bishop-piece",
        "chess-board",
        "chess-clock",
        "chess-clock-flip",
        "chess-king",
        "chess-king-piece",
        "chess-knight",
        "chess-knight-piece",
        "chess-pawn",
        "chess-pawn-piece",
        "chess-queen",
        "chess-queen-piece",
        "chess-rook",
        "chess-rook-piece",
        "chestnut",
        "chevron-down",
        "chevron-left",
        "chevron-right",
        "chevron-up",
        "chevrons-down",
        "chevrons-left",
        "chevrons-right",
        "chevrons-up",
        "chf-sign",
        "child",
        "child-combatant",
        "child-dress",
        "child-reaching",
        "children",
        "chimney",
        "chopsticks",
        "chrome",
        "chromecast",
        "church",
        "circle",
        "circle-0",
        "circle-1",
        "circle-2",
        "circle-3",
        "circle-4",
        "circle-5",
        "circle-6",
        "circle-7",
        "circle-8",
        "circle-9",
        "circle-a",
        "circle-ampersand",
        "circle-arrow-down",
        "circle-arrow-down-left",
        "circle-arrow-down-right",
        "circle-arrow-left",
        "circle-arrow-right",
        "circle-arrow-up",
        "circle-arrow-up-left",
        "circle-arrow-up-right",
        "circle-b",
        "circle-bolt",
        "circle-book-open",
        "circle-bookmark",
        "circle-c",
        "circle-calendar",
        "circle-camera",
        "circle-caret-down",
        "circle-caret-left",
        "circle-caret-right",
        "circle-caret-up",
        "circle-check",
        "circle-chevron-down",
        "circle-chevron-left",
        "circle-chevron-right",
        "circle-chevron-up",
        "circle-d",
        "circle-dashed",
        "circle-divide",
        "circle-dollar",
        "circle-dollar-to-slot",
        "circle-dot",
        "circle-down",
        "circle-down-left",
        "circle-down-right",
        "circle-e",
        "circle-ellipsis",
        "circle-ellipsis-vertical",
        "circle-envelope",
        "circle-euro",
        "circle-exclamation",
        "circle-exclamation-check",
        "circle-f",
        "circle-g",
        "circle-h",
        "circle-half",
        "circle-half-stroke",
        "circle-heart",
        "circle-i",
        "circle-info",
        "circle-j",
        "circle-k",
        "circle-l",
        "circle-left",
        "circle-location-arrow",
        "circle-m",
        "circle-microphone",
        "circle-microphone-lines",
        "circle-minus",
        "circle-n",
        "circle-nodes",
        "circle-notch",
        "circle-o",
        "circle-p",
        "circle-parking",
        "circle-pause",
        "circle-phone",
        "circle-phone-flip",
        "circle-phone-hangup",
        "circle-play",
        "circle-plus",
        "circle-q",
        "circle-quarter",
        "circle-quarter-stroke",
        "circle-quarters",
        "circle-question",
        "circle-r",
        "circle-radiation",
        "circle-right",
        "circle-s",
        "circle-small",
        "circle-sort",
        "circle-sort-down",
        "circle-sort-up",
        "circle-star",
        "circle-sterling",
        "circle-stop",
        "circle-t",
        "circle-three-quarters",
        "circle-three-quarters-stroke",
        "circle-trash",
        "circle-u",
        "circle-up",
        "circle-up-left",
        "circle-up-right",
        "circle-user",
        "circle-v",
        "circle-video",
        "circle-w",
        "circle-waveform-lines",
        "circle-x",
        "circle-xmark",
        "circle-y",
        "circle-yen",
        "circle-z",
        "circles-overlap",
        "citrus",
        "citrus-slice",
        "city",
        "clapperboard",
        "clapperboard-play",
        "clarinet",
        "claw-marks",
        "clipboard",
        "clipboard-check",
        "clipboard-list",
        "clipboard-list-check",
        "clipboard-medical",
        "clipboard-prescription",
        "clipboard-question",
        "clipboard-user",
        "clock",
        "clock-desk",
        "clock-eight",
        "clock-eight-thirty",
        "clock-eleven",
        "clock-eleven-thirty",
        "clock-five",
        "clock-five-thirty",
        "clock-four-thirty",
        "clock-nine",
        "clock-nine-thirty",
        "clock-one",
        "clock-one-thirty",
        "clock-rotate-left",
        "clock-seven",
        "clock-seven-thirty",
        "clock-six",
        "clock-six-thirty",
        "clock-ten",
        "clock-ten-thirty",
        "clock-three",
        "clock-three-thirty",
        "clock-twelve",
        "clock-twelve-thirty",
        "clock-two",
        "clock-two-thirty",
        "clone",
        "closed-captioning",
        "closed-captioning-slash",
        "clothes-hanger",
        "cloud",
        "cloud-arrow-down",
        "cloud-arrow-up",
        "cloud-binary",
        "cloud-bolt",
        "cloud-bolt-moon",
        "cloud-bolt-sun",
        "cloud-check",
        "cloud-drizzle",
        "cloud-exclamation",
        "cloud-fog",
        "cloud-hail",
        "cloud-hail-mixed",
        "cloud-meatball",
        "cloud-minus",
        "cloud-moon",
        "cloud-moon-rain",
        "cloud-music",
        "cloud-plus",
        "cloud-question",
        "cloud-rain",
        "cloud-rainbow",
        "cloud-showers",
        "cloud-showers-heavy",
        "cloud-showers-water",
        "cloud-slash",
        "cloud-sleet",
        "cloud-snow",
        "cloud-sun",
        "cloud-sun-rain",
        "cloud-word",
        "cloud-xmark",
        "cloudflare",
        "clouds",
        "clouds-moon",
        "clouds-sun",
        "cloudscale",
        "cloudsmith",
        "cloudversify",
        "clover",
        "club",
        "cmplid",
        "coconut",
        "code",
        "code-branch",
        "code-commit",
        "code-compare",
        "code-fork",
        "code-merge",
        "code-pull-request",
        "code-pull-request-closed",
        "code-pull-request-draft",
        "code-simple",
        "codepen",
        "codiepie",
        "coffee-bean",
        "coffee-beans",
        "coffee-pot",
        "coffin",
        "coffin-cross",
        "coin",
        "coin-blank",
        "coin-front",
        "coin-vertical",
        "coins",
        "colon",
        "colon-sign",
        "columns-3",
        "comet",
        "comma",
        "command",
        "comment",
        "comment-arrow-down",
        "comment-arrow-up",
        "comment-arrow-up-right",
        "comment-captions",
        "comment-check",
        "comment-code",
        "comment-dollar",
        "comment-dots",
        "comment-exclamation",
        "comment-heart",
        "comment-image",
        "comment-lines",
        "comment-medical",
        "comment-middle",
        "comment-middle-top",
        "comment-minus",
        "comment-music",
        "comment-pen",
        "comment-plus",
        "comment-question",
        "comment-quote",
        "comment-slash",
        "comment-smile",
        "comment-sms",
        "comment-text",
        "comment-xmark",
        "comments",
        "comments-dollar",
        "comments-question",
        "comments-question-check",
        "compact-disc",
        "compass",
        "compass-drafting",
        "compass-slash",
        "compress",
        "compress-wide",
        "computer",
        "computer-classic",
        "computer-mouse",
        "computer-mouse-scrollwheel",
        "computer-speaker",
        "confluence",
        "connectdevelop",
        "container-storage",
        "contao",
        "conveyor-belt",
        "conveyor-belt-arm",
        "conveyor-belt-boxes",
        "conveyor-belt-empty",
        "cookie",
        "cookie-bite",
        "copy",
        "copyright",
        "corn",
        "corner",
        "cotton-bureau",
        "couch",
        "cow",
        "cowbell",
        "cowbell-circle-plus",
        "cpanel",
        "crab",
        "crate-apple",
        "crate-empty",
        "creative-commons",
        "creative-commons-by",
        "creative-commons-nc",
        "creative-commons-nc-eu",
        "creative-commons-nc-jp",
        "creative-commons-nd",
        "creative-commons-pd",
        "creative-commons-pd-alt",
        "creative-commons-remix",
        "creative-commons-sa",
        "creative-commons-sampling",
        "creative-commons-sampling-plus",
        "creative-commons-share",
        "creative-commons-zero",
        "credit-card",
        "credit-card-blank",
        "credit-card-front",
        "cricket-bat-ball",
        "critical-role",
        "croissant",
        "crop",
        "crop-simple",
        "cross",
        "crosshairs",
        "crosshairs-simple",
        "crow",
        "crown",
        "crutch",
        "crutches",
        "cruzeiro-sign",
        "crystal-ball",
        "css3",
        "css3-alt",
        "cube",
        "cubes",
        "cubes-stacked",
        "cucumber",
        "cup-straw",
        "cup-straw-swoosh",
        "cup-togo",
        "cupcake",
        "curling-stone",
        "custard",
        "cuttlefish",
        "d",
        "d-and-d",
        "d-and-d-beyond",
        "dagger",
        "dailymotion",
        "dash",
        "dashcube",
        "database",
        "debian",
        "deer",
        "deer-rudolph",
        "deezer",
        "delete-left",
        "delete-right",
        "delicious",
        "democrat",
        "deploydog",
        "deskpro",
        "desktop",
        "desktop-arrow-down",
        "dev",
        "deviantart",
        "dharmachakra",
        "dhl",
        "diagram-cells",
        "diagram-lean-canvas",
        "diagram-nested",
        "diagram-next",
        "diagram-predecessor",
        "diagram-previous",
        "diagram-project",
        "diagram-sankey",
        "diagram-subtask",
        "diagram-successor",
        "diagram-venn",
        "dial",
        "dial-high",
        "dial-low",
        "dial-max",
        "dial-med",
        "dial-med-low",
        "dial-min",
        "dial-off",
        "diamond",
        "diamond-exclamation",
        "diamond-half",
        "diamond-half-stroke",
        "diamond-turn-right",
        "diaspora",
        "dice",
        "dice-d10",
        "dice-d12",
        "dice-d20",
        "dice-d4",
        "dice-d6",
        "dice-d8",
        "dice-five",
        "dice-four",
        "dice-one",
        "dice-six",
        "dice-three",
        "dice-two",
        "digg",
        "digital-ocean",
        "dinosaur",
        "diploma",
        "disc-drive",
        "discord",
        "discourse",
        "disease",
        "display",
        "display-arrow-down",
        "display-chart-up",
        "display-chart-up-circle-currency",
        "display-chart-up-circle-dollar",
        "display-code",
        "display-medical",
        "display-slash",
        "distribute-spacing-horizontal",
        "distribute-spacing-vertical",
        "ditto",
        "divide",
        "dna",
        "do-not-enter",
        "dochub",
        "docker",
        "dog",
        "dog-leashed",
        "dollar-sign",
        "dolly",
        "dolly-empty",
        "dolphin",
        "dong-sign",
        "donut",
        "door-closed",
        "door-open",
        "dove",
        "down",
        "down-from-dotted-line",
        "down-from-line",
        "down-left",
        "down-left-and-up-right-to-center",
        "down-long",
        "down-right",
        "down-to-bracket",
        "down-to-dotted-line",
        "down-to-line",
        "download",
        "draft2digital",
        "dragon",
        "draw-circle",
        "draw-polygon",
        "draw-square",
        "dreidel",
        "dribbble",
        "drone",
        "drone-front",
        "dropbox",
        "droplet",
        "droplet-degree",
        "droplet-percent",
        "droplet-slash",
        "drum",
        "drum-steelpan",
        "drumstick",
        "drumstick-bite",
        "drupal",
        "dryer",
        "dryer-heat",
        "duck",
        "dumbbell",
        "dumpster",
        "dumpster-fire",
        "dungeon",
        "dyalog",
        "e",
        "ear",
        "ear-deaf",
        "ear-listen",
        "ear-muffs",
        "earlybirds",
        "earth-africa",
        "earth-americas",
        "earth-asia",
        "earth-europe",
        "earth-oceania",
        "ebay",
        "eclipse",
        "edge",
        "edge-legacy",
        "egg",
        "egg-fried",
        "eggplant",
        "eject",
        "elementor",
        "elephant",
        "elevator",
        "ellipsis",
        "ellipsis-stroke",
        "ellipsis-stroke-vertical",
        "ellipsis-vertical",
        "ello",
        "ember",
        "empire",
        "empty-set",
        "engine",
        "engine-warning",
        "envelope",
        "envelope-circle-check",
        "envelope-dot",
        "envelope-open",
        "envelope-open-dollar",
        "envelope-open-text",
        "envelopes",
        "envelopes-bulk",
        "envira",
        "equals",
        "eraser",
        "erlang",
        "escalator",
        "ethereum",
        "ethernet",
        "etsy",
        "euro-sign",
        "evernote",
        "exclamation",
        "expand",
        "expand-wide",
        "expeditedssl",
        "explosion",
        "eye",
        "eye-dropper",
        "eye-dropper-full",
        "eye-dropper-half",
        "eye-evil",
        "eye-low-vision",
        "eye-slash",
        "eyes",
        "f",
        "face-angry",
        "face-angry-horns",
        "face-anguished",
        "face-anxious-sweat",
        "face-astonished",
        "face-awesome",
        "face-beam-hand-over-mouth",
        "face-clouds",
        "face-confounded",
        "face-confused",
        "face-cowboy-hat",
        "face-diagonal-mouth",
        "face-disappointed",
        "face-disguise",
        "face-dizzy",
        "face-dotted",
        "face-downcast-sweat",
        "face-drooling",
        "face-exhaling",
        "face-explode",
        "face-expressionless",
        "face-eyes-xmarks",
        "face-fearful",
        "face-flushed",
        "face-frown",
        "face-frown-open",
        "face-frown-slight",
        "face-glasses",
        "face-grimace",
        "face-grin",
        "face-grin-beam",
        "face-grin-beam-sweat",
        "face-grin-hearts",
        "face-grin-squint",
        "face-grin-squint-tears",
        "face-grin-stars",
        "face-grin-tears",
        "face-grin-tongue",
        "face-grin-tongue-squint",
        "face-grin-tongue-wink",
        "face-grin-wide",
        "face-grin-wink",
        "face-hand-over-mouth",
        "face-hand-peeking",
        "face-hand-yawn",
        "face-head-bandage",
        "face-holding-back-tears",
        "face-hushed",
        "face-icicles",
        "face-kiss",
        "face-kiss-beam",
        "face-kiss-closed-eyes",
        "face-kiss-wink-heart",
        "face-laugh",
        "face-laugh-beam",
        "face-laugh-squint",
        "face-laugh-wink",
        "face-lying",
        "face-mask",
        "face-meh",
        "face-meh-blank",
        "face-melting",
        "face-monocle",
        "face-nauseated",
        "face-nose-steam",
        "face-party",
        "face-pensive",
        "face-persevering",
        "face-pleading",
        "face-pouting",
        "face-raised-eyebrow",
        "face-relieved",
        "face-rolling-eyes",
        "face-sad-cry",
        "face-sad-sweat",
        "face-sad-tear",
        "face-saluting",
        "face-scream",
        "face-shush",
        "face-sleeping",
        "face-sleepy",
        "face-smile",
        "face-smile-beam",
        "face-smile-halo",
        "face-smile-hearts",
        "face-smile-horns",
        "face-smile-plus",
        "face-smile-relaxed",
        "face-smile-tear",
        "face-smile-tongue",
        "face-smile-upside-down",
        "face-smile-wink",
        "face-smiling-hands",
        "face-smirking",
        "face-spiral-eyes",
        "face-sunglasses",
        "face-surprise",
        "face-swear",
        "face-thermometer",
        "face-thinking",
        "face-tired",
        "face-tissue",
        "face-tongue-money",
        "face-tongue-sweat",
        "face-unamused",
        "face-viewfinder",
        "face-vomit",
        "face-weary",
        "face-woozy",
        "face-worried",
        "face-zany",
        "face-zipper",
        "facebook",
        "facebook-f",
        "facebook-messenger",
        "falafel",
        "family",
        "family-dress",
        "family-pants",
        "fan",
        "fan-table",
        "fantasy-flight-games",
        "farm",
        "faucet",
        "faucet-drip",
        "fax",
        "feather",
        "feather-pointed",
        "fedex",
        "fedora",
        "fence",
        "ferris-wheel",
        "ferry",
        "field-hockey-stick-ball",
        "figma",
        "file",
        "file-arrow-down",
        "file-arrow-up",
        "file-audio",
        "file-binary",
        "file-certificate",
        "file-chart-column",
        "file-chart-pie",
        "file-check",
        "file-circle-check",
        "file-circle-exclamation",
        "file-circle-info",
        "file-circle-minus",
        "file-circle-plus",
        "file-circle-question",
        "file-circle-xmark",
        "file-code",
        "file-contract",
        "file-csv",
        "file-dashed-line",
        "file-doc",
        "file-excel",
        "file-exclamation",
        "file-export",
        "file-heart",
        "file-image",
        "file-import",
        "file-invoice",
        "file-invoice-dollar",
        "file-lines",
        "file-lock",
        "file-magnifying-glass",
        "file-medical",
        "file-minus",
        "file-music",
        "file-pdf",
        "file-pen",
        "file-plus",
        "file-plus-minus",
        "file-powerpoint",
        "file-prescription",
        "file-shield",
        "file-signature",
        "file-slash",
        "file-spreadsheet",
        "file-user",
        "file-video",
        "file-waveform",
        "file-word",
        "file-xmark",
        "file-zip",
        "file-zipper",
        "files",
        "files-medical",
        "fill",
        "fill-drip",
        "film",
        "film-canister",
        "film-simple",
        "film-slash",
        "films",
        "filter",
        "filter-circle-dollar",
        "filter-circle-xmark",
        "filter-list",
        "filter-slash",
        "filters",
        "fingerprint",
        "fire",
        "fire-burner",
        "fire-extinguisher",
        "fire-flame",
        "fire-flame-curved",
        "fire-flame-simple",
        "fire-hydrant",
        "fire-smoke",
        "firefox",
        "firefox-browser",
        "fireplace",
        "first-order",
        "first-order-alt",
        "firstdraft",
        "fish",
        "fish-bones",
        "fish-cooked",
        "fish-fins",
        "fishing-rod",
        "flag",
        "flag-checkered",
        "flag-pennant",
        "flag-swallowtail",
        "flag-usa",
        "flashlight",
        "flask",
        "flask-gear",
        "flask-round-poison",
        "flask-round-potion",
        "flask-vial",
        "flatbread",
        "flatbread-stuffed",
        "flickr",
        "flipboard",
        "floppy-disk",
        "floppy-disk-circle-arrow-right",
        "floppy-disk-circle-xmark",
        "floppy-disk-pen",
        "floppy-disks",
        "florin-sign",
        "flower",
        "flower-daffodil",
        "flower-tulip",
        "flute",
        "flux-capacitor",
        "fly",
        "flying-disc",
        "folder",
        "folder-arrow-down",
        "folder-arrow-up",
        "folder-bookmark",
        "folder-closed",
        "folder-gear",
        "folder-grid",
        "folder-heart",
        "folder-image",
        "folder-magnifying-glass",
        "folder-medical",
        "folder-minus",
        "folder-music",
        "folder-open",
        "folder-plus",
        "folder-tree",
        "folder-user",
        "folder-xmark",
        "folders",
        "fondue-pot",
        "font",
        "font-awesome",
        "font-case",
        "fonticons",
        "fonticons-fi",
        "football",
        "football-helmet",
        "fork",
        "fork-knife",
        "forklift",
        "fort",
        "fort-awesome",
        "fort-awesome-alt",
        "forumbee",
        "forward",
        "forward-fast",
        "forward-step",
        "foursquare",
        "frame",
        "franc-sign",
        "free-code-camp",
        "freebsd",
        "french-fries",
        "frog",
        "fulcrum",
        "function",
        "futbol",
        "g",
        "galactic-republic",
        "galactic-senate",
        "galaxy",
        "gallery-thumbnails",
        "game-board",
        "game-board-simple",
        "game-console-handheld",
        "game-console-handheld-crank",
        "gamepad",
        "gamepad-modern",
        "garage",
        "garage-car",
        "garage-open",
        "garlic",
        "gas-pump",
        "gas-pump-slash",
        "gauge",
        "gauge-circle-bolt",
        "gauge-circle-minus",
        "gauge-circle-plus",
        "gauge-high",
        "gauge-low",
        "gauge-max",
        "gauge-min",
        "gauge-simple",
        "gauge-simple-high",
        "gauge-simple-low",
        "gauge-simple-max",
        "gauge-simple-min",
        "gavel",
        "gear",
        "gear-code",
        "gear-complex",
        "gear-complex-code",
        "gears",
        "gem",
        "genderless",
        "get-pocket",
        "gg",
        "gg-circle",
        "ghost",
        "gif",
        "gift",
        "gift-card",
        "gifts",
        "gingerbread-man",
        "git",
        "git-alt",
        "github",
        "github-alt",
        "gitkraken",
        "gitlab",
        "gitter",
        "glass",
        "glass-citrus",
        "glass-empty",
        "glass-half",
        "glass-water",
        "glass-water-droplet",
        "glasses",
        "glasses-round",
        "glide",
        "glide-g",
        "globe",
        "globe-pointer",
        "globe-snow",
        "globe-stand",
        "goal-net",
        "gofore",
        "golang",
        "golf-ball-tee",
        "golf-club",
        "golf-flag-hole",
        "goodreads",
        "goodreads-g",
        "google",
        "google-drive",
        "google-pay",
        "google-play",
        "google-plus",
        "google-plus-g",
        "google-wallet",
        "gopuram",
        "graduation-cap",
        "gramophone",
        "grapes",
        "grate",
        "grate-droplet",
        "gratipay",
        "grav",
        "greater-than",
        "greater-than-equal",
        "grid",
        "grid-2",
        "grid-2-plus",
        "grid-4",
        "grid-5",
        "grid-dividers",
        "grid-horizontal",
        "grid-round",
        "grid-round-2",
        "grid-round-2-plus",
        "grid-round-4",
        "grid-round-5",
        "grill",
        "grill-fire",
        "grill-hot",
        "grip",
        "grip-dots",
        "grip-dots-vertical",
        "grip-lines",
        "grip-lines-vertical",
        "grip-vertical",
        "gripfire",
        "group-arrows-rotate",
        "grunt",
        "guarani-sign",
        "guilded",
        "guitar",
        "guitar-electric",
        "guitars",
        "gulp",
        "gun",
        "gun-slash",
        "gun-squirt",
        "h",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hacker-news",
        "hackerrank",
        "hammer",
        "hammer-crash",
        "hammer-war",
        "hamsa",
        "hand",
        "hand-back-fist",
        "hand-back-point-down",
        "hand-back-point-left",
        "hand-back-point-ribbon",
        "hand-back-point-right",
        "hand-back-point-up",
        "hand-dots",
        "hand-fingers-crossed",
        "hand-fist",
        "hand-heart",
        "hand-holding",
        "hand-holding-box",
        "hand-holding-dollar",
        "hand-holding-droplet",
        "hand-holding-hand",
        "hand-holding-heart",
        "hand-holding-magic",
        "hand-holding-medical",
        "hand-holding-seedling",
        "hand-holding-skull",
        "hand-horns",
        "hand-lizard",
        "hand-love",
        "hand-middle-finger",
        "hand-peace",
        "hand-point-down",
        "hand-point-left",
        "hand-point-ribbon",
        "hand-point-right",
        "hand-point-up",
        "hand-pointer",
        "hand-scissors",
        "hand-sparkles",
        "hand-spock",
        "hand-wave",
        "handcuffs",
        "hands",
        "hands-asl-interpreting",
        "hands-bound",
        "hands-bubbles",
        "hands-clapping",
        "hands-holding",
        "hands-holding-child",
        "hands-holding-circle",
        "hands-holding-diamond",
        "hands-holding-dollar",
        "hands-holding-heart",
        "hands-praying",
        "handshake",
        "handshake-angle",
        "handshake-simple",
        "handshake-simple-slash",
        "handshake-slash",
        "hanukiah",
        "hard-drive",
        "hashnode",
        "hashtag",
        "hashtag-lock",
        "hat-beach",
        "hat-chef",
        "hat-cowboy",
        "hat-cowboy-side",
        "hat-santa",
        "hat-winter",
        "hat-witch",
        "hat-wizard",
        "head-side",
        "head-side-brain",
        "head-side-cough",
        "head-side-cough-slash",
        "head-side-gear",
        "head-side-goggles",
        "head-side-headphones",
        "head-side-heart",
        "head-side-mask",
        "head-side-medical",
        "head-side-virus",
        "heading",
        "headphones",
        "headphones-simple",
        "headset",
        "heart",
        "heart-circle-bolt",
        "heart-circle-check",
        "heart-circle-exclamation",
        "heart-circle-minus",
        "heart-circle-plus",
        "heart-circle-xmark",
        "heart-crack",
        "heart-half",
        "heart-half-stroke",
        "heart-pulse",
        "heat",
        "helicopter",
        "helicopter-symbol",
        "helmet-battle",
        "helmet-safety",
        "helmet-un",
        "hexagon",
        "hexagon-check",
        "hexagon-divide",
        "hexagon-exclamation",
        "hexagon-image",
        "hexagon-minus",
        "hexagon-plus",
        "hexagon-vertical-nft",
        "hexagon-vertical-nft-slanted",
        "hexagon-xmark",
        "high-definition",
        "highlighter",
        "highlighter-line",
        "hill-avalanche",
        "hill-rockslide",
        "hippo",
        "hips",
        "hire-a-helper",
        "hive",
        "hockey-mask",
        "hockey-puck",
        "hockey-stick-puck",
        "hockey-sticks",
        "holly-berry",
        "honey-pot",
        "hood-cloak",
        "hooli",
        "horizontal-rule",
        "hornbill",
        "horse",
        "horse-head",
        "horse-saddle",
        "hose",
        "hose-reel",
        "hospital",
        "hospital-user",
        "hospitals",
        "hot-tub-person",
        "hotdog",
        "hotel",
        "hotjar",
        "hourglass",
        "hourglass-clock",
        "hourglass-end",
        "hourglass-half",
        "hourglass-start",
        "house",
        "house-blank",
        "house-building",
        "house-chimney",
        "house-chimney-blank",
        "house-chimney-crack",
        "house-chimney-heart",
        "house-chimney-medical",
        "house-chimney-user",
        "house-chimney-window",
        "house-circle-check",
        "house-circle-exclamation",
        "house-circle-xmark",
        "house-crack",
        "house-day",
        "house-fire",
        "house-flag",
        "house-flood-water",
        "house-flood-water-circle-arrow-right",
        "house-heart",
        "house-laptop",
        "house-lock",
        "house-medical",
        "house-medical-circle-check",
        "house-medical-circle-exclamation",
        "house-medical-circle-xmark",
        "house-medical-flag",
        "house-night",
        "house-person-leave",
        "house-person-return",
        "house-signal",
        "house-tree",
        "house-tsunami",
        "house-turret",
        "house-user",
        "house-water",
        "house-window",
        "houzz",
        "hryvnia-sign",
        "html5",
        "hubspot",
        "hundred-points",
        "hurricane",
        "hyphen",
        "i",
        "i-cursor",
        "ice-cream",
        "ice-skate",
        "icicles",
        "icons",
        "id-badge",
        "id-card",
        "id-card-clip",
        "ideal",
        "igloo",
        "image",
        "image-landscape",
        "image-polaroid",
        "image-polaroid-user",
        "image-portrait",
        "image-slash",
        "image-user",
        "images",
        "images-user",
        "imdb",
        "inbox",
        "inbox-full",
        "inbox-in",
        "inbox-out",
        "inboxes",
        "indent",
        "indian-rupee-sign",
        "industry",
        "industry-windows",
        "infinity",
        "info",
        "inhaler",
        "input-numeric",
        "input-pipe",
        "input-text",
        "instagram",
        "instalod",
        "integral",
        "intercom",
        "internet-explorer",
        "interrobang",
        "intersection",
        "invision",
        "ioxhost",
        "island-tropical",
        "italic",
        "itch-io",
        "itunes",
        "itunes-note",
        "j",
        "jack-o-lantern",
        "jar",
        "jar-wheat",
        "java",
        "jedi",
        "jedi-order",
        "jenkins",
        "jet-fighter",
        "jet-fighter-up",
        "jira",
        "joget",
        "joint",
        "joomla",
        "joystick",
        "js",
        "jsfiddle",
        "jug",
        "jug-bottle",
        "jug-detergent",
        "k",
        "kaaba",
        "kaggle",
        "kazoo",
        "kerning",
        "key",
        "key-skeleton",
        "key-skeleton-left-right",
        "keybase",
        "keyboard",
        "keyboard-brightness",
        "keyboard-brightness-low",
        "keyboard-down",
        "keyboard-left",
        "keycdn",
        "keynote",
        "khanda",
        "kickstarter",
        "kickstarter-k",
        "kidneys",
        "kip-sign",
        "kit-medical",
        "kitchen-set",
        "kite",
        "kiwi-bird",
        "kiwi-fruit",
        "knife",
        "knife-kitchen",
        "korvue",
        "l",
        "lacrosse-stick",
        "lacrosse-stick-ball",
        "lambda",
        "lamp",
        "lamp-desk",
        "lamp-floor",
        "lamp-street",
        "land-mine-on",
        "landmark",
        "landmark-dome",
        "landmark-flag",
        "language",
        "laptop",
        "laptop-arrow-down",
        "laptop-binary",
        "laptop-code",
        "laptop-file",
        "laptop-medical",
        "laptop-mobile",
        "laptop-slash",
        "laravel",
        "lari-sign",
        "lasso",
        "lasso-sparkles",
        "lastfm",
        "layer-group",
        "layer-minus",
        "layer-plus",
        "leaf",
        "leaf-heart",
        "leaf-maple",
        "leaf-oak",
        "leafy-green",
        "leanpub",
        "left",
        "left-from-line",
        "left-long",
        "left-long-to-line",
        "left-right",
        "left-to-line",
        "lemon",
        "less",
        "less-than",
        "less-than-equal",
        "life-ring",
        "light-ceiling",
        "light-emergency",
        "light-emergency-on",
        "light-switch",
        "light-switch-off",
        "light-switch-on",
        "lightbulb",
        "lightbulb-cfl",
        "lightbulb-cfl-on",
        "lightbulb-dollar",
        "lightbulb-exclamation",
        "lightbulb-exclamation-on",
        "lightbulb-gear",
        "lightbulb-on",
        "lightbulb-slash",
        "lighthouse",
        "lights-holiday",
        "line",
        "line-columns",
        "line-height",
        "lines-leaning",
        "link",
        "link-horizontal",
        "link-horizontal-slash",
        "link-simple",
        "link-simple-slash",
        "link-slash",
        "linkedin",
        "linkedin-in",
        "linode",
        "linux",
        "lips",
        "lira-sign",
        "list",
        "list-check",
        "list-dropdown",
        "list-music",
        "list-ol",
        "list-radio",
        "list-timeline",
        "list-tree",
        "list-ul",
        "litecoin-sign",
        "loader",
        "lobster",
        "location-arrow",
        "location-check",
        "location-crosshairs",
        "location-crosshairs-slash",
        "location-dot",
        "location-dot-slash",
        "location-exclamation",
        "location-minus",
        "location-pen",
        "location-pin",
        "location-pin-lock",
        "location-pin-slash",
        "location-plus",
        "location-question",
        "location-smile",
        "location-xmark",
        "lock",
        "lock-a",
        "lock-hashtag",
        "lock-keyhole",
        "lock-keyhole-open",
        "lock-open",
        "locust",
        "lollipop",
        "loveseat",
        "luchador-mask",
        "lungs",
        "lungs-virus",
        "lyft",
        "m",
        "mace",
        "magento",
        "magnet",
        "magnifying-glass",
        "magnifying-glass-arrow-right",
        "magnifying-glass-chart",
        "magnifying-glass-dollar",
        "magnifying-glass-location",
        "magnifying-glass-minus",
        "magnifying-glass-plus",
        "mailbox",
        "mailbox-flag-up",
        "mailchimp",
        "manat-sign",
        "mandalorian",
        "mandolin",
        "mango",
        "manhole",
        "map",
        "map-location",
        "map-location-dot",
        "map-pin",
        "markdown",
        "marker",
        "mars",
        "mars-and-venus",
        "mars-and-venus-burst",
        "mars-double",
        "mars-stroke",
        "mars-stroke-right",
        "mars-stroke-up",
        "martini-glass",
        "martini-glass-citrus",
        "martini-glass-empty",
        "mask",
        "mask-face",
        "mask-snorkel",
        "mask-ventilator",
        "masks-theater",
        "mastodon",
        "mattress-pillow",
        "maxcdn",
        "maximize",
        "mdb",
        "meat",
        "medal",
        "medapps",
        "medium",
        "medrt",
        "meetup",
        "megaphone",
        "megaport",
        "melon",
        "melon-slice",
        "memo",
        "memo-circle-check",
        "memo-circle-info",
        "memo-pad",
        "memory",
        "mendeley",
        "menorah",
        "mercury",
        "merge",
        "message",
        "message-arrow-down",
        "message-arrow-up",
        "message-arrow-up-right",
        "message-bot",
        "message-captions",
        "message-check",
        "message-code",
        "message-dollar",
        "message-dots",
        "message-exclamation",
        "message-heart",
        "message-image",
        "message-lines",
        "message-medical",
        "message-middle",
        "message-middle-top",
        "message-minus",
        "message-music",
        "message-pen",
        "message-plus",
        "message-question",
        "message-quote",
        "message-slash",
        "message-smile",
        "message-sms",
        "message-text",
        "message-xmark",
        "messages",
        "messages-dollar",
        "messages-question",
        "meta",
        "meteor",
        "meter",
        "meter-bolt",
        "meter-droplet",
        "meter-fire",
        "microblog",
        "microchip",
        "microchip-ai",
        "microphone",
        "microphone-lines",
        "microphone-lines-slash",
        "microphone-slash",
        "microphone-stand",
        "microscope",
        "microsoft",
        "microwave",
        "mill-sign",
        "minimize",
        "minus",
        "mistletoe",
        "mitten",
        "mix",
        "mixcloud",
        "mixer",
        "mizuni",
        "mobile",
        "mobile-button",
        "mobile-notch",
        "mobile-retro",
        "mobile-screen",
        "mobile-screen-button",
        "mobile-signal",
        "mobile-signal-out",
        "modx",
        "monero",
        "money-bill",
        "money-bill-1",
        "money-bill-1-wave",
        "money-bill-simple",
        "money-bill-simple-wave",
        "money-bill-transfer",
        "money-bill-trend-up",
        "money-bill-wave",
        "money-bill-wheat",
        "money-bills",
        "money-bills-simple",
        "money-check",
        "money-check-dollar",
        "money-check-dollar-pen",
        "money-check-pen",
        "money-from-bracket",
        "money-simple-from-bracket",
        "monitor-waveform",
        "monkey",
        "monument",
        "moon",
        "moon-cloud",
        "moon-over-sun",
        "moon-stars",
        "moped",
        "mortar-pestle",
        "mosque",
        "mosquito",
        "mosquito-net",
        "motorcycle",
        "mound",
        "mountain",
        "mountain-city",
        "mountain-sun",
        "mountains",
        "mouse-field",
        "mp3-player",
        "mug",
        "mug-hot",
        "mug-marshmallows",
        "mug-saucer",
        "mug-tea",
        "mug-tea-saucer",
        "mushroom",
        "music",
        "music-note",
        "music-note-slash",
        "music-slash",
        "mustache",
        "n",
        "naira-sign",
        "napster",
        "narwhal",
        "neos",
        "nesting-dolls",
        "network-wired",
        "neuter",
        "newspaper",
        "nfc",
        "nfc-directional",
        "nfc-lock",
        "nfc-magnifying-glass",
        "nfc-pen",
        "nfc-signal",
        "nfc-slash",
        "nfc-symbol",
        "nfc-trash",
        "nimblr",
        "node",
        "node-js",
        "nose",
        "not-equal",
        "notdef",
        "note",
        "note-medical",
        "note-sticky",
        "notebook",
        "notes",
        "notes-medical",
        "npm",
        "ns8",
        "nutritionix",
        "o",
        "object-exclude",
        "object-group",
        "object-intersect",
        "object-subtract",
        "object-ungroup",
        "object-union",
        "objects-align-bottom",
        "objects-align-center-horizontal",
        "objects-align-center-vertical",
        "objects-align-left",
        "objects-align-right",
        "objects-align-top",
        "objects-column",
        "octagon",
        "octagon-check",
        "octagon-divide",
        "octagon-exclamation",
        "octagon-minus",
        "octagon-plus",
        "octagon-xmark",
        "octopus-deploy",
        "odnoklassniki",
        "odysee",
        "oil-can",
        "oil-can-drip",
        "oil-temperature",
        "oil-well",
        "old-republic",
        "olive",
        "olive-branch",
        "om",
        "omega",
        "onion",
        "opencart",
        "openid",
        "opera",
        "optin-monster",
        "option",
        "orcid",
        "ornament",
        "osi",
        "otter",
        "outdent",
        "outlet",
        "oven",
        "overline",
        "p",
        "padlet",
        "page",
        "page-caret-down",
        "page-caret-up",
        "page4",
        "pagelines",
        "pager",
        "paint-roller",
        "paintbrush",
        "paintbrush-fine",
        "paintbrush-pencil",
        "palette",
        "palfed",
        "pallet",
        "pallet-box",
        "pallet-boxes",
        "pan-food",
        "pan-frying",
        "pancakes",
        "panel-ews",
        "panel-fire",
        "panorama",
        "paper-plane",
        "paper-plane-top",
        "paperclip",
        "paperclip-vertical",
        "parachute-box",
        "paragraph",
        "paragraph-left",
        "party-bell",
        "party-horn",
        "passport",
        "paste",
        "patreon",
        "pause",
        "paw",
        "paw-claws",
        "paw-simple",
        "paypal",
        "peace",
        "peach",
        "peanut",
        "peanuts",
        "peapod",
        "pear",
        "pedestal",
        "pegasus",
        "pen",
        "pen-circle",
        "pen-clip",
        "pen-clip-slash",
        "pen-fancy",
        "pen-fancy-slash",
        "pen-field",
        "pen-line",
        "pen-nib",
        "pen-nib-slash",
        "pen-paintbrush",
        "pen-ruler",
        "pen-slash",
        "pen-swirl",
        "pen-to-square",
        "pencil",
        "pencil-mechanical",
        "pencil-slash",
        "people",
        "people-arrows",
        "people-carry-box",
        "people-dress",
        "people-dress-simple",
        "people-group",
        "people-line",
        "people-pants",
        "people-pants-simple",
        "people-pulling",
        "people-robbery",
        "people-roof",
        "people-simple",
        "pepper",
        "pepper-hot",
        "perbyte",
        "percent",
        "period",
        "periscope",
        "person",
        "person-arrow-down-to-line",
        "person-arrow-up-from-line",
        "person-biking",
        "person-biking-mountain",
        "person-booth",
        "person-breastfeeding",
        "person-burst",
        "person-cane",
        "person-carry-box",
        "person-chalkboard",
        "person-circle-check",
        "person-circle-exclamation",
        "person-circle-minus",
        "person-circle-plus",
        "person-circle-question",
        "person-circle-xmark",
        "person-digging",
        "person-dolly",
        "person-dolly-empty",
        "person-dots-from-line",
        "person-dress",
        "person-dress-burst",
        "person-dress-fairy",
        "person-dress-simple",
        "person-drowning",
        "person-fairy",
        "person-falling",
        "person-falling-burst",
        "person-from-portal",
        "person-half-dress",
        "person-harassing",
        "person-hiking",
        "person-military-pointing",
        "person-military-rifle",
        "person-military-to-person",
        "person-pinball",
        "person-praying",
        "person-pregnant",
        "person-rays",
        "person-rifle",
        "person-running",
        "person-running-fast",
        "person-seat",
        "person-seat-reclined",
        "person-shelter",
        "person-sign",
        "person-simple",
        "person-skating",
        "person-ski-jumping",
        "person-ski-lift",
        "person-skiing",
        "person-skiing-nordic",
        "person-sledding",
        "person-snowboarding",
        "person-snowmobiling",
        "person-swimming",
        "person-through-window",
        "person-to-door",
        "person-to-portal",
        "person-walking",
        "person-walking-arrow-loop-left",
        "person-walking-arrow-right",
        "person-walking-dashed-line-arrow-right",
        "person-walking-luggage",
        "person-walking-with-cane",
        "peseta-sign",
        "peso-sign",
        "phabricator",
        "phoenix-framework",
        "phoenix-squadron",
        "phone",
        "phone-arrow-down-left",
        "phone-arrow-right",
        "phone-arrow-up-right",
        "phone-flip",
        "phone-hangup",
        "phone-intercom",
        "phone-missed",
        "phone-office",
        "phone-plus",
        "phone-rotary",
        "phone-slash",
        "phone-volume",
        "phone-xmark",
        "photo-film",
        "photo-film-music",
        "php",
        "pi",
        "piano",
        "piano-keyboard",
        "pickaxe",
        "pickleball",
        "pie",
        "pied-piper",
        "pied-piper-alt",
        "pied-piper-hat",
        "pied-piper-pp",
        "pig",
        "piggy-bank",
        "pills",
        "pinata",
        "pinball",
        "pineapple",
        "pinterest",
        "pinterest-p",
        "pipe",
        "pipe-circle-check",
        "pipe-collar",
        "pipe-section",
        "pipe-smoking",
        "pipe-valve",
        "pix",
        "pizza",
        "pizza-slice",
        "place-of-worship",
        "plane",
        "plane-arrival",
        "plane-circle-check",
        "plane-circle-exclamation",
        "plane-circle-xmark",
        "plane-departure",
        "plane-engines",
        "plane-lock",
        "plane-prop",
        "plane-slash",
        "plane-tail",
        "plane-up",
        "plane-up-slash",
        "planet-moon",
        "planet-ringed",
        "plant-wilt",
        "plate-utensils",
        "plate-wheat",
        "play",
        "play-pause",
        "playstation",
        "plug",
        "plug-circle-bolt",
        "plug-circle-check",
        "plug-circle-exclamation",
        "plug-circle-minus",
        "plug-circle-plus",
        "plug-circle-xmark",
        "plus",
        "plus-large",
        "plus-minus",
        "podcast",
        "podium",
        "podium-star",
        "police-box",
        "poll-people",
        "pompebled",
        "poo",
        "poo-storm",
        "pool-8-ball",
        "poop",
        "popcorn",
        "popsicle",
        "pot-food",
        "potato",
        "power-off",
        "prescription",
        "prescription-bottle",
        "prescription-bottle-medical",
        "prescription-bottle-pill",
        "presentation-screen",
        "pretzel",
        "print",
        "print-magnifying-glass",
        "print-slash",
        "product-hunt",
        "projector",
        "pump",
        "pump-medical",
        "pump-soap",
        "pumpkin",
        "pushed",
        "puzzle",
        "puzzle-piece",
        "puzzle-piece-simple",
        "python",
        "q",
        "qq",
        "qrcode",
        "question",
        "quinscape",
        "quora",
        "quote-left",
        "quote-right",
        "quotes",
        "r",
        "r-project",
        "rabbit",
        "rabbit-running",
        "raccoon",
        "racquet",
        "radar",
        "radiation",
        "radio",
        "radio-tuner",
        "rainbow",
        "raindrops",
        "ram",
        "ramp-loading",
        "ranking-star",
        "raspberry-pi",
        "ravelry",
        "raygun",
        "react",
        "reacteurope",
        "readme",
        "rebel",
        "receipt",
        "record-vinyl",
        "rectangle",
        "rectangle-ad",
        "rectangle-barcode",
        "rectangle-code",
        "rectangle-history",
        "rectangle-history-circle-plus",
        "rectangle-history-circle-user",
        "rectangle-list",
        "rectangle-pro",
        "rectangle-terminal",
        "rectangle-vertical",
        "rectangle-vertical-history",
        "rectangle-wide",
        "rectangle-xmark",
        "rectangles-mixed",
        "recycle",
        "red-river",
        "reddit",
        "reddit-alien",
        "redhat",
        "reel",
        "refrigerator",
        "registered",
        "renren",
        "repeat",
        "repeat-1",
        "reply",
        "reply-all",
        "reply-clock",
        "replyd",
        "republican",
        "researchgate",
        "resolving",
        "restroom",
        "restroom-simple",
        "retweet",
        "rev",
        "rhombus",
        "ribbon",
        "right",
        "right-from-bracket",
        "right-from-line",
        "right-left",
        "right-left-large",
        "right-long",
        "right-long-to-line",
        "right-to-bracket",
        "right-to-line",
        "ring",
        "ring-diamond",
        "rings-wedding",
        "road",
        "road-barrier",
        "road-bridge",
        "road-circle-check",
        "road-circle-exclamation",
        "road-circle-xmark",
        "road-lock",
        "road-spikes",
        "robot",
        "robot-astromech",
        "rocket",
        "rocket-launch",
        "rocketchat",
        "rockrms",
        "roller-coaster",
        "rotate",
        "rotate-exclamation",
        "rotate-left",
        "rotate-right",
        "route",
        "route-highway",
        "route-interstate",
        "router",
        "rss",
        "ruble-sign",
        "rug",
        "rugby-ball",
        "ruler",
        "ruler-combined",
        "ruler-horizontal",
        "ruler-triangle",
        "ruler-vertical",
        "rupee-sign",
        "rupiah-sign",
        "rust",
        "rv",
        "s",
        "sack",
        "sack-dollar",
        "sack-xmark",
        "safari",
        "sailboat",
        "salad",
        "salesforce",
        "salt-shaker",
        "sandwich",
        "sass",
        "satellite",
        "satellite-dish",
        "sausage",
        "saxophone",
        "saxophone-fire",
        "scale-balanced",
        "scale-unbalanced",
        "scale-unbalanced-flip",
        "scalpel",
        "scalpel-line-dashed",
        "scanner-gun",
        "scanner-image",
        "scanner-keyboard",
        "scanner-touchscreen",
        "scarecrow",
        "scarf",
        "schlix",
        "school",
        "school-circle-check",
        "school-circle-exclamation",
        "school-circle-xmark",
        "school-flag",
        "school-lock",
        "scissors",
        "screen-users",
        "screencast",
        "screenpal",
        "screwdriver",
        "screwdriver-wrench",
        "scribble",
        "scribd",
        "scroll",
        "scroll-old",
        "scroll-torah",
        "scrubber",
        "scythe",
        "sd-card",
        "sd-cards",
        "seal",
        "seal-exclamation",
        "seal-question",
        "searchengin",
        "seat-airline",
        "section",
        "seedling",
        "sellcast",
        "sellsy",
        "semicolon",
        "send-back",
        "send-backward",
        "sensor",
        "sensor-cloud",
        "sensor-fire",
        "sensor-on",
        "sensor-triangle-exclamation",
        "server",
        "servicestack",
        "shapes",
        "share",
        "share-all",
        "share-from-square",
        "share-nodes",
        "sheep",
        "sheet-plastic",
        "shekel-sign",
        "shelves",
        "shelves-empty",
        "shield",
        "shield-cat",
        "shield-check",
        "shield-cross",
        "shield-dog",
        "shield-exclamation",
        "shield-halved",
        "shield-heart",
        "shield-keyhole",
        "shield-minus",
        "shield-plus",
        "shield-quartered",
        "shield-slash",
        "shield-virus",
        "shield-xmark",
        "ship",
        "shirt",
        "shirt-long-sleeve",
        "shirt-running",
        "shirt-tank-top",
        "shirtsinbulk",
        "shish-kebab",
        "shoe-prints",
        "shoelace",
        "shop",
        "shop-lock",
        "shop-slash",
        "shopify",
        "shopware",
        "shovel",
        "shovel-snow",
        "shower",
        "shower-down",
        "shredder",
        "shrimp",
        "shuffle",
        "shutters",
        "shuttle-space",
        "shuttlecock",
        "sickle",
        "sidebar",
        "sidebar-flip",
        "sigma",
        "sign-hanging",
        "signal",
        "signal-bars",
        "signal-bars-fair",
        "signal-bars-good",
        "signal-bars-slash",
        "signal-bars-weak",
        "signal-fair",
        "signal-good",
        "signal-slash",
        "signal-stream",
        "signal-stream-slash",
        "signal-strong",
        "signal-weak",
        "signature",
        "signature-lock",
        "signature-slash",
        "signs-post",
        "sim-card",
        "sim-cards",
        "simplybuilt",
        "sink",
        "siren",
        "siren-on",
        "sistrix",
        "sitemap",
        "sith",
        "sitrox",
        "skeleton",
        "skeleton-ribs",
        "sketch",
        "ski-boot",
        "ski-boot-ski",
        "skull",
        "skull-cow",
        "skull-crossbones",
        "skyatlas",
        "skype",
        "slack",
        "slash",
        "slash-back",
        "slash-forward",
        "sleigh",
        "slider",
        "sliders",
        "sliders-simple",
        "sliders-up",
        "slideshare",
        "slot-machine",
        "smog",
        "smoke",
        "smoking",
        "snake",
        "snapchat",
        "snooze",
        "snow-blowing",
        "snowflake",
        "snowflake-droplets",
        "snowflakes",
        "snowman",
        "snowman-head",
        "snowplow",
        "soap",
        "socks",
        "soft-serve",
        "solar-panel",
        "solar-system",
        "sort",
        "sort-down",
        "sort-up",
        "soundcloud",
        "sourcetree",
        "spa",
        "space-awesome",
        "space-station-moon",
        "space-station-moon-construction",
        "spade",
        "spaghetti-monster-flying",
        "sparkle",
        "sparkles",
        "speakap",
        "speaker",
        "speaker-deck",
        "speakers",
        "spell-check",
        "spider",
        "spider-black-widow",
        "spider-web",
        "spinner",
        "spinner-third",
        "split",
        "splotch",
        "spoon",
        "sportsball",
        "spotify",
        "spray-can",
        "spray-can-sparkles",
        "sprinkler",
        "sprinkler-ceiling",
        "square",
        "square-0",
        "square-1",
        "square-2",
        "square-3",
        "square-4",
        "square-5",
        "square-6",
        "square-7",
        "square-8",
        "square-9",
        "square-a",
        "square-a-lock",
        "square-ampersand",
        "square-arrow-down",
        "square-arrow-down-left",
        "square-arrow-down-right",
        "square-arrow-left",
        "square-arrow-right",
        "square-arrow-up",
        "square-arrow-up-left",
        "square-arrow-up-right",
        "square-b",
        "square-behance",
        "square-bolt",
        "square-c",
        "square-caret-down",
        "square-caret-left",
        "square-caret-right",
        "square-caret-up",
        "square-check",
        "square-chevron-down",
        "square-chevron-left",
        "square-chevron-right",
        "square-chevron-up",
        "square-code",
        "square-d",
        "square-dashed",
        "square-dashed-circle-plus",
        "square-divide",
        "square-dollar",
        "square-down",
        "square-down-left",
        "square-down-right",
        "square-dribbble",
        "square-e",
        "square-ellipsis",
        "square-ellipsis-vertical",
        "square-envelope",
        "square-exclamation",
        "square-f",
        "square-facebook",
        "square-font-awesome",
        "square-font-awesome-stroke",
        "square-fragile",
        "square-full",
        "square-g",
        "square-git",
        "square-github",
        "square-gitlab",
        "square-google-plus",
        "square-h",
        "square-hacker-news",
        "square-heart",
        "square-i",
        "square-info",
        "square-instagram",
        "square-j",
        "square-js",
        "square-k",
        "square-kanban",
        "square-l",
        "square-lastfm",
        "square-left",
        "square-list",
        "square-m",
        "square-minus",
        "square-n",
        "square-nfi",
        "square-o",
        "square-odnoklassniki",
        "square-p",
        "square-parking",
        "square-parking-slash",
        "square-pen",
        "square-person-confined",
        "square-phone",
        "square-phone-flip",
        "square-phone-hangup",
        "square-pied-piper",
        "square-pinterest",
        "square-plus",
        "square-poll-horizontal",
        "square-poll-vertical",
        "square-q",
        "square-quarters",
        "square-question",
        "square-quote",
        "square-r",
        "square-reddit",
        "square-right",
        "square-ring",
        "square-root",
        "square-root-variable",
        "square-rss",
        "square-s",
        "square-share-nodes",
        "square-sliders",
        "square-sliders-vertical",
        "square-small",
        "square-snapchat",
        "square-star",
        "square-steam",
        "square-t",
        "square-terminal",
        "square-this-way-up",
        "square-threads",
        "square-twitter",
        "square-u",
        "square-up",
        "square-up-left",
        "square-up-right",
        "square-user",
        "square-v",
        "square-viadeo",
        "square-vimeo",
        "square-virus",
        "square-w",
        "square-whatsapp",
        "square-x",
        "square-x-twitter",
        "square-xing",
        "square-xmark",
        "square-y",
        "square-youtube",
        "square-z",
        "squarespace",
        "squid",
        "squirrel",
        "stack-exchange",
        "stack-overflow",
        "stackpath",
        "staff",
        "staff-snake",
        "stairs",
        "stamp",
        "standard-definition",
        "stapler",
        "star",
        "star-and-crescent",
        "star-christmas",
        "star-exclamation",
        "star-half",
        "star-half-stroke",
        "star-of-david",
        "star-of-life",
        "star-sharp",
        "star-sharp-half",
        "star-sharp-half-stroke",
        "star-shooting",
        "starfighter",
        "starfighter-twin-ion-engine",
        "starfighter-twin-ion-engine-advanced",
        "stars",
        "starship",
        "starship-freighter",
        "staylinked",
        "steak",
        "steam",
        "steam-symbol",
        "steering-wheel",
        "sterling-sign",
        "stethoscope",
        "sticker-mule",
        "stocking",
        "stomach",
        "stop",
        "stopwatch",
        "stopwatch-20",
        "store",
        "store-lock",
        "store-slash",
        "strava",
        "strawberry",
        "street-view",
        "stretcher",
        "strikethrough",
        "stripe",
        "stripe-s",
        "stroopwafel",
        "stubber",
        "studiovinari",
        "stumbleupon",
        "stumbleupon-circle",
        "subscript",
        "subtitles",
        "subtitles-slash",
        "suitcase",
        "suitcase-medical",
        "suitcase-rolling",
        "sun",
        "sun-bright",
        "sun-cloud",
        "sun-dust",
        "sun-haze",
        "sun-plant-wilt",
        "sunglasses",
        "sunrise",
        "sunset",
        "superpowers",
        "superscript",
        "supple",
        "suse",
        "sushi",
        "sushi-roll",
        "swap",
        "swap-arrows",
        "swatchbook",
        "swift",
        "sword",
        "sword-laser",
        "sword-laser-alt",
        "swords",
        "swords-laser",
        "symbols",
        "symfony",
        "synagogue",
        "syringe",
        "t",
        "table",
        "table-cells",
        "table-cells-large",
        "table-columns",
        "table-layout",
        "table-list",
        "table-picnic",
        "table-pivot",
        "table-rows",
        "table-tennis-paddle-ball",
        "table-tree",
        "tablet",
        "tablet-button",
        "tablet-rugged",
        "tablet-screen",
        "tablet-screen-button",
        "tablets",
        "tachograph-digital",
        "taco",
        "tag",
        "tags",
        "tally",
        "tally-1",
        "tally-2",
        "tally-3",
        "tally-4",
        "tamale",
        "tank-water",
        "tape",
        "tarp",
        "tarp-droplet",
        "taxi",
        "taxi-bus",
        "teamspeak",
        "teddy-bear",
        "teeth",
        "teeth-open",
        "telegram",
        "telescope",
        "temperature-arrow-down",
        "temperature-arrow-up",
        "temperature-empty",
        "temperature-full",
        "temperature-half",
        "temperature-high",
        "temperature-list",
        "temperature-low",
        "temperature-quarter",
        "temperature-snow",
        "temperature-sun",
        "temperature-three-quarters",
        "tencent-weibo",
        "tenge-sign",
        "tennis-ball",
        "tent",
        "tent-arrow-down-to-line",
        "tent-arrow-left-right",
        "tent-arrow-turn-left",
        "tent-arrows-down",
        "tents",
        "terminal",
        "text",
        "text-height",
        "text-size",
        "text-slash",
        "text-width",
        "the-red-yeti",
        "themeco",
        "themeisle",
        "thermometer",
        "theta",
        "think-peaks",
        "thought-bubble",
        "threads",
        "thumbs-down",
        "thumbs-up",
        "thumbtack",
        "tick",
        "ticket",
        "ticket-airline",
        "ticket-simple",
        "tickets-airline",
        "tiktok",
        "tilde",
        "timeline",
        "timeline-arrow",
        "timer",
        "tire",
        "tire-flat",
        "tire-pressure-warning",
        "tire-rugged",
        "toggle-large-off",
        "toggle-large-on",
        "toggle-off",
        "toggle-on",
        "toilet",
        "toilet-paper",
        "toilet-paper-blank",
        "toilet-paper-blank-under",
        "toilet-paper-check",
        "toilet-paper-slash",
        "toilet-paper-under",
        "toilet-paper-under-slash",
        "toilet-paper-xmark",
        "toilet-portable",
        "toilets-portable",
        "tomato",
        "tombstone",
        "tombstone-blank",
        "toolbox",
        "tooth",
        "toothbrush",
        "torii-gate",
        "tornado",
        "tower-broadcast",
        "tower-cell",
        "tower-control",
        "tower-observation",
        "tractor",
        "trade-federation",
        "trademark",
        "traffic-cone",
        "traffic-light",
        "traffic-light-go",
        "traffic-light-slow",
        "traffic-light-stop",
        "trailer",
        "train",
        "train-subway",
        "train-subway-tunnel",
        "train-track",
        "train-tram",
        "train-tunnel",
        "transformer-bolt",
        "transgender",
        "transporter",
        "transporter-1",
        "transporter-2",
        "transporter-3",
        "transporter-4",
        "transporter-5",
        "transporter-6",
        "transporter-7",
        "transporter-empty",
        "trash",
        "trash-arrow-up",
        "trash-can",
        "trash-can-arrow-up",
        "trash-can-check",
        "trash-can-clock",
        "trash-can-list",
        "trash-can-plus",
        "trash-can-slash",
        "trash-can-undo",
        "trash-can-xmark",
        "trash-check",
        "trash-clock",
        "trash-list",
        "trash-plus",
        "trash-slash",
        "trash-undo",
        "trash-xmark",
        "treasure-chest",
        "tree",
        "tree-christmas",
        "tree-city",
        "tree-deciduous",
        "tree-decorated",
        "tree-large",
        "tree-palm",
        "trees",
        "trello",
        "triangle",
        "triangle-exclamation",
        "triangle-instrument",
        "triangle-person-digging",
        "tricycle",
        "tricycle-adult",
        "trillium",
        "trophy",
        "trophy-star",
        "trowel",
        "trowel-bricks",
        "truck",
        "truck-arrow-right",
        "truck-bolt",
        "truck-clock",
        "truck-container",
        "truck-container-empty",
        "truck-droplet",
        "truck-fast",
        "truck-field",
        "truck-field-un",
        "truck-flatbed",
        "truck-front",
        "truck-medical",
        "truck-monster",
        "truck-moving",
        "truck-pickup",
        "truck-plane",
        "truck-plow",
        "truck-ramp",
        "truck-ramp-box",
        "truck-ramp-couch",
        "truck-tow",
        "trumpet",
        "tty",
        "tty-answer",
        "tugrik-sign",
        "tumblr",
        "turkey",
        "turkish-lira-sign",
        "turn-down",
        "turn-down-left",
        "turn-down-right",
        "turn-up",
        "turntable",
        "turtle",
        "tv",
        "tv-music",
        "tv-retro",
        "twitch",
        "twitter",
        "typewriter",
        "typo3",
        "u",
        "uber",
        "ubuntu",
        "ufo",
        "ufo-beam",
        "uikit",
        "umbraco",
        "umbrella",
        "umbrella-beach",
        "umbrella-simple",
        "uncharted",
        "underline",
        "unicorn",
        "uniform-martial-arts",
        "union",
        "uniregistry",
        "unity",
        "universal-access",
        "unlock",
        "unlock-keyhole",
        "unsplash",
        "untappd",
        "up",
        "up-down",
        "up-down-left-right",
        "up-from-bracket",
        "up-from-dotted-line",
        "up-from-line",
        "up-left",
        "up-long",
        "up-right",
        "up-right-and-down-left-from-center",
        "up-right-from-square",
        "up-to-dotted-line",
        "up-to-line",
        "upload",
        "ups",
        "usb",
        "usb-drive",
        "user",
        "user-alien",
        "user-astronaut",
        "user-bounty-hunter",
        "user-check",
        "user-chef",
        "user-clock",
        "user-cowboy",
        "user-crown",
        "user-doctor",
        "user-doctor-hair",
        "user-doctor-hair-long",
        "user-doctor-message",
        "user-gear",
        "user-graduate",
        "user-group",
        "user-group-crown",
        "user-group-simple",
        "user-hair",
        "user-hair-buns",
        "user-hair-long",
        "user-hair-mullet",
        "user-headset",
        "user-helmet-safety",
        "user-injured",
        "user-large",
        "user-large-slash",
        "user-lock",
        "user-magnifying-glass",
        "user-minus",
        "user-music",
        "user-ninja",
        "user-nurse",
        "user-nurse-hair",
        "user-nurse-hair-long",
        "user-pen",
        "user-pilot",
        "user-pilot-tie",
        "user-plus",
        "user-police",
        "user-police-tie",
        "user-robot",
        "user-robot-xmarks",
        "user-secret",
        "user-shakespeare",
        "user-shield",
        "user-slash",
        "user-tag",
        "user-tie",
        "user-tie-hair",
        "user-tie-hair-long",
        "user-unlock",
        "user-visor",
        "user-vneck",
        "user-vneck-hair",
        "user-vneck-hair-long",
        "user-xmark",
        "users",
        "users-between-lines",
        "users-gear",
        "users-line",
        "users-medical",
        "users-rays",
        "users-rectangle",
        "users-slash",
        "users-viewfinder",
        "usps",
        "ussunnah",
        "utensils",
        "utensils-slash",
        "utility-pole",
        "utility-pole-double",
        "v",
        "vaadin",
        "vacuum",
        "vacuum-robot",
        "value-absolute",
        "van-shuttle",
        "vault",
        "vector-circle",
        "vector-polygon",
        "vector-square",
        "vent-damper",
        "venus",
        "venus-double",
        "venus-mars",
        "vest",
        "vest-patches",
        "viacoin",
        "viadeo",
        "vial",
        "vial-circle-check",
        "vial-virus",
        "vials",
        "viber",
        "video",
        "video-arrow-down-left",
        "video-arrow-up-right",
        "video-plus",
        "video-slash",
        "vihara",
        "vimeo",
        "vimeo-v",
        "vine",
        "violin",
        "virus",
        "virus-covid",
        "virus-covid-slash",
        "virus-slash",
        "viruses",
        "vk",
        "vnv",
        "voicemail",
        "volcano",
        "volleyball",
        "volume",
        "volume-high",
        "volume-low",
        "volume-off",
        "volume-slash",
        "volume-xmark",
        "vr-cardboard",
        "vuejs",
        "w",
        "waffle",
        "wagon-covered",
        "walker",
        "walkie-talkie",
        "wallet",
        "wand",
        "wand-magic",
        "wand-magic-sparkles",
        "wand-sparkles",
        "warehouse",
        "warehouse-full",
        "washing-machine",
        "watch",
        "watch-apple",
        "watch-calculator",
        "watch-fitness",
        "watch-smart",
        "watchman-monitoring",
        "water",
        "water-arrow-down",
        "water-arrow-up",
        "water-ladder",
        "watermelon-slice",
        "wave-pulse",
        "wave-sine",
        "wave-square",
        "wave-triangle",
        "waveform",
        "waveform-lines",
        "waze",
        "webhook",
        "weebly",
        "weibo",
        "weight-hanging",
        "weight-scale",
        "weixin",
        "whale",
        "whatsapp",
        "wheat",
        "wheat-awn",
        "wheat-awn-circle-exclamation",
        "wheat-awn-slash",
        "wheat-slash",
        "wheelchair",
        "wheelchair-move",
        "whiskey-glass",
        "whiskey-glass-ice",
        "whistle",
        "whmcs",
        "wifi",
        "wifi-exclamation",
        "wifi-fair",
        "wifi-slash",
        "wifi-weak",
        "wikipedia-w",
        "wind",
        "wind-turbine",
        "wind-warning",
        "window",
        "window-flip",
        "window-frame",
        "window-frame-open",
        "window-maximize",
        "window-minimize",
        "window-restore",
        "windows",
        "windsock",
        "wine-bottle",
        "wine-glass",
        "wine-glass-crack",
        "wine-glass-empty",
        "wirsindhandwerk",
        "wix",
        "wizards-of-the-coast",
        "wodu",
        "wolf-pack-battalion",
        "won-sign",
        "wordpress",
        "wordpress-simple",
        "worm",
        "wpbeginner",
        "wpexplorer",
        "wpforms",
        "wpressr",
        "wreath",
        "wreath-laurel",
        "wrench",
        "wrench-simple",
        "x",
        "x-ray",
        "x-twitter",
        "xbox",
        "xing",
        "xmark",
        "xmark-large",
        "xmark-to-slot",
        "xmarks-lines",
        "y",
        "y-combinator",
        "yahoo",
        "yammer",
        "yandex",
        "yandex-international",
        "yarn",
        "yelp",
        "yen-sign",
        "yin-yang",
        "yoast",
        "youtube",
        "z",
        "zhihu"
    ];
}

export enum IconFA6 {
    NUM_0 = "0",
    NUM_00 = "00",
    NUM_1 = "1",
    NUM_2 = "2",
    NUM_3 = "3",
    NUM_360_DEGREES = "360-degrees",
    NUM_4 = "4",
    NUM_42_GROUP = "42-group",
    NUM_5 = "5",
    NUM_500PX = "500px",
    NUM_6 = "6",
    NUM_7 = "7",
    NUM_8 = "8",
    NUM_9 = "9",
    A = "a",
    ABACUS = "abacus",
    ACCENT_GRAVE = "accent-grave",
    ACCESSIBLE_ICON = "accessible-icon",
    ACCUSOFT = "accusoft",
    ACORN = "acorn",
    ADDRESS_BOOK = "address-book",
    ADDRESS_CARD = "address-card",
    ADN = "adn",
    ADVERSAL = "adversal",
    AFFILIATETHEME = "affiliatetheme",
    AIR_CONDITIONER = "air-conditioner",
    AIRBNB = "airbnb",
    AIRPLAY = "airplay",
    ALARM_CLOCK = "alarm-clock",
    ALARM_EXCLAMATION = "alarm-exclamation",
    ALARM_PLUS = "alarm-plus",
    ALARM_SNOOZE = "alarm-snooze",
    ALBUM = "album",
    ALBUM_CIRCLE_PLUS = "album-circle-plus",
    ALBUM_CIRCLE_USER = "album-circle-user",
    ALBUM_COLLECTION = "album-collection",
    ALBUM_COLLECTION_CIRCLE_PLUS = "album-collection-circle-plus",
    ALBUM_COLLECTION_CIRCLE_USER = "album-collection-circle-user",
    ALGOLIA = "algolia",
    ALICORN = "alicorn",
    ALIEN = "alien",
    ALIEN_8BIT = "alien-8bit",
    ALIGN_CENTER = "align-center",
    ALIGN_JUSTIFY = "align-justify",
    ALIGN_LEFT = "align-left",
    ALIGN_RIGHT = "align-right",
    ALIGN_SLASH = "align-slash",
    ALIPAY = "alipay",
    ALT = "alt",
    AMAZON = "amazon",
    AMAZON_PAY = "amazon-pay",
    AMILIA = "amilia",
    AMP_GUITAR = "amp-guitar",
    AMPERSAND = "ampersand",
    ANCHOR = "anchor",
    ANCHOR_CIRCLE_CHECK = "anchor-circle-check",
    ANCHOR_CIRCLE_EXCLAMATION = "anchor-circle-exclamation",
    ANCHOR_CIRCLE_XMARK = "anchor-circle-xmark",
    ANCHOR_LOCK = "anchor-lock",
    ANDROID = "android",
    ANGEL = "angel",
    ANGELLIST = "angellist",
    ANGLE = "angle",
    ANGLE_90 = "angle-90",
    ANGLE_DOWN = "angle-down",
    ANGLE_LEFT = "angle-left",
    ANGLE_RIGHT = "angle-right",
    ANGLE_UP = "angle-up",
    ANGLES_DOWN = "angles-down",
    ANGLES_LEFT = "angles-left",
    ANGLES_RIGHT = "angles-right",
    ANGLES_UP = "angles-up",
    ANGLES_UP_DOWN = "angles-up-down",
    ANGRYCREATIVE = "angrycreative",
    ANGULAR = "angular",
    ANKH = "ankh",
    APARTMENT = "apartment",
    APERTURE = "aperture",
    APOSTROPHE = "apostrophe",
    APP_STORE = "app-store",
    APP_STORE_IOS = "app-store-ios",
    APPER = "apper",
    APPLE = "apple",
    APPLE_CORE = "apple-core",
    APPLE_PAY = "apple-pay",
    APPLE_WHOLE = "apple-whole",
    ARCHWAY = "archway",
    ARROW_DOWN = "arrow-down",
    ARROW_DOWN_1_9 = "arrow-down-1-9",
    ARROW_DOWN_9_1 = "arrow-down-9-1",
    ARROW_DOWN_A_Z = "arrow-down-a-z",
    ARROW_DOWN_ARROW_UP = "arrow-down-arrow-up",
    ARROW_DOWN_BIG_SMALL = "arrow-down-big-small",
    ARROW_DOWN_FROM_ARC = "arrow-down-from-arc",
    ARROW_DOWN_FROM_DOTTED_LINE = "arrow-down-from-dotted-line",
    ARROW_DOWN_FROM_LINE = "arrow-down-from-line",
    ARROW_DOWN_LEFT = "arrow-down-left",
    ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER = "arrow-down-left-and-arrow-up-right-to-center",
    ARROW_DOWN_LONG = "arrow-down-long",
    ARROW_DOWN_RIGHT = "arrow-down-right",
    ARROW_DOWN_SHORT_WIDE = "arrow-down-short-wide",
    ARROW_DOWN_SMALL_BIG = "arrow-down-small-big",
    ARROW_DOWN_SQUARE_TRIANGLE = "arrow-down-square-triangle",
    ARROW_DOWN_TO_ARC = "arrow-down-to-arc",
    ARROW_DOWN_TO_BRACKET = "arrow-down-to-bracket",
    ARROW_DOWN_TO_DOTTED_LINE = "arrow-down-to-dotted-line",
    ARROW_DOWN_TO_LINE = "arrow-down-to-line",
    ARROW_DOWN_TO_SQUARE = "arrow-down-to-square",
    ARROW_DOWN_TRIANGLE_SQUARE = "arrow-down-triangle-square",
    ARROW_DOWN_UP_ACROSS_LINE = "arrow-down-up-across-line",
    ARROW_DOWN_UP_LOCK = "arrow-down-up-lock",
    ARROW_DOWN_WIDE_SHORT = "arrow-down-wide-short",
    ARROW_DOWN_Z_A = "arrow-down-z-a",
    ARROW_LEFT = "arrow-left",
    ARROW_LEFT_FROM_ARC = "arrow-left-from-arc",
    ARROW_LEFT_FROM_LINE = "arrow-left-from-line",
    ARROW_LEFT_LONG = "arrow-left-long",
    ARROW_LEFT_LONG_TO_LINE = "arrow-left-long-to-line",
    ARROW_LEFT_TO_ARC = "arrow-left-to-arc",
    ARROW_LEFT_TO_LINE = "arrow-left-to-line",
    ARROW_POINTER = "arrow-pointer",
    ARROW_PROGRESS = "arrow-progress",
    ARROW_RIGHT = "arrow-right",
    ARROW_RIGHT_ARROW_LEFT = "arrow-right-arrow-left",
    ARROW_RIGHT_FROM_ARC = "arrow-right-from-arc",
    ARROW_RIGHT_FROM_BRACKET = "arrow-right-from-bracket",
    ARROW_RIGHT_FROM_LINE = "arrow-right-from-line",
    ARROW_RIGHT_LONG = "arrow-right-long",
    ARROW_RIGHT_LONG_TO_LINE = "arrow-right-long-to-line",
    ARROW_RIGHT_TO_ARC = "arrow-right-to-arc",
    ARROW_RIGHT_TO_BRACKET = "arrow-right-to-bracket",
    ARROW_RIGHT_TO_CITY = "arrow-right-to-city",
    ARROW_RIGHT_TO_LINE = "arrow-right-to-line",
    ARROW_ROTATE_LEFT = "arrow-rotate-left",
    ARROW_ROTATE_RIGHT = "arrow-rotate-right",
    ARROW_TREND_DOWN = "arrow-trend-down",
    ARROW_TREND_UP = "arrow-trend-up",
    ARROW_TURN_DOWN = "arrow-turn-down",
    ARROW_TURN_DOWN_LEFT = "arrow-turn-down-left",
    ARROW_TURN_DOWN_RIGHT = "arrow-turn-down-right",
    ARROW_TURN_UP = "arrow-turn-up",
    ARROW_UP = "arrow-up",
    ARROW_UP_1_9 = "arrow-up-1-9",
    ARROW_UP_9_1 = "arrow-up-9-1",
    ARROW_UP_A_Z = "arrow-up-a-z",
    ARROW_UP_ARROW_DOWN = "arrow-up-arrow-down",
    ARROW_UP_BIG_SMALL = "arrow-up-big-small",
    ARROW_UP_FROM_ARC = "arrow-up-from-arc",
    ARROW_UP_FROM_BRACKET = "arrow-up-from-bracket",
    ARROW_UP_FROM_DOTTED_LINE = "arrow-up-from-dotted-line",
    ARROW_UP_FROM_GROUND_WATER = "arrow-up-from-ground-water",
    ARROW_UP_FROM_LINE = "arrow-up-from-line",
    ARROW_UP_FROM_SQUARE = "arrow-up-from-square",
    ARROW_UP_FROM_WATER_PUMP = "arrow-up-from-water-pump",
    ARROW_UP_LEFT = "arrow-up-left",
    ARROW_UP_LEFT_FROM_CIRCLE = "arrow-up-left-from-circle",
    ARROW_UP_LONG = "arrow-up-long",
    ARROW_UP_RIGHT = "arrow-up-right",
    ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER = "arrow-up-right-and-arrow-down-left-from-center",
    ARROW_UP_RIGHT_DOTS = "arrow-up-right-dots",
    ARROW_UP_RIGHT_FROM_SQUARE = "arrow-up-right-from-square",
    ARROW_UP_SHORT_WIDE = "arrow-up-short-wide",
    ARROW_UP_SMALL_BIG = "arrow-up-small-big",
    ARROW_UP_SQUARE_TRIANGLE = "arrow-up-square-triangle",
    ARROW_UP_TO_ARC = "arrow-up-to-arc",
    ARROW_UP_TO_DOTTED_LINE = "arrow-up-to-dotted-line",
    ARROW_UP_TO_LINE = "arrow-up-to-line",
    ARROW_UP_TRIANGLE_SQUARE = "arrow-up-triangle-square",
    ARROW_UP_WIDE_SHORT = "arrow-up-wide-short",
    ARROW_UP_Z_A = "arrow-up-z-a",
    ARROWS_CROSS = "arrows-cross",
    ARROWS_DOWN_TO_LINE = "arrows-down-to-line",
    ARROWS_DOWN_TO_PEOPLE = "arrows-down-to-people",
    ARROWS_FROM_DOTTED_LINE = "arrows-from-dotted-line",
    ARROWS_FROM_LINE = "arrows-from-line",
    ARROWS_LEFT_RIGHT = "arrows-left-right",
    ARROWS_LEFT_RIGHT_TO_LINE = "arrows-left-right-to-line",
    ARROWS_MAXIMIZE = "arrows-maximize",
    ARROWS_MINIMIZE = "arrows-minimize",
    ARROWS_REPEAT = "arrows-repeat",
    ARROWS_REPEAT_1 = "arrows-repeat-1",
    ARROWS_RETWEET = "arrows-retweet",
    ARROWS_ROTATE = "arrows-rotate",
    ARROWS_SPIN = "arrows-spin",
    ARROWS_SPLIT_UP_AND_LEFT = "arrows-split-up-and-left",
    ARROWS_TO_CIRCLE = "arrows-to-circle",
    ARROWS_TO_DOT = "arrows-to-dot",
    ARROWS_TO_DOTTED_LINE = "arrows-to-dotted-line",
    ARROWS_TO_EYE = "arrows-to-eye",
    ARROWS_TO_LINE = "arrows-to-line",
    ARROWS_TURN_RIGHT = "arrows-turn-right",
    ARROWS_TURN_TO_DOTS = "arrows-turn-to-dots",
    ARROWS_UP_DOWN = "arrows-up-down",
    ARROWS_UP_DOWN_LEFT_RIGHT = "arrows-up-down-left-right",
    ARROWS_UP_TO_LINE = "arrows-up-to-line",
    ARTSTATION = "artstation",
    ASTERISK = "asterisk",
    ASYMMETRIK = "asymmetrik",
    AT = "at",
    ATLASSIAN = "atlassian",
    ATOM = "atom",
    ATOM_SIMPLE = "atom-simple",
    AUDIBLE = "audible",
    AUDIO_DESCRIPTION = "audio-description",
    AUDIO_DESCRIPTION_SLASH = "audio-description-slash",
    AUSTRAL_SIGN = "austral-sign",
    AUTOPREFIXER = "autoprefixer",
    AVIANEX = "avianex",
    AVIATO = "aviato",
    AVOCADO = "avocado",
    AWARD = "award",
    AWARD_SIMPLE = "award-simple",
    AWS = "aws",
    AXE = "axe",
    AXE_BATTLE = "axe-battle",
    B = "b",
    BABY = "baby",
    BABY_CARRIAGE = "baby-carriage",
    BACKPACK = "backpack",
    BACKWARD = "backward",
    BACKWARD_FAST = "backward-fast",
    BACKWARD_STEP = "backward-step",
    BACON = "bacon",
    BACTERIA = "bacteria",
    BACTERIUM = "bacterium",
    BADGE = "badge",
    BADGE_CHECK = "badge-check",
    BADGE_DOLLAR = "badge-dollar",
    BADGE_PERCENT = "badge-percent",
    BADGE_SHERIFF = "badge-sheriff",
    BADGER_HONEY = "badger-honey",
    BADMINTON = "badminton",
    BAG_SEEDLING = "bag-seedling",
    BAG_SHOPPING = "bag-shopping",
    BAGEL = "bagel",
    BAGS_SHOPPING = "bags-shopping",
    BAGUETTE = "baguette",
    BAHAI = "bahai",
    BAHT_SIGN = "baht-sign",
    BALL_PILE = "ball-pile",
    BALLOON = "balloon",
    BALLOONS = "balloons",
    BALLOT = "ballot",
    BALLOT_CHECK = "ballot-check",
    BAN = "ban",
    BAN_BUG = "ban-bug",
    BAN_PARKING = "ban-parking",
    BAN_SMOKING = "ban-smoking",
    BANANA = "banana",
    BANDAGE = "bandage",
    BANDCAMP = "bandcamp",
    BANGLADESHI_TAKA_SIGN = "bangladeshi-taka-sign",
    BANJO = "banjo",
    BARCODE = "barcode",
    BARCODE_READ = "barcode-read",
    BARCODE_SCAN = "barcode-scan",
    BARS = "bars",
    BARS_FILTER = "bars-filter",
    BARS_PROGRESS = "bars-progress",
    BARS_SORT = "bars-sort",
    BARS_STAGGERED = "bars-staggered",
    BASEBALL = "baseball",
    BASEBALL_BAT_BALL = "baseball-bat-ball",
    BASKET_SHOPPING = "basket-shopping",
    BASKET_SHOPPING_SIMPLE = "basket-shopping-simple",
    BASKETBALL = "basketball",
    BASKETBALL_HOOP = "basketball-hoop",
    BAT = "bat",
    BATH = "bath",
    BATTERY_BOLT = "battery-bolt",
    BATTERY_EMPTY = "battery-empty",
    BATTERY_EXCLAMATION = "battery-exclamation",
    BATTERY_FULL = "battery-full",
    BATTERY_HALF = "battery-half",
    BATTERY_LOW = "battery-low",
    BATTERY_QUARTER = "battery-quarter",
    BATTERY_SLASH = "battery-slash",
    BATTERY_THREE_QUARTERS = "battery-three-quarters",
    BATTLE_NET = "battle-net",
    BED = "bed",
    BED_BUNK = "bed-bunk",
    BED_EMPTY = "bed-empty",
    BED_FRONT = "bed-front",
    BED_PULSE = "bed-pulse",
    BEE = "bee",
    BEER_MUG = "beer-mug",
    BEER_MUG_EMPTY = "beer-mug-empty",
    BEHANCE = "behance",
    BELL = "bell",
    BELL_CONCIERGE = "bell-concierge",
    BELL_EXCLAMATION = "bell-exclamation",
    BELL_ON = "bell-on",
    BELL_PLUS = "bell-plus",
    BELL_SCHOOL = "bell-school",
    BELL_SCHOOL_SLASH = "bell-school-slash",
    BELL_SLASH = "bell-slash",
    BELLS = "bells",
    BENCH_TREE = "bench-tree",
    BEZIER_CURVE = "bezier-curve",
    BICYCLE = "bicycle",
    BILIBILI = "bilibili",
    BILLBOARD = "billboard",
    BIMOBJECT = "bimobject",
    BIN_BOTTLES = "bin-bottles",
    BIN_BOTTLES_RECYCLE = "bin-bottles-recycle",
    BIN_RECYCLE = "bin-recycle",
    BINARY = "binary",
    BINARY_CIRCLE_CHECK = "binary-circle-check",
    BINARY_LOCK = "binary-lock",
    BINARY_SLASH = "binary-slash",
    BINOCULARS = "binoculars",
    BIOHAZARD = "biohazard",
    BIRD = "bird",
    BITBUCKET = "bitbucket",
    BITCOIN = "bitcoin",
    BITCOIN_SIGN = "bitcoin-sign",
    BITY = "bity",
    BLACK_TIE = "black-tie",
    BLACKBERRY = "blackberry",
    BLANKET = "blanket",
    BLANKET_FIRE = "blanket-fire",
    BLENDER = "blender",
    BLENDER_PHONE = "blender-phone",
    BLINDS = "blinds",
    BLINDS_OPEN = "blinds-open",
    BLINDS_RAISED = "blinds-raised",
    BLOCK = "block",
    BLOCK_BRICK = "block-brick",
    BLOCK_BRICK_FIRE = "block-brick-fire",
    BLOCK_QUESTION = "block-question",
    BLOCK_QUOTE = "block-quote",
    BLOG = "blog",
    BLOGGER = "blogger",
    BLOGGER_B = "blogger-b",
    BLUEBERRIES = "blueberries",
    BLUETOOTH = "bluetooth",
    BLUETOOTH_B = "bluetooth-b",
    BOLD = "bold",
    BOLT = "bolt",
    BOLT_AUTO = "bolt-auto",
    BOLT_LIGHTNING = "bolt-lightning",
    BOLT_SLASH = "bolt-slash",
    BOMB = "bomb",
    BONE = "bone",
    BONE_BREAK = "bone-break",
    BONG = "bong",
    BOOK = "book",
    BOOK_ARROW_RIGHT = "book-arrow-right",
    BOOK_ARROW_UP = "book-arrow-up",
    BOOK_ATLAS = "book-atlas",
    BOOK_BIBLE = "book-bible",
    BOOK_BLANK = "book-blank",
    BOOK_BOOKMARK = "book-bookmark",
    BOOK_CIRCLE_ARROW_RIGHT = "book-circle-arrow-right",
    BOOK_CIRCLE_ARROW_UP = "book-circle-arrow-up",
    BOOK_COPY = "book-copy",
    BOOK_FONT = "book-font",
    BOOK_HEART = "book-heart",
    BOOK_JOURNAL_WHILLS = "book-journal-whills",
    BOOK_MEDICAL = "book-medical",
    BOOK_OPEN = "book-open",
    BOOK_OPEN_COVER = "book-open-cover",
    BOOK_OPEN_READER = "book-open-reader",
    BOOK_QURAN = "book-quran",
    BOOK_SECTION = "book-section",
    BOOK_SKULL = "book-skull",
    BOOK_SPARKLES = "book-sparkles",
    BOOK_TANAKH = "book-tanakh",
    BOOK_USER = "book-user",
    BOOKMARK = "bookmark",
    BOOKMARK_SLASH = "bookmark-slash",
    BOOKS = "books",
    BOOKS_MEDICAL = "books-medical",
    BOOMBOX = "boombox",
    BOOT = "boot",
    BOOT_HEELED = "boot-heeled",
    BOOTH_CURTAIN = "booth-curtain",
    BOOTSTRAP = "bootstrap",
    BORDER_ALL = "border-all",
    BORDER_BOTTOM = "border-bottom",
    BORDER_BOTTOM_RIGHT = "border-bottom-right",
    BORDER_CENTER_H = "border-center-h",
    BORDER_CENTER_V = "border-center-v",
    BORDER_INNER = "border-inner",
    BORDER_LEFT = "border-left",
    BORDER_NONE = "border-none",
    BORDER_OUTER = "border-outer",
    BORDER_RIGHT = "border-right",
    BORDER_TOP = "border-top",
    BORDER_TOP_LEFT = "border-top-left",
    BORE_HOLE = "bore-hole",
    BOTS = "bots",
    BOTTLE_DROPLET = "bottle-droplet",
    BOTTLE_WATER = "bottle-water",
    BOW_ARROW = "bow-arrow",
    BOWL_CHOPSTICKS = "bowl-chopsticks",
    BOWL_CHOPSTICKS_NOODLES = "bowl-chopsticks-noodles",
    BOWL_FOOD = "bowl-food",
    BOWL_HOT = "bowl-hot",
    BOWL_RICE = "bowl-rice",
    BOWL_SCOOP = "bowl-scoop",
    BOWL_SCOOPS = "bowl-scoops",
    BOWL_SOFT_SERVE = "bowl-soft-serve",
    BOWL_SPOON = "bowl-spoon",
    BOWLING_BALL = "bowling-ball",
    BOWLING_BALL_PIN = "bowling-ball-pin",
    BOWLING_PINS = "bowling-pins",
    BOX = "box",
    BOX_ARCHIVE = "box-archive",
    BOX_BALLOT = "box-ballot",
    BOX_CHECK = "box-check",
    BOX_CIRCLE_CHECK = "box-circle-check",
    BOX_DOLLAR = "box-dollar",
    BOX_HEART = "box-heart",
    BOX_OPEN = "box-open",
    BOX_OPEN_FULL = "box-open-full",
    BOX_TAPED = "box-taped",
    BOX_TISSUE = "box-tissue",
    BOXES_PACKING = "boxes-packing",
    BOXES_STACKED = "boxes-stacked",
    BOXING_GLOVE = "boxing-glove",
    BRACKET_CURLY = "bracket-curly",
    BRACKET_CURLY_RIGHT = "bracket-curly-right",
    BRACKET_ROUND = "bracket-round",
    BRACKET_ROUND_RIGHT = "bracket-round-right",
    BRACKET_SQUARE = "bracket-square",
    BRACKET_SQUARE_RIGHT = "bracket-square-right",
    BRACKETS_CURLY = "brackets-curly",
    BRACKETS_ROUND = "brackets-round",
    BRACKETS_SQUARE = "brackets-square",
    BRAILLE = "braille",
    BRAIN = "brain",
    BRAIN_ARROW_CURVED_RIGHT = "brain-arrow-curved-right",
    BRAIN_CIRCUIT = "brain-circuit",
    BRAKE_WARNING = "brake-warning",
    BRAZILIAN_REAL_SIGN = "brazilian-real-sign",
    BREAD_LOAF = "bread-loaf",
    BREAD_SLICE = "bread-slice",
    BREAD_SLICE_BUTTER = "bread-slice-butter",
    BRIDGE = "bridge",
    BRIDGE_CIRCLE_CHECK = "bridge-circle-check",
    BRIDGE_CIRCLE_EXCLAMATION = "bridge-circle-exclamation",
    BRIDGE_CIRCLE_XMARK = "bridge-circle-xmark",
    BRIDGE_LOCK = "bridge-lock",
    BRIDGE_SUSPENSION = "bridge-suspension",
    BRIDGE_WATER = "bridge-water",
    BRIEFCASE = "briefcase",
    BRIEFCASE_ARROW_RIGHT = "briefcase-arrow-right",
    BRIEFCASE_BLANK = "briefcase-blank",
    BRIEFCASE_MEDICAL = "briefcase-medical",
    BRIGHTNESS = "brightness",
    BRIGHTNESS_LOW = "brightness-low",
    BRING_FORWARD = "bring-forward",
    BRING_FRONT = "bring-front",
    BROCCOLI = "broccoli",
    BROOM = "broom",
    BROOM_BALL = "broom-ball",
    BROOM_WIDE = "broom-wide",
    BROWSER = "browser",
    BROWSERS = "browsers",
    BRUSH = "brush",
    BTC = "btc",
    BUCKET = "bucket",
    BUFFER = "buffer",
    BUG = "bug",
    BUG_SLASH = "bug-slash",
    BUGS = "bugs",
    BUILDING = "building",
    BUILDING_CIRCLE_ARROW_RIGHT = "building-circle-arrow-right",
    BUILDING_CIRCLE_CHECK = "building-circle-check",
    BUILDING_CIRCLE_EXCLAMATION = "building-circle-exclamation",
    BUILDING_CIRCLE_XMARK = "building-circle-xmark",
    BUILDING_COLUMNS = "building-columns",
    BUILDING_FLAG = "building-flag",
    BUILDING_LOCK = "building-lock",
    BUILDING_NGO = "building-ngo",
    BUILDING_SHIELD = "building-shield",
    BUILDING_UN = "building-un",
    BUILDING_USER = "building-user",
    BUILDING_WHEAT = "building-wheat",
    BUILDINGS = "buildings",
    BULLHORN = "bullhorn",
    BULLSEYE = "bullseye",
    BULLSEYE_ARROW = "bullseye-arrow",
    BULLSEYE_POINTER = "bullseye-pointer",
    BUOY = "buoy",
    BUOY_MOORING = "buoy-mooring",
    BURGER = "burger",
    BURGER_CHEESE = "burger-cheese",
    BURGER_FRIES = "burger-fries",
    BURGER_GLASS = "burger-glass",
    BURGER_LETTUCE = "burger-lettuce",
    BURGER_SODA = "burger-soda",
    BUROMOBELEXPERTE = "buromobelexperte",
    BURRITO = "burrito",
    BURST = "burst",
    BUS = "bus",
    BUS_SCHOOL = "bus-school",
    BUS_SIMPLE = "bus-simple",
    BUSINESS_TIME = "business-time",
    BUTTER = "butter",
    BUY_N_LARGE = "buy-n-large",
    BUYSELLADS = "buysellads",
    C = "c",
    CABIN = "cabin",
    CABINET_FILING = "cabinet-filing",
    CABLE_CAR = "cable-car",
    CACTUS = "cactus",
    CAKE_CANDLES = "cake-candles",
    CAKE_SLICE = "cake-slice",
    CALCULATOR = "calculator",
    CALCULATOR_SIMPLE = "calculator-simple",
    CALENDAR = "calendar",
    CALENDAR_ARROW_DOWN = "calendar-arrow-down",
    CALENDAR_ARROW_UP = "calendar-arrow-up",
    CALENDAR_CHECK = "calendar-check",
    CALENDAR_CIRCLE_EXCLAMATION = "calendar-circle-exclamation",
    CALENDAR_CIRCLE_MINUS = "calendar-circle-minus",
    CALENDAR_CIRCLE_PLUS = "calendar-circle-plus",
    CALENDAR_CIRCLE_USER = "calendar-circle-user",
    CALENDAR_CLOCK = "calendar-clock",
    CALENDAR_DAY = "calendar-day",
    CALENDAR_DAYS = "calendar-days",
    CALENDAR_EXCLAMATION = "calendar-exclamation",
    CALENDAR_HEART = "calendar-heart",
    CALENDAR_IMAGE = "calendar-image",
    CALENDAR_LINES = "calendar-lines",
    CALENDAR_LINES_PEN = "calendar-lines-pen",
    CALENDAR_MINUS = "calendar-minus",
    CALENDAR_PEN = "calendar-pen",
    CALENDAR_PLUS = "calendar-plus",
    CALENDAR_RANGE = "calendar-range",
    CALENDAR_STAR = "calendar-star",
    CALENDAR_USERS = "calendar-users",
    CALENDAR_WEEK = "calendar-week",
    CALENDAR_XMARK = "calendar-xmark",
    CALENDARS = "calendars",
    CAMCORDER = "camcorder",
    CAMERA = "camera",
    CAMERA_CCTV = "camera-cctv",
    CAMERA_MOVIE = "camera-movie",
    CAMERA_POLAROID = "camera-polaroid",
    CAMERA_RETRO = "camera-retro",
    CAMERA_ROTATE = "camera-rotate",
    CAMERA_SECURITY = "camera-security",
    CAMERA_SLASH = "camera-slash",
    CAMERA_VIEWFINDER = "camera-viewfinder",
    CAMERA_WEB = "camera-web",
    CAMERA_WEB_SLASH = "camera-web-slash",
    CAMPFIRE = "campfire",
    CAMPGROUND = "campground",
    CAN_FOOD = "can-food",
    CANADIAN_MAPLE_LEAF = "canadian-maple-leaf",
    CANDLE_HOLDER = "candle-holder",
    CANDY = "candy",
    CANDY_BAR = "candy-bar",
    CANDY_CANE = "candy-cane",
    CANDY_CORN = "candy-corn",
    CANNABIS = "cannabis",
    CAPSULES = "capsules",
    CAR = "car",
    CAR_BATTERY = "car-battery",
    CAR_BOLT = "car-bolt",
    CAR_BUILDING = "car-building",
    CAR_BUMP = "car-bump",
    CAR_BURST = "car-burst",
    CAR_BUS = "car-bus",
    CAR_CIRCLE_BOLT = "car-circle-bolt",
    CAR_GARAGE = "car-garage",
    CAR_MIRRORS = "car-mirrors",
    CAR_ON = "car-on",
    CAR_REAR = "car-rear",
    CAR_SIDE = "car-side",
    CAR_SIDE_BOLT = "car-side-bolt",
    CAR_TILT = "car-tilt",
    CAR_TUNNEL = "car-tunnel",
    CAR_WASH = "car-wash",
    CAR_WRENCH = "car-wrench",
    CARAVAN = "caravan",
    CARAVAN_SIMPLE = "caravan-simple",
    CARD_CLUB = "card-club",
    CARD_DIAMOND = "card-diamond",
    CARD_HEART = "card-heart",
    CARD_SPADE = "card-spade",
    CARDS = "cards",
    CARDS_BLANK = "cards-blank",
    CARET_DOWN = "caret-down",
    CARET_LEFT = "caret-left",
    CARET_RIGHT = "caret-right",
    CARET_UP = "caret-up",
    CARROT = "carrot",
    CARS = "cars",
    CART_ARROW_DOWN = "cart-arrow-down",
    CART_ARROW_UP = "cart-arrow-up",
    CART_CIRCLE_ARROW_DOWN = "cart-circle-arrow-down",
    CART_CIRCLE_ARROW_UP = "cart-circle-arrow-up",
    CART_CIRCLE_CHECK = "cart-circle-check",
    CART_CIRCLE_EXCLAMATION = "cart-circle-exclamation",
    CART_CIRCLE_PLUS = "cart-circle-plus",
    CART_CIRCLE_XMARK = "cart-circle-xmark",
    CART_FLATBED = "cart-flatbed",
    CART_FLATBED_BOXES = "cart-flatbed-boxes",
    CART_FLATBED_EMPTY = "cart-flatbed-empty",
    CART_FLATBED_SUITCASE = "cart-flatbed-suitcase",
    CART_MINUS = "cart-minus",
    CART_PLUS = "cart-plus",
    CART_SHOPPING = "cart-shopping",
    CART_SHOPPING_FAST = "cart-shopping-fast",
    CART_XMARK = "cart-xmark",
    CASH_REGISTER = "cash-register",
    CASSETTE_BETAMAX = "cassette-betamax",
    CASSETTE_TAPE = "cassette-tape",
    CASSETTE_VHS = "cassette-vhs",
    CASTLE = "castle",
    CAT = "cat",
    CAT_SPACE = "cat-space",
    CAULDRON = "cauldron",
    CC_AMAZON_PAY = "cc-amazon-pay",
    CC_AMEX = "cc-amex",
    CC_APPLE_PAY = "cc-apple-pay",
    CC_DINERS_CLUB = "cc-diners-club",
    CC_DISCOVER = "cc-discover",
    CC_JCB = "cc-jcb",
    CC_MASTERCARD = "cc-mastercard",
    CC_PAYPAL = "cc-paypal",
    CC_STRIPE = "cc-stripe",
    CC_VISA = "cc-visa",
    CEDI_SIGN = "cedi-sign",
    CENT_SIGN = "cent-sign",
    CENTERCODE = "centercode",
    CENTOS = "centos",
    CERTIFICATE = "certificate",
    CHAIR = "chair",
    CHAIR_OFFICE = "chair-office",
    CHALKBOARD = "chalkboard",
    CHALKBOARD_USER = "chalkboard-user",
    CHAMPAGNE_GLASS = "champagne-glass",
    CHAMPAGNE_GLASSES = "champagne-glasses",
    CHARGING_STATION = "charging-station",
    CHART_AREA = "chart-area",
    CHART_BAR = "chart-bar",
    CHART_BULLET = "chart-bullet",
    CHART_CANDLESTICK = "chart-candlestick",
    CHART_COLUMN = "chart-column",
    CHART_GANTT = "chart-gantt",
    CHART_LINE = "chart-line",
    CHART_LINE_DOWN = "chart-line-down",
    CHART_LINE_UP = "chart-line-up",
    CHART_LINE_UP_DOWN = "chart-line-up-down",
    CHART_MIXED = "chart-mixed",
    CHART_MIXED_UP_CIRCLE_CURRENCY = "chart-mixed-up-circle-currency",
    CHART_MIXED_UP_CIRCLE_DOLLAR = "chart-mixed-up-circle-dollar",
    CHART_NETWORK = "chart-network",
    CHART_PIE = "chart-pie",
    CHART_PIE_SIMPLE = "chart-pie-simple",
    CHART_PIE_SIMPLE_CIRCLE_CURRENCY = "chart-pie-simple-circle-currency",
    CHART_PIE_SIMPLE_CIRCLE_DOLLAR = "chart-pie-simple-circle-dollar",
    CHART_PYRAMID = "chart-pyramid",
    CHART_RADAR = "chart-radar",
    CHART_SCATTER = "chart-scatter",
    CHART_SCATTER_3D = "chart-scatter-3d",
    CHART_SCATTER_BUBBLE = "chart-scatter-bubble",
    CHART_SIMPLE = "chart-simple",
    CHART_SIMPLE_HORIZONTAL = "chart-simple-horizontal",
    CHART_TREE_MAP = "chart-tree-map",
    CHART_USER = "chart-user",
    CHART_WATERFALL = "chart-waterfall",
    CHECK = "check",
    CHECK_DOUBLE = "check-double",
    CHECK_TO_SLOT = "check-to-slot",
    CHEESE = "cheese",
    CHEESE_SWISS = "cheese-swiss",
    CHERRIES = "cherries",
    CHESS = "chess",
    CHESS_BISHOP = "chess-bishop",
    CHESS_BISHOP_PIECE = "chess-bishop-piece",
    CHESS_BOARD = "chess-board",
    CHESS_CLOCK = "chess-clock",
    CHESS_CLOCK_FLIP = "chess-clock-flip",
    CHESS_KING = "chess-king",
    CHESS_KING_PIECE = "chess-king-piece",
    CHESS_KNIGHT = "chess-knight",
    CHESS_KNIGHT_PIECE = "chess-knight-piece",
    CHESS_PAWN = "chess-pawn",
    CHESS_PAWN_PIECE = "chess-pawn-piece",
    CHESS_QUEEN = "chess-queen",
    CHESS_QUEEN_PIECE = "chess-queen-piece",
    CHESS_ROOK = "chess-rook",
    CHESS_ROOK_PIECE = "chess-rook-piece",
    CHESTNUT = "chestnut",
    CHEVRON_DOWN = "chevron-down",
    CHEVRON_LEFT = "chevron-left",
    CHEVRON_RIGHT = "chevron-right",
    CHEVRON_UP = "chevron-up",
    CHEVRONS_DOWN = "chevrons-down",
    CHEVRONS_LEFT = "chevrons-left",
    CHEVRONS_RIGHT = "chevrons-right",
    CHEVRONS_UP = "chevrons-up",
    CHF_SIGN = "chf-sign",
    CHILD = "child",
    CHILD_COMBATANT = "child-combatant",
    CHILD_DRESS = "child-dress",
    CHILD_REACHING = "child-reaching",
    CHILDREN = "children",
    CHIMNEY = "chimney",
    CHOPSTICKS = "chopsticks",
    CHROME = "chrome",
    CHROMECAST = "chromecast",
    CHURCH = "church",
    CIRCLE = "circle",
    CIRCLE_0 = "circle-0",
    CIRCLE_1 = "circle-1",
    CIRCLE_2 = "circle-2",
    CIRCLE_3 = "circle-3",
    CIRCLE_4 = "circle-4",
    CIRCLE_5 = "circle-5",
    CIRCLE_6 = "circle-6",
    CIRCLE_7 = "circle-7",
    CIRCLE_8 = "circle-8",
    CIRCLE_9 = "circle-9",
    CIRCLE_A = "circle-a",
    CIRCLE_AMPERSAND = "circle-ampersand",
    CIRCLE_ARROW_DOWN = "circle-arrow-down",
    CIRCLE_ARROW_DOWN_LEFT = "circle-arrow-down-left",
    CIRCLE_ARROW_DOWN_RIGHT = "circle-arrow-down-right",
    CIRCLE_ARROW_LEFT = "circle-arrow-left",
    CIRCLE_ARROW_RIGHT = "circle-arrow-right",
    CIRCLE_ARROW_UP = "circle-arrow-up",
    CIRCLE_ARROW_UP_LEFT = "circle-arrow-up-left",
    CIRCLE_ARROW_UP_RIGHT = "circle-arrow-up-right",
    CIRCLE_B = "circle-b",
    CIRCLE_BOLT = "circle-bolt",
    CIRCLE_BOOK_OPEN = "circle-book-open",
    CIRCLE_BOOKMARK = "circle-bookmark",
    CIRCLE_C = "circle-c",
    CIRCLE_CALENDAR = "circle-calendar",
    CIRCLE_CAMERA = "circle-camera",
    CIRCLE_CARET_DOWN = "circle-caret-down",
    CIRCLE_CARET_LEFT = "circle-caret-left",
    CIRCLE_CARET_RIGHT = "circle-caret-right",
    CIRCLE_CARET_UP = "circle-caret-up",
    CIRCLE_CHECK = "circle-check",
    CIRCLE_CHEVRON_DOWN = "circle-chevron-down",
    CIRCLE_CHEVRON_LEFT = "circle-chevron-left",
    CIRCLE_CHEVRON_RIGHT = "circle-chevron-right",
    CIRCLE_CHEVRON_UP = "circle-chevron-up",
    CIRCLE_D = "circle-d",
    CIRCLE_DASHED = "circle-dashed",
    CIRCLE_DIVIDE = "circle-divide",
    CIRCLE_DOLLAR = "circle-dollar",
    CIRCLE_DOLLAR_TO_SLOT = "circle-dollar-to-slot",
    CIRCLE_DOT = "circle-dot",
    CIRCLE_DOWN = "circle-down",
    CIRCLE_DOWN_LEFT = "circle-down-left",
    CIRCLE_DOWN_RIGHT = "circle-down-right",
    CIRCLE_E = "circle-e",
    CIRCLE_ELLIPSIS = "circle-ellipsis",
    CIRCLE_ELLIPSIS_VERTICAL = "circle-ellipsis-vertical",
    CIRCLE_ENVELOPE = "circle-envelope",
    CIRCLE_EURO = "circle-euro",
    CIRCLE_EXCLAMATION = "circle-exclamation",
    CIRCLE_EXCLAMATION_CHECK = "circle-exclamation-check",
    CIRCLE_F = "circle-f",
    CIRCLE_G = "circle-g",
    CIRCLE_H = "circle-h",
    CIRCLE_HALF = "circle-half",
    CIRCLE_HALF_STROKE = "circle-half-stroke",
    CIRCLE_HEART = "circle-heart",
    CIRCLE_I = "circle-i",
    CIRCLE_INFO = "circle-info",
    CIRCLE_J = "circle-j",
    CIRCLE_K = "circle-k",
    CIRCLE_L = "circle-l",
    CIRCLE_LEFT = "circle-left",
    CIRCLE_LOCATION_ARROW = "circle-location-arrow",
    CIRCLE_M = "circle-m",
    CIRCLE_MICROPHONE = "circle-microphone",
    CIRCLE_MICROPHONE_LINES = "circle-microphone-lines",
    CIRCLE_MINUS = "circle-minus",
    CIRCLE_N = "circle-n",
    CIRCLE_NODES = "circle-nodes",
    CIRCLE_NOTCH = "circle-notch",
    CIRCLE_O = "circle-o",
    CIRCLE_P = "circle-p",
    CIRCLE_PARKING = "circle-parking",
    CIRCLE_PAUSE = "circle-pause",
    CIRCLE_PHONE = "circle-phone",
    CIRCLE_PHONE_FLIP = "circle-phone-flip",
    CIRCLE_PHONE_HANGUP = "circle-phone-hangup",
    CIRCLE_PLAY = "circle-play",
    CIRCLE_PLUS = "circle-plus",
    CIRCLE_Q = "circle-q",
    CIRCLE_QUARTER = "circle-quarter",
    CIRCLE_QUARTER_STROKE = "circle-quarter-stroke",
    CIRCLE_QUARTERS = "circle-quarters",
    CIRCLE_QUESTION = "circle-question",
    CIRCLE_R = "circle-r",
    CIRCLE_RADIATION = "circle-radiation",
    CIRCLE_RIGHT = "circle-right",
    CIRCLE_S = "circle-s",
    CIRCLE_SMALL = "circle-small",
    CIRCLE_SORT = "circle-sort",
    CIRCLE_SORT_DOWN = "circle-sort-down",
    CIRCLE_SORT_UP = "circle-sort-up",
    CIRCLE_STAR = "circle-star",
    CIRCLE_STERLING = "circle-sterling",
    CIRCLE_STOP = "circle-stop",
    CIRCLE_T = "circle-t",
    CIRCLE_THREE_QUARTERS = "circle-three-quarters",
    CIRCLE_THREE_QUARTERS_STROKE = "circle-three-quarters-stroke",
    CIRCLE_TRASH = "circle-trash",
    CIRCLE_U = "circle-u",
    CIRCLE_UP = "circle-up",
    CIRCLE_UP_LEFT = "circle-up-left",
    CIRCLE_UP_RIGHT = "circle-up-right",
    CIRCLE_USER = "circle-user",
    CIRCLE_V = "circle-v",
    CIRCLE_VIDEO = "circle-video",
    CIRCLE_W = "circle-w",
    CIRCLE_WAVEFORM_LINES = "circle-waveform-lines",
    CIRCLE_X = "circle-x",
    CIRCLE_XMARK = "circle-xmark",
    CIRCLE_Y = "circle-y",
    CIRCLE_YEN = "circle-yen",
    CIRCLE_Z = "circle-z",
    CIRCLES_OVERLAP = "circles-overlap",
    CITRUS = "citrus",
    CITRUS_SLICE = "citrus-slice",
    CITY = "city",
    CLAPPERBOARD = "clapperboard",
    CLAPPERBOARD_PLAY = "clapperboard-play",
    CLARINET = "clarinet",
    CLAW_MARKS = "claw-marks",
    CLIPBOARD = "clipboard",
    CLIPBOARD_CHECK = "clipboard-check",
    CLIPBOARD_LIST = "clipboard-list",
    CLIPBOARD_LIST_CHECK = "clipboard-list-check",
    CLIPBOARD_MEDICAL = "clipboard-medical",
    CLIPBOARD_PRESCRIPTION = "clipboard-prescription",
    CLIPBOARD_QUESTION = "clipboard-question",
    CLIPBOARD_USER = "clipboard-user",
    CLOCK = "clock",
    CLOCK_DESK = "clock-desk",
    CLOCK_EIGHT = "clock-eight",
    CLOCK_EIGHT_THIRTY = "clock-eight-thirty",
    CLOCK_ELEVEN = "clock-eleven",
    CLOCK_ELEVEN_THIRTY = "clock-eleven-thirty",
    CLOCK_FIVE = "clock-five",
    CLOCK_FIVE_THIRTY = "clock-five-thirty",
    CLOCK_FOUR_THIRTY = "clock-four-thirty",
    CLOCK_NINE = "clock-nine",
    CLOCK_NINE_THIRTY = "clock-nine-thirty",
    CLOCK_ONE = "clock-one",
    CLOCK_ONE_THIRTY = "clock-one-thirty",
    CLOCK_ROTATE_LEFT = "clock-rotate-left",
    CLOCK_SEVEN = "clock-seven",
    CLOCK_SEVEN_THIRTY = "clock-seven-thirty",
    CLOCK_SIX = "clock-six",
    CLOCK_SIX_THIRTY = "clock-six-thirty",
    CLOCK_TEN = "clock-ten",
    CLOCK_TEN_THIRTY = "clock-ten-thirty",
    CLOCK_THREE = "clock-three",
    CLOCK_THREE_THIRTY = "clock-three-thirty",
    CLOCK_TWELVE = "clock-twelve",
    CLOCK_TWELVE_THIRTY = "clock-twelve-thirty",
    CLOCK_TWO = "clock-two",
    CLOCK_TWO_THIRTY = "clock-two-thirty",
    CLONE = "clone",
    CLOSED_CAPTIONING = "closed-captioning",
    CLOSED_CAPTIONING_SLASH = "closed-captioning-slash",
    CLOTHES_HANGER = "clothes-hanger",
    CLOUD = "cloud",
    CLOUD_ARROW_DOWN = "cloud-arrow-down",
    CLOUD_ARROW_UP = "cloud-arrow-up",
    CLOUD_BINARY = "cloud-binary",
    CLOUD_BOLT = "cloud-bolt",
    CLOUD_BOLT_MOON = "cloud-bolt-moon",
    CLOUD_BOLT_SUN = "cloud-bolt-sun",
    CLOUD_CHECK = "cloud-check",
    CLOUD_DRIZZLE = "cloud-drizzle",
    CLOUD_EXCLAMATION = "cloud-exclamation",
    CLOUD_FOG = "cloud-fog",
    CLOUD_HAIL = "cloud-hail",
    CLOUD_HAIL_MIXED = "cloud-hail-mixed",
    CLOUD_MEATBALL = "cloud-meatball",
    CLOUD_MINUS = "cloud-minus",
    CLOUD_MOON = "cloud-moon",
    CLOUD_MOON_RAIN = "cloud-moon-rain",
    CLOUD_MUSIC = "cloud-music",
    CLOUD_PLUS = "cloud-plus",
    CLOUD_QUESTION = "cloud-question",
    CLOUD_RAIN = "cloud-rain",
    CLOUD_RAINBOW = "cloud-rainbow",
    CLOUD_SHOWERS = "cloud-showers",
    CLOUD_SHOWERS_HEAVY = "cloud-showers-heavy",
    CLOUD_SHOWERS_WATER = "cloud-showers-water",
    CLOUD_SLASH = "cloud-slash",
    CLOUD_SLEET = "cloud-sleet",
    CLOUD_SNOW = "cloud-snow",
    CLOUD_SUN = "cloud-sun",
    CLOUD_SUN_RAIN = "cloud-sun-rain",
    CLOUD_WORD = "cloud-word",
    CLOUD_XMARK = "cloud-xmark",
    CLOUDFLARE = "cloudflare",
    CLOUDS = "clouds",
    CLOUDS_MOON = "clouds-moon",
    CLOUDS_SUN = "clouds-sun",
    CLOUDSCALE = "cloudscale",
    CLOUDSMITH = "cloudsmith",
    CLOUDVERSIFY = "cloudversify",
    CLOVER = "clover",
    CLUB = "club",
    CMPLID = "cmplid",
    COCONUT = "coconut",
    CODE = "code",
    CODE_BRANCH = "code-branch",
    CODE_COMMIT = "code-commit",
    CODE_COMPARE = "code-compare",
    CODE_FORK = "code-fork",
    CODE_MERGE = "code-merge",
    CODE_PULL_REQUEST = "code-pull-request",
    CODE_PULL_REQUEST_CLOSED = "code-pull-request-closed",
    CODE_PULL_REQUEST_DRAFT = "code-pull-request-draft",
    CODE_SIMPLE = "code-simple",
    CODEPEN = "codepen",
    CODIEPIE = "codiepie",
    COFFEE_BEAN = "coffee-bean",
    COFFEE_BEANS = "coffee-beans",
    COFFEE_POT = "coffee-pot",
    COFFIN = "coffin",
    COFFIN_CROSS = "coffin-cross",
    COIN = "coin",
    COIN_BLANK = "coin-blank",
    COIN_FRONT = "coin-front",
    COIN_VERTICAL = "coin-vertical",
    COINS = "coins",
    COLON = "colon",
    COLON_SIGN = "colon-sign",
    COLUMNS_3 = "columns-3",
    COMET = "comet",
    COMMA = "comma",
    COMMAND = "command",
    COMMENT = "comment",
    COMMENT_ARROW_DOWN = "comment-arrow-down",
    COMMENT_ARROW_UP = "comment-arrow-up",
    COMMENT_ARROW_UP_RIGHT = "comment-arrow-up-right",
    COMMENT_CAPTIONS = "comment-captions",
    COMMENT_CHECK = "comment-check",
    COMMENT_CODE = "comment-code",
    COMMENT_DOLLAR = "comment-dollar",
    COMMENT_DOTS = "comment-dots",
    COMMENT_EXCLAMATION = "comment-exclamation",
    COMMENT_HEART = "comment-heart",
    COMMENT_IMAGE = "comment-image",
    COMMENT_LINES = "comment-lines",
    COMMENT_MEDICAL = "comment-medical",
    COMMENT_MIDDLE = "comment-middle",
    COMMENT_MIDDLE_TOP = "comment-middle-top",
    COMMENT_MINUS = "comment-minus",
    COMMENT_MUSIC = "comment-music",
    COMMENT_PEN = "comment-pen",
    COMMENT_PLUS = "comment-plus",
    COMMENT_QUESTION = "comment-question",
    COMMENT_QUOTE = "comment-quote",
    COMMENT_SLASH = "comment-slash",
    COMMENT_SMILE = "comment-smile",
    COMMENT_SMS = "comment-sms",
    COMMENT_TEXT = "comment-text",
    COMMENT_XMARK = "comment-xmark",
    COMMENTS = "comments",
    COMMENTS_DOLLAR = "comments-dollar",
    COMMENTS_QUESTION = "comments-question",
    COMMENTS_QUESTION_CHECK = "comments-question-check",
    COMPACT_DISC = "compact-disc",
    COMPASS = "compass",
    COMPASS_DRAFTING = "compass-drafting",
    COMPASS_SLASH = "compass-slash",
    COMPRESS = "compress",
    COMPRESS_WIDE = "compress-wide",
    COMPUTER = "computer",
    COMPUTER_CLASSIC = "computer-classic",
    COMPUTER_MOUSE = "computer-mouse",
    COMPUTER_MOUSE_SCROLLWHEEL = "computer-mouse-scrollwheel",
    COMPUTER_SPEAKER = "computer-speaker",
    CONFLUENCE = "confluence",
    CONNECTDEVELOP = "connectdevelop",
    CONTAINER_STORAGE = "container-storage",
    CONTAO = "contao",
    CONVEYOR_BELT = "conveyor-belt",
    CONVEYOR_BELT_ARM = "conveyor-belt-arm",
    CONVEYOR_BELT_BOXES = "conveyor-belt-boxes",
    CONVEYOR_BELT_EMPTY = "conveyor-belt-empty",
    COOKIE = "cookie",
    COOKIE_BITE = "cookie-bite",
    COPY = "copy",
    COPYRIGHT = "copyright",
    CORN = "corn",
    CORNER = "corner",
    COTTON_BUREAU = "cotton-bureau",
    COUCH = "couch",
    COW = "cow",
    COWBELL = "cowbell",
    COWBELL_CIRCLE_PLUS = "cowbell-circle-plus",
    CPANEL = "cpanel",
    CRAB = "crab",
    CRATE_APPLE = "crate-apple",
    CRATE_EMPTY = "crate-empty",
    CREATIVE_COMMONS = "creative-commons",
    CREATIVE_COMMONS_BY = "creative-commons-by",
    CREATIVE_COMMONS_NC = "creative-commons-nc",
    CREATIVE_COMMONS_NC_EU = "creative-commons-nc-eu",
    CREATIVE_COMMONS_NC_JP = "creative-commons-nc-jp",
    CREATIVE_COMMONS_ND = "creative-commons-nd",
    CREATIVE_COMMONS_PD = "creative-commons-pd",
    CREATIVE_COMMONS_PD_ALT = "creative-commons-pd-alt",
    CREATIVE_COMMONS_REMIX = "creative-commons-remix",
    CREATIVE_COMMONS_SA = "creative-commons-sa",
    CREATIVE_COMMONS_SAMPLING = "creative-commons-sampling",
    CREATIVE_COMMONS_SAMPLING_PLUS = "creative-commons-sampling-plus",
    CREATIVE_COMMONS_SHARE = "creative-commons-share",
    CREATIVE_COMMONS_ZERO = "creative-commons-zero",
    CREDIT_CARD = "credit-card",
    CREDIT_CARD_BLANK = "credit-card-blank",
    CREDIT_CARD_FRONT = "credit-card-front",
    CRICKET_BAT_BALL = "cricket-bat-ball",
    CRITICAL_ROLE = "critical-role",
    CROISSANT = "croissant",
    CROP = "crop",
    CROP_SIMPLE = "crop-simple",
    CROSS = "cross",
    CROSSHAIRS = "crosshairs",
    CROSSHAIRS_SIMPLE = "crosshairs-simple",
    CROW = "crow",
    CROWN = "crown",
    CRUTCH = "crutch",
    CRUTCHES = "crutches",
    CRUZEIRO_SIGN = "cruzeiro-sign",
    CRYSTAL_BALL = "crystal-ball",
    CSS3 = "css3",
    CSS3_ALT = "css3-alt",
    CUBE = "cube",
    CUBES = "cubes",
    CUBES_STACKED = "cubes-stacked",
    CUCUMBER = "cucumber",
    CUP_STRAW = "cup-straw",
    CUP_STRAW_SWOOSH = "cup-straw-swoosh",
    CUP_TOGO = "cup-togo",
    CUPCAKE = "cupcake",
    CURLING_STONE = "curling-stone",
    CUSTARD = "custard",
    CUTTLEFISH = "cuttlefish",
    D = "d",
    D_AND_D = "d-and-d",
    D_AND_D_BEYOND = "d-and-d-beyond",
    DAGGER = "dagger",
    DAILYMOTION = "dailymotion",
    DASH = "dash",
    DASHCUBE = "dashcube",
    DATABASE = "database",
    DEBIAN = "debian",
    DEER = "deer",
    DEER_RUDOLPH = "deer-rudolph",
    DEEZER = "deezer",
    DELETE_LEFT = "delete-left",
    DELETE_RIGHT = "delete-right",
    DELICIOUS = "delicious",
    DEMOCRAT = "democrat",
    DEPLOYDOG = "deploydog",
    DESKPRO = "deskpro",
    DESKTOP = "desktop",
    DESKTOP_ARROW_DOWN = "desktop-arrow-down",
    DEV = "dev",
    DEVIANTART = "deviantart",
    DHARMACHAKRA = "dharmachakra",
    DHL = "dhl",
    DIAGRAM_CELLS = "diagram-cells",
    DIAGRAM_LEAN_CANVAS = "diagram-lean-canvas",
    DIAGRAM_NESTED = "diagram-nested",
    DIAGRAM_NEXT = "diagram-next",
    DIAGRAM_PREDECESSOR = "diagram-predecessor",
    DIAGRAM_PREVIOUS = "diagram-previous",
    DIAGRAM_PROJECT = "diagram-project",
    DIAGRAM_SANKEY = "diagram-sankey",
    DIAGRAM_SUBTASK = "diagram-subtask",
    DIAGRAM_SUCCESSOR = "diagram-successor",
    DIAGRAM_VENN = "diagram-venn",
    DIAL = "dial",
    DIAL_HIGH = "dial-high",
    DIAL_LOW = "dial-low",
    DIAL_MAX = "dial-max",
    DIAL_MED = "dial-med",
    DIAL_MED_LOW = "dial-med-low",
    DIAL_MIN = "dial-min",
    DIAL_OFF = "dial-off",
    DIAMOND = "diamond",
    DIAMOND_EXCLAMATION = "diamond-exclamation",
    DIAMOND_HALF = "diamond-half",
    DIAMOND_HALF_STROKE = "diamond-half-stroke",
    DIAMOND_TURN_RIGHT = "diamond-turn-right",
    DIASPORA = "diaspora",
    DICE = "dice",
    DICE_D10 = "dice-d10",
    DICE_D12 = "dice-d12",
    DICE_D20 = "dice-d20",
    DICE_D4 = "dice-d4",
    DICE_D6 = "dice-d6",
    DICE_D8 = "dice-d8",
    DICE_FIVE = "dice-five",
    DICE_FOUR = "dice-four",
    DICE_ONE = "dice-one",
    DICE_SIX = "dice-six",
    DICE_THREE = "dice-three",
    DICE_TWO = "dice-two",
    DIGG = "digg",
    DIGITAL_OCEAN = "digital-ocean",
    DINOSAUR = "dinosaur",
    DIPLOMA = "diploma",
    DISC_DRIVE = "disc-drive",
    DISCORD = "discord",
    DISCOURSE = "discourse",
    DISEASE = "disease",
    DISPLAY = "display",
    DISPLAY_ARROW_DOWN = "display-arrow-down",
    DISPLAY_CHART_UP = "display-chart-up",
    DISPLAY_CHART_UP_CIRCLE_CURRENCY = "display-chart-up-circle-currency",
    DISPLAY_CHART_UP_CIRCLE_DOLLAR = "display-chart-up-circle-dollar",
    DISPLAY_CODE = "display-code",
    DISPLAY_MEDICAL = "display-medical",
    DISPLAY_SLASH = "display-slash",
    DISTRIBUTE_SPACING_HORIZONTAL = "distribute-spacing-horizontal",
    DISTRIBUTE_SPACING_VERTICAL = "distribute-spacing-vertical",
    DITTO = "ditto",
    DIVIDE = "divide",
    DNA = "dna",
    DO_NOT_ENTER = "do-not-enter",
    DOCHUB = "dochub",
    DOCKER = "docker",
    DOG = "dog",
    DOG_LEASHED = "dog-leashed",
    DOLLAR_SIGN = "dollar-sign",
    DOLLY = "dolly",
    DOLLY_EMPTY = "dolly-empty",
    DOLPHIN = "dolphin",
    DONG_SIGN = "dong-sign",
    DONUT = "donut",
    DOOR_CLOSED = "door-closed",
    DOOR_OPEN = "door-open",
    DOVE = "dove",
    DOWN = "down",
    DOWN_FROM_DOTTED_LINE = "down-from-dotted-line",
    DOWN_FROM_LINE = "down-from-line",
    DOWN_LEFT = "down-left",
    DOWN_LEFT_AND_UP_RIGHT_TO_CENTER = "down-left-and-up-right-to-center",
    DOWN_LONG = "down-long",
    DOWN_RIGHT = "down-right",
    DOWN_TO_BRACKET = "down-to-bracket",
    DOWN_TO_DOTTED_LINE = "down-to-dotted-line",
    DOWN_TO_LINE = "down-to-line",
    DOWNLOAD = "download",
    DRAFT2DIGITAL = "draft2digital",
    DRAGON = "dragon",
    DRAW_CIRCLE = "draw-circle",
    DRAW_POLYGON = "draw-polygon",
    DRAW_SQUARE = "draw-square",
    DREIDEL = "dreidel",
    DRIBBBLE = "dribbble",
    DRONE = "drone",
    DRONE_FRONT = "drone-front",
    DROPBOX = "dropbox",
    DROPLET = "droplet",
    DROPLET_DEGREE = "droplet-degree",
    DROPLET_PERCENT = "droplet-percent",
    DROPLET_SLASH = "droplet-slash",
    DRUM = "drum",
    DRUM_STEELPAN = "drum-steelpan",
    DRUMSTICK = "drumstick",
    DRUMSTICK_BITE = "drumstick-bite",
    DRUPAL = "drupal",
    DRYER = "dryer",
    DRYER_HEAT = "dryer-heat",
    DUCK = "duck",
    DUMBBELL = "dumbbell",
    DUMPSTER = "dumpster",
    DUMPSTER_FIRE = "dumpster-fire",
    DUNGEON = "dungeon",
    DYALOG = "dyalog",
    E = "e",
    EAR = "ear",
    EAR_DEAF = "ear-deaf",
    EAR_LISTEN = "ear-listen",
    EAR_MUFFS = "ear-muffs",
    EARLYBIRDS = "earlybirds",
    EARTH_AFRICA = "earth-africa",
    EARTH_AMERICAS = "earth-americas",
    EARTH_ASIA = "earth-asia",
    EARTH_EUROPE = "earth-europe",
    EARTH_OCEANIA = "earth-oceania",
    EBAY = "ebay",
    ECLIPSE = "eclipse",
    EDGE = "edge",
    EDGE_LEGACY = "edge-legacy",
    EGG = "egg",
    EGG_FRIED = "egg-fried",
    EGGPLANT = "eggplant",
    EJECT = "eject",
    ELEMENTOR = "elementor",
    ELEPHANT = "elephant",
    ELEVATOR = "elevator",
    ELLIPSIS = "ellipsis",
    ELLIPSIS_STROKE = "ellipsis-stroke",
    ELLIPSIS_STROKE_VERTICAL = "ellipsis-stroke-vertical",
    ELLIPSIS_VERTICAL = "ellipsis-vertical",
    ELLO = "ello",
    EMBER = "ember",
    EMPIRE = "empire",
    EMPTY_SET = "empty-set",
    ENGINE = "engine",
    ENGINE_WARNING = "engine-warning",
    ENVELOPE = "envelope",
    ENVELOPE_CIRCLE_CHECK = "envelope-circle-check",
    ENVELOPE_DOT = "envelope-dot",
    ENVELOPE_OPEN = "envelope-open",
    ENVELOPE_OPEN_DOLLAR = "envelope-open-dollar",
    ENVELOPE_OPEN_TEXT = "envelope-open-text",
    ENVELOPES = "envelopes",
    ENVELOPES_BULK = "envelopes-bulk",
    ENVIRA = "envira",
    EQUALS = "equals",
    ERASER = "eraser",
    ERLANG = "erlang",
    ESCALATOR = "escalator",
    ETHEREUM = "ethereum",
    ETHERNET = "ethernet",
    ETSY = "etsy",
    EURO_SIGN = "euro-sign",
    EVERNOTE = "evernote",
    EXCLAMATION = "exclamation",
    EXPAND = "expand",
    EXPAND_WIDE = "expand-wide",
    EXPEDITEDSSL = "expeditedssl",
    EXPLOSION = "explosion",
    EYE = "eye",
    EYE_DROPPER = "eye-dropper",
    EYE_DROPPER_FULL = "eye-dropper-full",
    EYE_DROPPER_HALF = "eye-dropper-half",
    EYE_EVIL = "eye-evil",
    EYE_LOW_VISION = "eye-low-vision",
    EYE_SLASH = "eye-slash",
    EYES = "eyes",
    F = "f",
    FACE_ANGRY = "face-angry",
    FACE_ANGRY_HORNS = "face-angry-horns",
    FACE_ANGUISHED = "face-anguished",
    FACE_ANXIOUS_SWEAT = "face-anxious-sweat",
    FACE_ASTONISHED = "face-astonished",
    FACE_AWESOME = "face-awesome",
    FACE_BEAM_HAND_OVER_MOUTH = "face-beam-hand-over-mouth",
    FACE_CLOUDS = "face-clouds",
    FACE_CONFOUNDED = "face-confounded",
    FACE_CONFUSED = "face-confused",
    FACE_COWBOY_HAT = "face-cowboy-hat",
    FACE_DIAGONAL_MOUTH = "face-diagonal-mouth",
    FACE_DISAPPOINTED = "face-disappointed",
    FACE_DISGUISE = "face-disguise",
    FACE_DIZZY = "face-dizzy",
    FACE_DOTTED = "face-dotted",
    FACE_DOWNCAST_SWEAT = "face-downcast-sweat",
    FACE_DROOLING = "face-drooling",
    FACE_EXHALING = "face-exhaling",
    FACE_EXPLODE = "face-explode",
    FACE_EXPRESSIONLESS = "face-expressionless",
    FACE_EYES_XMARKS = "face-eyes-xmarks",
    FACE_FEARFUL = "face-fearful",
    FACE_FLUSHED = "face-flushed",
    FACE_FROWN = "face-frown",
    FACE_FROWN_OPEN = "face-frown-open",
    FACE_FROWN_SLIGHT = "face-frown-slight",
    FACE_GLASSES = "face-glasses",
    FACE_GRIMACE = "face-grimace",
    FACE_GRIN = "face-grin",
    FACE_GRIN_BEAM = "face-grin-beam",
    FACE_GRIN_BEAM_SWEAT = "face-grin-beam-sweat",
    FACE_GRIN_HEARTS = "face-grin-hearts",
    FACE_GRIN_SQUINT = "face-grin-squint",
    FACE_GRIN_SQUINT_TEARS = "face-grin-squint-tears",
    FACE_GRIN_STARS = "face-grin-stars",
    FACE_GRIN_TEARS = "face-grin-tears",
    FACE_GRIN_TONGUE = "face-grin-tongue",
    FACE_GRIN_TONGUE_SQUINT = "face-grin-tongue-squint",
    FACE_GRIN_TONGUE_WINK = "face-grin-tongue-wink",
    FACE_GRIN_WIDE = "face-grin-wide",
    FACE_GRIN_WINK = "face-grin-wink",
    FACE_HAND_OVER_MOUTH = "face-hand-over-mouth",
    FACE_HAND_PEEKING = "face-hand-peeking",
    FACE_HAND_YAWN = "face-hand-yawn",
    FACE_HEAD_BANDAGE = "face-head-bandage",
    FACE_HOLDING_BACK_TEARS = "face-holding-back-tears",
    FACE_HUSHED = "face-hushed",
    FACE_ICICLES = "face-icicles",
    FACE_KISS = "face-kiss",
    FACE_KISS_BEAM = "face-kiss-beam",
    FACE_KISS_CLOSED_EYES = "face-kiss-closed-eyes",
    FACE_KISS_WINK_HEART = "face-kiss-wink-heart",
    FACE_LAUGH = "face-laugh",
    FACE_LAUGH_BEAM = "face-laugh-beam",
    FACE_LAUGH_SQUINT = "face-laugh-squint",
    FACE_LAUGH_WINK = "face-laugh-wink",
    FACE_LYING = "face-lying",
    FACE_MASK = "face-mask",
    FACE_MEH = "face-meh",
    FACE_MEH_BLANK = "face-meh-blank",
    FACE_MELTING = "face-melting",
    FACE_MONOCLE = "face-monocle",
    FACE_NAUSEATED = "face-nauseated",
    FACE_NOSE_STEAM = "face-nose-steam",
    FACE_PARTY = "face-party",
    FACE_PENSIVE = "face-pensive",
    FACE_PERSEVERING = "face-persevering",
    FACE_PLEADING = "face-pleading",
    FACE_POUTING = "face-pouting",
    FACE_RAISED_EYEBROW = "face-raised-eyebrow",
    FACE_RELIEVED = "face-relieved",
    FACE_ROLLING_EYES = "face-rolling-eyes",
    FACE_SAD_CRY = "face-sad-cry",
    FACE_SAD_SWEAT = "face-sad-sweat",
    FACE_SAD_TEAR = "face-sad-tear",
    FACE_SALUTING = "face-saluting",
    FACE_SCREAM = "face-scream",
    FACE_SHUSH = "face-shush",
    FACE_SLEEPING = "face-sleeping",
    FACE_SLEEPY = "face-sleepy",
    FACE_SMILE = "face-smile",
    FACE_SMILE_BEAM = "face-smile-beam",
    FACE_SMILE_HALO = "face-smile-halo",
    FACE_SMILE_HEARTS = "face-smile-hearts",
    FACE_SMILE_HORNS = "face-smile-horns",
    FACE_SMILE_PLUS = "face-smile-plus",
    FACE_SMILE_RELAXED = "face-smile-relaxed",
    FACE_SMILE_TEAR = "face-smile-tear",
    FACE_SMILE_TONGUE = "face-smile-tongue",
    FACE_SMILE_UPSIDE_DOWN = "face-smile-upside-down",
    FACE_SMILE_WINK = "face-smile-wink",
    FACE_SMILING_HANDS = "face-smiling-hands",
    FACE_SMIRKING = "face-smirking",
    FACE_SPIRAL_EYES = "face-spiral-eyes",
    FACE_SUNGLASSES = "face-sunglasses",
    FACE_SURPRISE = "face-surprise",
    FACE_SWEAR = "face-swear",
    FACE_THERMOMETER = "face-thermometer",
    FACE_THINKING = "face-thinking",
    FACE_TIRED = "face-tired",
    FACE_TISSUE = "face-tissue",
    FACE_TONGUE_MONEY = "face-tongue-money",
    FACE_TONGUE_SWEAT = "face-tongue-sweat",
    FACE_UNAMUSED = "face-unamused",
    FACE_VIEWFINDER = "face-viewfinder",
    FACE_VOMIT = "face-vomit",
    FACE_WEARY = "face-weary",
    FACE_WOOZY = "face-woozy",
    FACE_WORRIED = "face-worried",
    FACE_ZANY = "face-zany",
    FACE_ZIPPER = "face-zipper",
    FACEBOOK = "facebook",
    FACEBOOK_F = "facebook-f",
    FACEBOOK_MESSENGER = "facebook-messenger",
    FALAFEL = "falafel",
    FAMILY = "family",
    FAMILY_DRESS = "family-dress",
    FAMILY_PANTS = "family-pants",
    FAN = "fan",
    FAN_TABLE = "fan-table",
    FANTASY_FLIGHT_GAMES = "fantasy-flight-games",
    FARM = "farm",
    FAUCET = "faucet",
    FAUCET_DRIP = "faucet-drip",
    FAX = "fax",
    FEATHER = "feather",
    FEATHER_POINTED = "feather-pointed",
    FEDEX = "fedex",
    FEDORA = "fedora",
    FENCE = "fence",
    FERRIS_WHEEL = "ferris-wheel",
    FERRY = "ferry",
    FIELD_HOCKEY_STICK_BALL = "field-hockey-stick-ball",
    FIGMA = "figma",
    FILE = "file",
    FILE_ARROW_DOWN = "file-arrow-down",
    FILE_ARROW_UP = "file-arrow-up",
    FILE_AUDIO = "file-audio",
    FILE_BINARY = "file-binary",
    FILE_CERTIFICATE = "file-certificate",
    FILE_CHART_COLUMN = "file-chart-column",
    FILE_CHART_PIE = "file-chart-pie",
    FILE_CHECK = "file-check",
    FILE_CIRCLE_CHECK = "file-circle-check",
    FILE_CIRCLE_EXCLAMATION = "file-circle-exclamation",
    FILE_CIRCLE_INFO = "file-circle-info",
    FILE_CIRCLE_MINUS = "file-circle-minus",
    FILE_CIRCLE_PLUS = "file-circle-plus",
    FILE_CIRCLE_QUESTION = "file-circle-question",
    FILE_CIRCLE_XMARK = "file-circle-xmark",
    FILE_CODE = "file-code",
    FILE_CONTRACT = "file-contract",
    FILE_CSV = "file-csv",
    FILE_DASHED_LINE = "file-dashed-line",
    FILE_DOC = "file-doc",
    FILE_EXCEL = "file-excel",
    FILE_EXCLAMATION = "file-exclamation",
    FILE_EXPORT = "file-export",
    FILE_HEART = "file-heart",
    FILE_IMAGE = "file-image",
    FILE_IMPORT = "file-import",
    FILE_INVOICE = "file-invoice",
    FILE_INVOICE_DOLLAR = "file-invoice-dollar",
    FILE_LINES = "file-lines",
    FILE_LOCK = "file-lock",
    FILE_MAGNIFYING_GLASS = "file-magnifying-glass",
    FILE_MEDICAL = "file-medical",
    FILE_MINUS = "file-minus",
    FILE_MUSIC = "file-music",
    FILE_PDF = "file-pdf",
    FILE_PEN = "file-pen",
    FILE_PLUS = "file-plus",
    FILE_PLUS_MINUS = "file-plus-minus",
    FILE_POWERPOINT = "file-powerpoint",
    FILE_PRESCRIPTION = "file-prescription",
    FILE_SHIELD = "file-shield",
    FILE_SIGNATURE = "file-signature",
    FILE_SLASH = "file-slash",
    FILE_SPREADSHEET = "file-spreadsheet",
    FILE_USER = "file-user",
    FILE_VIDEO = "file-video",
    FILE_WAVEFORM = "file-waveform",
    FILE_WORD = "file-word",
    FILE_XMARK = "file-xmark",
    FILE_ZIP = "file-zip",
    FILE_ZIPPER = "file-zipper",
    FILES = "files",
    FILES_MEDICAL = "files-medical",
    FILL = "fill",
    FILL_DRIP = "fill-drip",
    FILM = "film",
    FILM_CANISTER = "film-canister",
    FILM_SIMPLE = "film-simple",
    FILM_SLASH = "film-slash",
    FILMS = "films",
    FILTER = "filter",
    FILTER_CIRCLE_DOLLAR = "filter-circle-dollar",
    FILTER_CIRCLE_XMARK = "filter-circle-xmark",
    FILTER_LIST = "filter-list",
    FILTER_SLASH = "filter-slash",
    FILTERS = "filters",
    FINGERPRINT = "fingerprint",
    FIRE = "fire",
    FIRE_BURNER = "fire-burner",
    FIRE_EXTINGUISHER = "fire-extinguisher",
    FIRE_FLAME = "fire-flame",
    FIRE_FLAME_CURVED = "fire-flame-curved",
    FIRE_FLAME_SIMPLE = "fire-flame-simple",
    FIRE_HYDRANT = "fire-hydrant",
    FIRE_SMOKE = "fire-smoke",
    FIREFOX = "firefox",
    FIREFOX_BROWSER = "firefox-browser",
    FIREPLACE = "fireplace",
    FIRST_ORDER = "first-order",
    FIRST_ORDER_ALT = "first-order-alt",
    FIRSTDRAFT = "firstdraft",
    FISH = "fish",
    FISH_BONES = "fish-bones",
    FISH_COOKED = "fish-cooked",
    FISH_FINS = "fish-fins",
    FISHING_ROD = "fishing-rod",
    FLAG = "flag",
    FLAG_CHECKERED = "flag-checkered",
    FLAG_PENNANT = "flag-pennant",
    FLAG_SWALLOWTAIL = "flag-swallowtail",
    FLAG_USA = "flag-usa",
    FLASHLIGHT = "flashlight",
    FLASK = "flask",
    FLASK_GEAR = "flask-gear",
    FLASK_ROUND_POISON = "flask-round-poison",
    FLASK_ROUND_POTION = "flask-round-potion",
    FLASK_VIAL = "flask-vial",
    FLATBREAD = "flatbread",
    FLATBREAD_STUFFED = "flatbread-stuffed",
    FLICKR = "flickr",
    FLIPBOARD = "flipboard",
    FLOPPY_DISK = "floppy-disk",
    FLOPPY_DISK_CIRCLE_ARROW_RIGHT = "floppy-disk-circle-arrow-right",
    FLOPPY_DISK_CIRCLE_XMARK = "floppy-disk-circle-xmark",
    FLOPPY_DISK_PEN = "floppy-disk-pen",
    FLOPPY_DISKS = "floppy-disks",
    FLORIN_SIGN = "florin-sign",
    FLOWER = "flower",
    FLOWER_DAFFODIL = "flower-daffodil",
    FLOWER_TULIP = "flower-tulip",
    FLUTE = "flute",
    FLUX_CAPACITOR = "flux-capacitor",
    FLY = "fly",
    FLYING_DISC = "flying-disc",
    FOLDER = "folder",
    FOLDER_ARROW_DOWN = "folder-arrow-down",
    FOLDER_ARROW_UP = "folder-arrow-up",
    FOLDER_BOOKMARK = "folder-bookmark",
    FOLDER_CLOSED = "folder-closed",
    FOLDER_GEAR = "folder-gear",
    FOLDER_GRID = "folder-grid",
    FOLDER_HEART = "folder-heart",
    FOLDER_IMAGE = "folder-image",
    FOLDER_MAGNIFYING_GLASS = "folder-magnifying-glass",
    FOLDER_MEDICAL = "folder-medical",
    FOLDER_MINUS = "folder-minus",
    FOLDER_MUSIC = "folder-music",
    FOLDER_OPEN = "folder-open",
    FOLDER_PLUS = "folder-plus",
    FOLDER_TREE = "folder-tree",
    FOLDER_USER = "folder-user",
    FOLDER_XMARK = "folder-xmark",
    FOLDERS = "folders",
    FONDUE_POT = "fondue-pot",
    FONT = "font",
    FONT_AWESOME = "font-awesome",
    FONT_CASE = "font-case",
    FONTICONS = "fonticons",
    FONTICONS_FI = "fonticons-fi",
    FOOTBALL = "football",
    FOOTBALL_HELMET = "football-helmet",
    FORK = "fork",
    FORK_KNIFE = "fork-knife",
    FORKLIFT = "forklift",
    FORT = "fort",
    FORT_AWESOME = "fort-awesome",
    FORT_AWESOME_ALT = "fort-awesome-alt",
    FORUMBEE = "forumbee",
    FORWARD = "forward",
    FORWARD_FAST = "forward-fast",
    FORWARD_STEP = "forward-step",
    FOURSQUARE = "foursquare",
    FRAME = "frame",
    FRANC_SIGN = "franc-sign",
    FREE_CODE_CAMP = "free-code-camp",
    FREEBSD = "freebsd",
    FRENCH_FRIES = "french-fries",
    FROG = "frog",
    FULCRUM = "fulcrum",
    FUNCTION = "function",
    FUTBOL = "futbol",
    G = "g",
    GALACTIC_REPUBLIC = "galactic-republic",
    GALACTIC_SENATE = "galactic-senate",
    GALAXY = "galaxy",
    GALLERY_THUMBNAILS = "gallery-thumbnails",
    GAME_BOARD = "game-board",
    GAME_BOARD_SIMPLE = "game-board-simple",
    GAME_CONSOLE_HANDHELD = "game-console-handheld",
    GAME_CONSOLE_HANDHELD_CRANK = "game-console-handheld-crank",
    GAMEPAD = "gamepad",
    GAMEPAD_MODERN = "gamepad-modern",
    GARAGE = "garage",
    GARAGE_CAR = "garage-car",
    GARAGE_OPEN = "garage-open",
    GARLIC = "garlic",
    GAS_PUMP = "gas-pump",
    GAS_PUMP_SLASH = "gas-pump-slash",
    GAUGE = "gauge",
    GAUGE_CIRCLE_BOLT = "gauge-circle-bolt",
    GAUGE_CIRCLE_MINUS = "gauge-circle-minus",
    GAUGE_CIRCLE_PLUS = "gauge-circle-plus",
    GAUGE_HIGH = "gauge-high",
    GAUGE_LOW = "gauge-low",
    GAUGE_MAX = "gauge-max",
    GAUGE_MIN = "gauge-min",
    GAUGE_SIMPLE = "gauge-simple",
    GAUGE_SIMPLE_HIGH = "gauge-simple-high",
    GAUGE_SIMPLE_LOW = "gauge-simple-low",
    GAUGE_SIMPLE_MAX = "gauge-simple-max",
    GAUGE_SIMPLE_MIN = "gauge-simple-min",
    GAVEL = "gavel",
    GEAR = "gear",
    GEAR_CODE = "gear-code",
    GEAR_COMPLEX = "gear-complex",
    GEAR_COMPLEX_CODE = "gear-complex-code",
    GEARS = "gears",
    GEM = "gem",
    GENDERLESS = "genderless",
    GET_POCKET = "get-pocket",
    GG = "gg",
    GG_CIRCLE = "gg-circle",
    GHOST = "ghost",
    GIF = "gif",
    GIFT = "gift",
    GIFT_CARD = "gift-card",
    GIFTS = "gifts",
    GINGERBREAD_MAN = "gingerbread-man",
    GIT = "git",
    GIT_ALT = "git-alt",
    GITHUB = "github",
    GITHUB_ALT = "github-alt",
    GITKRAKEN = "gitkraken",
    GITLAB = "gitlab",
    GITTER = "gitter",
    GLASS = "glass",
    GLASS_CITRUS = "glass-citrus",
    GLASS_EMPTY = "glass-empty",
    GLASS_HALF = "glass-half",
    GLASS_WATER = "glass-water",
    GLASS_WATER_DROPLET = "glass-water-droplet",
    GLASSES = "glasses",
    GLASSES_ROUND = "glasses-round",
    GLIDE = "glide",
    GLIDE_G = "glide-g",
    GLOBE = "globe",
    GLOBE_POINTER = "globe-pointer",
    GLOBE_SNOW = "globe-snow",
    GLOBE_STAND = "globe-stand",
    GOAL_NET = "goal-net",
    GOFORE = "gofore",
    GOLANG = "golang",
    GOLF_BALL_TEE = "golf-ball-tee",
    GOLF_CLUB = "golf-club",
    GOLF_FLAG_HOLE = "golf-flag-hole",
    GOODREADS = "goodreads",
    GOODREADS_G = "goodreads-g",
    GOOGLE = "google",
    GOOGLE_DRIVE = "google-drive",
    GOOGLE_PAY = "google-pay",
    GOOGLE_PLAY = "google-play",
    GOOGLE_PLUS = "google-plus",
    GOOGLE_PLUS_G = "google-plus-g",
    GOOGLE_WALLET = "google-wallet",
    GOPURAM = "gopuram",
    GRADUATION_CAP = "graduation-cap",
    GRAMOPHONE = "gramophone",
    GRAPES = "grapes",
    GRATE = "grate",
    GRATE_DROPLET = "grate-droplet",
    GRATIPAY = "gratipay",
    GRAV = "grav",
    GREATER_THAN = "greater-than",
    GREATER_THAN_EQUAL = "greater-than-equal",
    GRID = "grid",
    GRID_2 = "grid-2",
    GRID_2_PLUS = "grid-2-plus",
    GRID_4 = "grid-4",
    GRID_5 = "grid-5",
    GRID_DIVIDERS = "grid-dividers",
    GRID_HORIZONTAL = "grid-horizontal",
    GRID_ROUND = "grid-round",
    GRID_ROUND_2 = "grid-round-2",
    GRID_ROUND_2_PLUS = "grid-round-2-plus",
    GRID_ROUND_4 = "grid-round-4",
    GRID_ROUND_5 = "grid-round-5",
    GRILL = "grill",
    GRILL_FIRE = "grill-fire",
    GRILL_HOT = "grill-hot",
    GRIP = "grip",
    GRIP_DOTS = "grip-dots",
    GRIP_DOTS_VERTICAL = "grip-dots-vertical",
    GRIP_LINES = "grip-lines",
    GRIP_LINES_VERTICAL = "grip-lines-vertical",
    GRIP_VERTICAL = "grip-vertical",
    GRIPFIRE = "gripfire",
    GROUP_ARROWS_ROTATE = "group-arrows-rotate",
    GRUNT = "grunt",
    GUARANI_SIGN = "guarani-sign",
    GUILDED = "guilded",
    GUITAR = "guitar",
    GUITAR_ELECTRIC = "guitar-electric",
    GUITARS = "guitars",
    GULP = "gulp",
    GUN = "gun",
    GUN_SLASH = "gun-slash",
    GUN_SQUIRT = "gun-squirt",
    H = "h",
    H1 = "h1",
    H2 = "h2",
    H3 = "h3",
    H4 = "h4",
    H5 = "h5",
    H6 = "h6",
    HACKER_NEWS = "hacker-news",
    HACKERRANK = "hackerrank",
    HAMMER = "hammer",
    HAMMER_CRASH = "hammer-crash",
    HAMMER_WAR = "hammer-war",
    HAMSA = "hamsa",
    HAND = "hand",
    HAND_BACK_FIST = "hand-back-fist",
    HAND_BACK_POINT_DOWN = "hand-back-point-down",
    HAND_BACK_POINT_LEFT = "hand-back-point-left",
    HAND_BACK_POINT_RIBBON = "hand-back-point-ribbon",
    HAND_BACK_POINT_RIGHT = "hand-back-point-right",
    HAND_BACK_POINT_UP = "hand-back-point-up",
    HAND_DOTS = "hand-dots",
    HAND_FINGERS_CROSSED = "hand-fingers-crossed",
    HAND_FIST = "hand-fist",
    HAND_HEART = "hand-heart",
    HAND_HOLDING = "hand-holding",
    HAND_HOLDING_BOX = "hand-holding-box",
    HAND_HOLDING_DOLLAR = "hand-holding-dollar",
    HAND_HOLDING_DROPLET = "hand-holding-droplet",
    HAND_HOLDING_HAND = "hand-holding-hand",
    HAND_HOLDING_HEART = "hand-holding-heart",
    HAND_HOLDING_MAGIC = "hand-holding-magic",
    HAND_HOLDING_MEDICAL = "hand-holding-medical",
    HAND_HOLDING_SEEDLING = "hand-holding-seedling",
    HAND_HOLDING_SKULL = "hand-holding-skull",
    HAND_HORNS = "hand-horns",
    HAND_LIZARD = "hand-lizard",
    HAND_LOVE = "hand-love",
    HAND_MIDDLE_FINGER = "hand-middle-finger",
    HAND_PEACE = "hand-peace",
    HAND_POINT_DOWN = "hand-point-down",
    HAND_POINT_LEFT = "hand-point-left",
    HAND_POINT_RIBBON = "hand-point-ribbon",
    HAND_POINT_RIGHT = "hand-point-right",
    HAND_POINT_UP = "hand-point-up",
    HAND_POINTER = "hand-pointer",
    HAND_SCISSORS = "hand-scissors",
    HAND_SPARKLES = "hand-sparkles",
    HAND_SPOCK = "hand-spock",
    HAND_WAVE = "hand-wave",
    HANDCUFFS = "handcuffs",
    HANDS = "hands",
    HANDS_ASL_INTERPRETING = "hands-asl-interpreting",
    HANDS_BOUND = "hands-bound",
    HANDS_BUBBLES = "hands-bubbles",
    HANDS_CLAPPING = "hands-clapping",
    HANDS_HOLDING = "hands-holding",
    HANDS_HOLDING_CHILD = "hands-holding-child",
    HANDS_HOLDING_CIRCLE = "hands-holding-circle",
    HANDS_HOLDING_DIAMOND = "hands-holding-diamond",
    HANDS_HOLDING_DOLLAR = "hands-holding-dollar",
    HANDS_HOLDING_HEART = "hands-holding-heart",
    HANDS_PRAYING = "hands-praying",
    HANDSHAKE = "handshake",
    HANDSHAKE_ANGLE = "handshake-angle",
    HANDSHAKE_SIMPLE = "handshake-simple",
    HANDSHAKE_SIMPLE_SLASH = "handshake-simple-slash",
    HANDSHAKE_SLASH = "handshake-slash",
    HANUKIAH = "hanukiah",
    HARD_DRIVE = "hard-drive",
    HASHNODE = "hashnode",
    HASHTAG = "hashtag",
    HASHTAG_LOCK = "hashtag-lock",
    HAT_BEACH = "hat-beach",
    HAT_CHEF = "hat-chef",
    HAT_COWBOY = "hat-cowboy",
    HAT_COWBOY_SIDE = "hat-cowboy-side",
    HAT_SANTA = "hat-santa",
    HAT_WINTER = "hat-winter",
    HAT_WITCH = "hat-witch",
    HAT_WIZARD = "hat-wizard",
    HEAD_SIDE = "head-side",
    HEAD_SIDE_BRAIN = "head-side-brain",
    HEAD_SIDE_COUGH = "head-side-cough",
    HEAD_SIDE_COUGH_SLASH = "head-side-cough-slash",
    HEAD_SIDE_GEAR = "head-side-gear",
    HEAD_SIDE_GOGGLES = "head-side-goggles",
    HEAD_SIDE_HEADPHONES = "head-side-headphones",
    HEAD_SIDE_HEART = "head-side-heart",
    HEAD_SIDE_MASK = "head-side-mask",
    HEAD_SIDE_MEDICAL = "head-side-medical",
    HEAD_SIDE_VIRUS = "head-side-virus",
    HEADING = "heading",
    HEADPHONES = "headphones",
    HEADPHONES_SIMPLE = "headphones-simple",
    HEADSET = "headset",
    HEART = "heart",
    HEART_CIRCLE_BOLT = "heart-circle-bolt",
    HEART_CIRCLE_CHECK = "heart-circle-check",
    HEART_CIRCLE_EXCLAMATION = "heart-circle-exclamation",
    HEART_CIRCLE_MINUS = "heart-circle-minus",
    HEART_CIRCLE_PLUS = "heart-circle-plus",
    HEART_CIRCLE_XMARK = "heart-circle-xmark",
    HEART_CRACK = "heart-crack",
    HEART_HALF = "heart-half",
    HEART_HALF_STROKE = "heart-half-stroke",
    HEART_PULSE = "heart-pulse",
    HEAT = "heat",
    HELICOPTER = "helicopter",
    HELICOPTER_SYMBOL = "helicopter-symbol",
    HELMET_BATTLE = "helmet-battle",
    HELMET_SAFETY = "helmet-safety",
    HELMET_UN = "helmet-un",
    HEXAGON = "hexagon",
    HEXAGON_CHECK = "hexagon-check",
    HEXAGON_DIVIDE = "hexagon-divide",
    HEXAGON_EXCLAMATION = "hexagon-exclamation",
    HEXAGON_IMAGE = "hexagon-image",
    HEXAGON_MINUS = "hexagon-minus",
    HEXAGON_PLUS = "hexagon-plus",
    HEXAGON_VERTICAL_NFT = "hexagon-vertical-nft",
    HEXAGON_VERTICAL_NFT_SLANTED = "hexagon-vertical-nft-slanted",
    HEXAGON_XMARK = "hexagon-xmark",
    HIGH_DEFINITION = "high-definition",
    HIGHLIGHTER = "highlighter",
    HIGHLIGHTER_LINE = "highlighter-line",
    HILL_AVALANCHE = "hill-avalanche",
    HILL_ROCKSLIDE = "hill-rockslide",
    HIPPO = "hippo",
    HIPS = "hips",
    HIRE_A_HELPER = "hire-a-helper",
    HIVE = "hive",
    HOCKEY_MASK = "hockey-mask",
    HOCKEY_PUCK = "hockey-puck",
    HOCKEY_STICK_PUCK = "hockey-stick-puck",
    HOCKEY_STICKS = "hockey-sticks",
    HOLLY_BERRY = "holly-berry",
    HONEY_POT = "honey-pot",
    HOOD_CLOAK = "hood-cloak",
    HOOLI = "hooli",
    HORIZONTAL_RULE = "horizontal-rule",
    HORNBILL = "hornbill",
    HORSE = "horse",
    HORSE_HEAD = "horse-head",
    HORSE_SADDLE = "horse-saddle",
    HOSE = "hose",
    HOSE_REEL = "hose-reel",
    HOSPITAL = "hospital",
    HOSPITAL_USER = "hospital-user",
    HOSPITALS = "hospitals",
    HOT_TUB_PERSON = "hot-tub-person",
    HOTDOG = "hotdog",
    HOTEL = "hotel",
    HOTJAR = "hotjar",
    HOURGLASS = "hourglass",
    HOURGLASS_CLOCK = "hourglass-clock",
    HOURGLASS_END = "hourglass-end",
    HOURGLASS_HALF = "hourglass-half",
    HOURGLASS_START = "hourglass-start",
    HOUSE = "house",
    HOUSE_BLANK = "house-blank",
    HOUSE_BUILDING = "house-building",
    HOUSE_CHIMNEY = "house-chimney",
    HOUSE_CHIMNEY_BLANK = "house-chimney-blank",
    HOUSE_CHIMNEY_CRACK = "house-chimney-crack",
    HOUSE_CHIMNEY_HEART = "house-chimney-heart",
    HOUSE_CHIMNEY_MEDICAL = "house-chimney-medical",
    HOUSE_CHIMNEY_USER = "house-chimney-user",
    HOUSE_CHIMNEY_WINDOW = "house-chimney-window",
    HOUSE_CIRCLE_CHECK = "house-circle-check",
    HOUSE_CIRCLE_EXCLAMATION = "house-circle-exclamation",
    HOUSE_CIRCLE_XMARK = "house-circle-xmark",
    HOUSE_CRACK = "house-crack",
    HOUSE_DAY = "house-day",
    HOUSE_FIRE = "house-fire",
    HOUSE_FLAG = "house-flag",
    HOUSE_FLOOD_WATER = "house-flood-water",
    HOUSE_FLOOD_WATER_CIRCLE_ARROW_RIGHT = "house-flood-water-circle-arrow-right",
    HOUSE_HEART = "house-heart",
    HOUSE_LAPTOP = "house-laptop",
    HOUSE_LOCK = "house-lock",
    HOUSE_MEDICAL = "house-medical",
    HOUSE_MEDICAL_CIRCLE_CHECK = "house-medical-circle-check",
    HOUSE_MEDICAL_CIRCLE_EXCLAMATION = "house-medical-circle-exclamation",
    HOUSE_MEDICAL_CIRCLE_XMARK = "house-medical-circle-xmark",
    HOUSE_MEDICAL_FLAG = "house-medical-flag",
    HOUSE_NIGHT = "house-night",
    HOUSE_PERSON_LEAVE = "house-person-leave",
    HOUSE_PERSON_RETURN = "house-person-return",
    HOUSE_SIGNAL = "house-signal",
    HOUSE_TREE = "house-tree",
    HOUSE_TSUNAMI = "house-tsunami",
    HOUSE_TURRET = "house-turret",
    HOUSE_USER = "house-user",
    HOUSE_WATER = "house-water",
    HOUSE_WINDOW = "house-window",
    HOUZZ = "houzz",
    HRYVNIA_SIGN = "hryvnia-sign",
    HTML5 = "html5",
    HUBSPOT = "hubspot",
    HUNDRED_POINTS = "hundred-points",
    HURRICANE = "hurricane",
    HYPHEN = "hyphen",
    I = "i",
    I_CURSOR = "i-cursor",
    ICE_CREAM = "ice-cream",
    ICE_SKATE = "ice-skate",
    ICICLES = "icicles",
    ICONS = "icons",
    ID_BADGE = "id-badge",
    ID_CARD = "id-card",
    ID_CARD_CLIP = "id-card-clip",
    IDEAL = "ideal",
    IGLOO = "igloo",
    IMAGE = "image",
    IMAGE_LANDSCAPE = "image-landscape",
    IMAGE_POLAROID = "image-polaroid",
    IMAGE_POLAROID_USER = "image-polaroid-user",
    IMAGE_PORTRAIT = "image-portrait",
    IMAGE_SLASH = "image-slash",
    IMAGE_USER = "image-user",
    IMAGES = "images",
    IMAGES_USER = "images-user",
    IMDB = "imdb",
    INBOX = "inbox",
    INBOX_FULL = "inbox-full",
    INBOX_IN = "inbox-in",
    INBOX_OUT = "inbox-out",
    INBOXES = "inboxes",
    INDENT = "indent",
    INDIAN_RUPEE_SIGN = "indian-rupee-sign",
    INDUSTRY = "industry",
    INDUSTRY_WINDOWS = "industry-windows",
    INFINITY = "infinity",
    INFO = "info",
    INHALER = "inhaler",
    INPUT_NUMERIC = "input-numeric",
    INPUT_PIPE = "input-pipe",
    INPUT_TEXT = "input-text",
    INSTAGRAM = "instagram",
    INSTALOD = "instalod",
    INTEGRAL = "integral",
    INTERCOM = "intercom",
    INTERNET_EXPLORER = "internet-explorer",
    INTERROBANG = "interrobang",
    INTERSECTION = "intersection",
    INVISION = "invision",
    IOXHOST = "ioxhost",
    ISLAND_TROPICAL = "island-tropical",
    ITALIC = "italic",
    ITCH_IO = "itch-io",
    ITUNES = "itunes",
    ITUNES_NOTE = "itunes-note",
    J = "j",
    JACK_O_LANTERN = "jack-o-lantern",
    JAR = "jar",
    JAR_WHEAT = "jar-wheat",
    JAVA = "java",
    JEDI = "jedi",
    JEDI_ORDER = "jedi-order",
    JENKINS = "jenkins",
    JET_FIGHTER = "jet-fighter",
    JET_FIGHTER_UP = "jet-fighter-up",
    JIRA = "jira",
    JOGET = "joget",
    JOINT = "joint",
    JOOMLA = "joomla",
    JOYSTICK = "joystick",
    JS = "js",
    JSFIDDLE = "jsfiddle",
    JUG = "jug",
    JUG_BOTTLE = "jug-bottle",
    JUG_DETERGENT = "jug-detergent",
    K = "k",
    KAABA = "kaaba",
    KAGGLE = "kaggle",
    KAZOO = "kazoo",
    KERNING = "kerning",
    KEY = "key",
    KEY_SKELETON = "key-skeleton",
    KEY_SKELETON_LEFT_RIGHT = "key-skeleton-left-right",
    KEYBASE = "keybase",
    KEYBOARD = "keyboard",
    KEYBOARD_BRIGHTNESS = "keyboard-brightness",
    KEYBOARD_BRIGHTNESS_LOW = "keyboard-brightness-low",
    KEYBOARD_DOWN = "keyboard-down",
    KEYBOARD_LEFT = "keyboard-left",
    KEYCDN = "keycdn",
    KEYNOTE = "keynote",
    KHANDA = "khanda",
    KICKSTARTER = "kickstarter",
    KICKSTARTER_K = "kickstarter-k",
    KIDNEYS = "kidneys",
    KIP_SIGN = "kip-sign",
    KIT_MEDICAL = "kit-medical",
    KITCHEN_SET = "kitchen-set",
    KITE = "kite",
    KIWI_BIRD = "kiwi-bird",
    KIWI_FRUIT = "kiwi-fruit",
    KNIFE = "knife",
    KNIFE_KITCHEN = "knife-kitchen",
    KORVUE = "korvue",
    L = "l",
    LACROSSE_STICK = "lacrosse-stick",
    LACROSSE_STICK_BALL = "lacrosse-stick-ball",
    LAMBDA = "lambda",
    LAMP = "lamp",
    LAMP_DESK = "lamp-desk",
    LAMP_FLOOR = "lamp-floor",
    LAMP_STREET = "lamp-street",
    LAND_MINE_ON = "land-mine-on",
    LANDMARK = "landmark",
    LANDMARK_DOME = "landmark-dome",
    LANDMARK_FLAG = "landmark-flag",
    LANGUAGE = "language",
    LAPTOP = "laptop",
    LAPTOP_ARROW_DOWN = "laptop-arrow-down",
    LAPTOP_BINARY = "laptop-binary",
    LAPTOP_CODE = "laptop-code",
    LAPTOP_FILE = "laptop-file",
    LAPTOP_MEDICAL = "laptop-medical",
    LAPTOP_MOBILE = "laptop-mobile",
    LAPTOP_SLASH = "laptop-slash",
    LARAVEL = "laravel",
    LARI_SIGN = "lari-sign",
    LASSO = "lasso",
    LASSO_SPARKLES = "lasso-sparkles",
    LASTFM = "lastfm",
    LAYER_GROUP = "layer-group",
    LAYER_MINUS = "layer-minus",
    LAYER_PLUS = "layer-plus",
    LEAF = "leaf",
    LEAF_HEART = "leaf-heart",
    LEAF_MAPLE = "leaf-maple",
    LEAF_OAK = "leaf-oak",
    LEAFY_GREEN = "leafy-green",
    LEANPUB = "leanpub",
    LEFT = "left",
    LEFT_FROM_LINE = "left-from-line",
    LEFT_LONG = "left-long",
    LEFT_LONG_TO_LINE = "left-long-to-line",
    LEFT_RIGHT = "left-right",
    LEFT_TO_LINE = "left-to-line",
    LEMON = "lemon",
    LESS = "less",
    LESS_THAN = "less-than",
    LESS_THAN_EQUAL = "less-than-equal",
    LIFE_RING = "life-ring",
    LIGHT_CEILING = "light-ceiling",
    LIGHT_EMERGENCY = "light-emergency",
    LIGHT_EMERGENCY_ON = "light-emergency-on",
    LIGHT_SWITCH = "light-switch",
    LIGHT_SWITCH_OFF = "light-switch-off",
    LIGHT_SWITCH_ON = "light-switch-on",
    LIGHTBULB = "lightbulb",
    LIGHTBULB_CFL = "lightbulb-cfl",
    LIGHTBULB_CFL_ON = "lightbulb-cfl-on",
    LIGHTBULB_DOLLAR = "lightbulb-dollar",
    LIGHTBULB_EXCLAMATION = "lightbulb-exclamation",
    LIGHTBULB_EXCLAMATION_ON = "lightbulb-exclamation-on",
    LIGHTBULB_GEAR = "lightbulb-gear",
    LIGHTBULB_ON = "lightbulb-on",
    LIGHTBULB_SLASH = "lightbulb-slash",
    LIGHTHOUSE = "lighthouse",
    LIGHTS_HOLIDAY = "lights-holiday",
    LINE = "line",
    LINE_COLUMNS = "line-columns",
    LINE_HEIGHT = "line-height",
    LINES_LEANING = "lines-leaning",
    LINK = "link",
    LINK_HORIZONTAL = "link-horizontal",
    LINK_HORIZONTAL_SLASH = "link-horizontal-slash",
    LINK_SIMPLE = "link-simple",
    LINK_SIMPLE_SLASH = "link-simple-slash",
    LINK_SLASH = "link-slash",
    LINKEDIN = "linkedin",
    LINKEDIN_IN = "linkedin-in",
    LINODE = "linode",
    LINUX = "linux",
    LIPS = "lips",
    LIRA_SIGN = "lira-sign",
    LIST = "list",
    LIST_CHECK = "list-check",
    LIST_DROPDOWN = "list-dropdown",
    LIST_MUSIC = "list-music",
    LIST_OL = "list-ol",
    LIST_RADIO = "list-radio",
    LIST_TIMELINE = "list-timeline",
    LIST_TREE = "list-tree",
    LIST_UL = "list-ul",
    LITECOIN_SIGN = "litecoin-sign",
    LOADER = "loader",
    LOBSTER = "lobster",
    LOCATION_ARROW = "location-arrow",
    LOCATION_CHECK = "location-check",
    LOCATION_CROSSHAIRS = "location-crosshairs",
    LOCATION_CROSSHAIRS_SLASH = "location-crosshairs-slash",
    LOCATION_DOT = "location-dot",
    LOCATION_DOT_SLASH = "location-dot-slash",
    LOCATION_EXCLAMATION = "location-exclamation",
    LOCATION_MINUS = "location-minus",
    LOCATION_PEN = "location-pen",
    LOCATION_PIN = "location-pin",
    LOCATION_PIN_LOCK = "location-pin-lock",
    LOCATION_PIN_SLASH = "location-pin-slash",
    LOCATION_PLUS = "location-plus",
    LOCATION_QUESTION = "location-question",
    LOCATION_SMILE = "location-smile",
    LOCATION_XMARK = "location-xmark",
    LOCK = "lock",
    LOCK_A = "lock-a",
    LOCK_HASHTAG = "lock-hashtag",
    LOCK_KEYHOLE = "lock-keyhole",
    LOCK_KEYHOLE_OPEN = "lock-keyhole-open",
    LOCK_OPEN = "lock-open",
    LOCUST = "locust",
    LOLLIPOP = "lollipop",
    LOVESEAT = "loveseat",
    LUCHADOR_MASK = "luchador-mask",
    LUNGS = "lungs",
    LUNGS_VIRUS = "lungs-virus",
    LYFT = "lyft",
    M = "m",
    MACE = "mace",
    MAGENTO = "magento",
    MAGNET = "magnet",
    MAGNIFYING_GLASS = "magnifying-glass",
    MAGNIFYING_GLASS_ARROW_RIGHT = "magnifying-glass-arrow-right",
    MAGNIFYING_GLASS_CHART = "magnifying-glass-chart",
    MAGNIFYING_GLASS_DOLLAR = "magnifying-glass-dollar",
    MAGNIFYING_GLASS_LOCATION = "magnifying-glass-location",
    MAGNIFYING_GLASS_MINUS = "magnifying-glass-minus",
    MAGNIFYING_GLASS_PLUS = "magnifying-glass-plus",
    MAILBOX = "mailbox",
    MAILBOX_FLAG_UP = "mailbox-flag-up",
    MAILCHIMP = "mailchimp",
    MANAT_SIGN = "manat-sign",
    MANDALORIAN = "mandalorian",
    MANDOLIN = "mandolin",
    MANGO = "mango",
    MANHOLE = "manhole",
    MAP = "map",
    MAP_LOCATION = "map-location",
    MAP_LOCATION_DOT = "map-location-dot",
    MAP_PIN = "map-pin",
    MARKDOWN = "markdown",
    MARKER = "marker",
    MARS = "mars",
    MARS_AND_VENUS = "mars-and-venus",
    MARS_AND_VENUS_BURST = "mars-and-venus-burst",
    MARS_DOUBLE = "mars-double",
    MARS_STROKE = "mars-stroke",
    MARS_STROKE_RIGHT = "mars-stroke-right",
    MARS_STROKE_UP = "mars-stroke-up",
    MARTINI_GLASS = "martini-glass",
    MARTINI_GLASS_CITRUS = "martini-glass-citrus",
    MARTINI_GLASS_EMPTY = "martini-glass-empty",
    MASK = "mask",
    MASK_FACE = "mask-face",
    MASK_SNORKEL = "mask-snorkel",
    MASK_VENTILATOR = "mask-ventilator",
    MASKS_THEATER = "masks-theater",
    MASTODON = "mastodon",
    MATTRESS_PILLOW = "mattress-pillow",
    MAXCDN = "maxcdn",
    MAXIMIZE = "maximize",
    MDB = "mdb",
    MEAT = "meat",
    MEDAL = "medal",
    MEDAPPS = "medapps",
    MEDIUM = "medium",
    MEDRT = "medrt",
    MEETUP = "meetup",
    MEGAPHONE = "megaphone",
    MEGAPORT = "megaport",
    MELON = "melon",
    MELON_SLICE = "melon-slice",
    MEMO = "memo",
    MEMO_CIRCLE_CHECK = "memo-circle-check",
    MEMO_CIRCLE_INFO = "memo-circle-info",
    MEMO_PAD = "memo-pad",
    MEMORY = "memory",
    MENDELEY = "mendeley",
    MENORAH = "menorah",
    MERCURY = "mercury",
    MERGE = "merge",
    MESSAGE = "message",
    MESSAGE_ARROW_DOWN = "message-arrow-down",
    MESSAGE_ARROW_UP = "message-arrow-up",
    MESSAGE_ARROW_UP_RIGHT = "message-arrow-up-right",
    MESSAGE_BOT = "message-bot",
    MESSAGE_CAPTIONS = "message-captions",
    MESSAGE_CHECK = "message-check",
    MESSAGE_CODE = "message-code",
    MESSAGE_DOLLAR = "message-dollar",
    MESSAGE_DOTS = "message-dots",
    MESSAGE_EXCLAMATION = "message-exclamation",
    MESSAGE_HEART = "message-heart",
    MESSAGE_IMAGE = "message-image",
    MESSAGE_LINES = "message-lines",
    MESSAGE_MEDICAL = "message-medical",
    MESSAGE_MIDDLE = "message-middle",
    MESSAGE_MIDDLE_TOP = "message-middle-top",
    MESSAGE_MINUS = "message-minus",
    MESSAGE_MUSIC = "message-music",
    MESSAGE_PEN = "message-pen",
    MESSAGE_PLUS = "message-plus",
    MESSAGE_QUESTION = "message-question",
    MESSAGE_QUOTE = "message-quote",
    MESSAGE_SLASH = "message-slash",
    MESSAGE_SMILE = "message-smile",
    MESSAGE_SMS = "message-sms",
    MESSAGE_TEXT = "message-text",
    MESSAGE_XMARK = "message-xmark",
    MESSAGES = "messages",
    MESSAGES_DOLLAR = "messages-dollar",
    MESSAGES_QUESTION = "messages-question",
    META = "meta",
    METEOR = "meteor",
    METER = "meter",
    METER_BOLT = "meter-bolt",
    METER_DROPLET = "meter-droplet",
    METER_FIRE = "meter-fire",
    MICROBLOG = "microblog",
    MICROCHIP = "microchip",
    MICROCHIP_AI = "microchip-ai",
    MICROPHONE = "microphone",
    MICROPHONE_LINES = "microphone-lines",
    MICROPHONE_LINES_SLASH = "microphone-lines-slash",
    MICROPHONE_SLASH = "microphone-slash",
    MICROPHONE_STAND = "microphone-stand",
    MICROSCOPE = "microscope",
    MICROSOFT = "microsoft",
    MICROWAVE = "microwave",
    MILL_SIGN = "mill-sign",
    MINIMIZE = "minimize",
    MINUS = "minus",
    MISTLETOE = "mistletoe",
    MITTEN = "mitten",
    MIX = "mix",
    MIXCLOUD = "mixcloud",
    MIXER = "mixer",
    MIZUNI = "mizuni",
    MOBILE = "mobile",
    MOBILE_BUTTON = "mobile-button",
    MOBILE_NOTCH = "mobile-notch",
    MOBILE_RETRO = "mobile-retro",
    MOBILE_SCREEN = "mobile-screen",
    MOBILE_SCREEN_BUTTON = "mobile-screen-button",
    MOBILE_SIGNAL = "mobile-signal",
    MOBILE_SIGNAL_OUT = "mobile-signal-out",
    MODX = "modx",
    MONERO = "monero",
    MONEY_BILL = "money-bill",
    MONEY_BILL_1 = "money-bill-1",
    MONEY_BILL_1_WAVE = "money-bill-1-wave",
    MONEY_BILL_SIMPLE = "money-bill-simple",
    MONEY_BILL_SIMPLE_WAVE = "money-bill-simple-wave",
    MONEY_BILL_TRANSFER = "money-bill-transfer",
    MONEY_BILL_TREND_UP = "money-bill-trend-up",
    MONEY_BILL_WAVE = "money-bill-wave",
    MONEY_BILL_WHEAT = "money-bill-wheat",
    MONEY_BILLS = "money-bills",
    MONEY_BILLS_SIMPLE = "money-bills-simple",
    MONEY_CHECK = "money-check",
    MONEY_CHECK_DOLLAR = "money-check-dollar",
    MONEY_CHECK_DOLLAR_PEN = "money-check-dollar-pen",
    MONEY_CHECK_PEN = "money-check-pen",
    MONEY_FROM_BRACKET = "money-from-bracket",
    MONEY_SIMPLE_FROM_BRACKET = "money-simple-from-bracket",
    MONITOR_WAVEFORM = "monitor-waveform",
    MONKEY = "monkey",
    MONUMENT = "monument",
    MOON = "moon",
    MOON_CLOUD = "moon-cloud",
    MOON_OVER_SUN = "moon-over-sun",
    MOON_STARS = "moon-stars",
    MOPED = "moped",
    MORTAR_PESTLE = "mortar-pestle",
    MOSQUE = "mosque",
    MOSQUITO = "mosquito",
    MOSQUITO_NET = "mosquito-net",
    MOTORCYCLE = "motorcycle",
    MOUND = "mound",
    MOUNTAIN = "mountain",
    MOUNTAIN_CITY = "mountain-city",
    MOUNTAIN_SUN = "mountain-sun",
    MOUNTAINS = "mountains",
    MOUSE_FIELD = "mouse-field",
    MP3_PLAYER = "mp3-player",
    MUG = "mug",
    MUG_HOT = "mug-hot",
    MUG_MARSHMALLOWS = "mug-marshmallows",
    MUG_SAUCER = "mug-saucer",
    MUG_TEA = "mug-tea",
    MUG_TEA_SAUCER = "mug-tea-saucer",
    MUSHROOM = "mushroom",
    MUSIC = "music",
    MUSIC_NOTE = "music-note",
    MUSIC_NOTE_SLASH = "music-note-slash",
    MUSIC_SLASH = "music-slash",
    MUSTACHE = "mustache",
    N = "n",
    NAIRA_SIGN = "naira-sign",
    NAPSTER = "napster",
    NARWHAL = "narwhal",
    NEOS = "neos",
    NESTING_DOLLS = "nesting-dolls",
    NETWORK_WIRED = "network-wired",
    NEUTER = "neuter",
    NEWSPAPER = "newspaper",
    NFC = "nfc",
    NFC_DIRECTIONAL = "nfc-directional",
    NFC_LOCK = "nfc-lock",
    NFC_MAGNIFYING_GLASS = "nfc-magnifying-glass",
    NFC_PEN = "nfc-pen",
    NFC_SIGNAL = "nfc-signal",
    NFC_SLASH = "nfc-slash",
    NFC_SYMBOL = "nfc-symbol",
    NFC_TRASH = "nfc-trash",
    NIMBLR = "nimblr",
    NODE = "node",
    NODE_JS = "node-js",
    NOSE = "nose",
    NOT_EQUAL = "not-equal",
    NOTDEF = "notdef",
    NOTE = "note",
    NOTE_MEDICAL = "note-medical",
    NOTE_STICKY = "note-sticky",
    NOTEBOOK = "notebook",
    NOTES = "notes",
    NOTES_MEDICAL = "notes-medical",
    NPM = "npm",
    NS8 = "ns8",
    NUTRITIONIX = "nutritionix",
    O = "o",
    OBJECT_EXCLUDE = "object-exclude",
    OBJECT_GROUP = "object-group",
    OBJECT_INTERSECT = "object-intersect",
    OBJECT_SUBTRACT = "object-subtract",
    OBJECT_UNGROUP = "object-ungroup",
    OBJECT_UNION = "object-union",
    OBJECTS_ALIGN_BOTTOM = "objects-align-bottom",
    OBJECTS_ALIGN_CENTER_HORIZONTAL = "objects-align-center-horizontal",
    OBJECTS_ALIGN_CENTER_VERTICAL = "objects-align-center-vertical",
    OBJECTS_ALIGN_LEFT = "objects-align-left",
    OBJECTS_ALIGN_RIGHT = "objects-align-right",
    OBJECTS_ALIGN_TOP = "objects-align-top",
    OBJECTS_COLUMN = "objects-column",
    OCTAGON = "octagon",
    OCTAGON_CHECK = "octagon-check",
    OCTAGON_DIVIDE = "octagon-divide",
    OCTAGON_EXCLAMATION = "octagon-exclamation",
    OCTAGON_MINUS = "octagon-minus",
    OCTAGON_PLUS = "octagon-plus",
    OCTAGON_XMARK = "octagon-xmark",
    OCTOPUS_DEPLOY = "octopus-deploy",
    ODNOKLASSNIKI = "odnoklassniki",
    ODYSEE = "odysee",
    OIL_CAN = "oil-can",
    OIL_CAN_DRIP = "oil-can-drip",
    OIL_TEMPERATURE = "oil-temperature",
    OIL_WELL = "oil-well",
    OLD_REPUBLIC = "old-republic",
    OLIVE = "olive",
    OLIVE_BRANCH = "olive-branch",
    OM = "om",
    OMEGA = "omega",
    ONION = "onion",
    OPENCART = "opencart",
    OPENID = "openid",
    OPERA = "opera",
    OPTIN_MONSTER = "optin-monster",
    OPTION = "option",
    ORCID = "orcid",
    ORNAMENT = "ornament",
    OSI = "osi",
    OTTER = "otter",
    OUTDENT = "outdent",
    OUTLET = "outlet",
    OVEN = "oven",
    OVERLINE = "overline",
    P = "p",
    PADLET = "padlet",
    PAGE = "page",
    PAGE_CARET_DOWN = "page-caret-down",
    PAGE_CARET_UP = "page-caret-up",
    PAGE4 = "page4",
    PAGELINES = "pagelines",
    PAGER = "pager",
    PAINT_ROLLER = "paint-roller",
    PAINTBRUSH = "paintbrush",
    PAINTBRUSH_FINE = "paintbrush-fine",
    PAINTBRUSH_PENCIL = "paintbrush-pencil",
    PALETTE = "palette",
    PALFED = "palfed",
    PALLET = "pallet",
    PALLET_BOX = "pallet-box",
    PALLET_BOXES = "pallet-boxes",
    PAN_FOOD = "pan-food",
    PAN_FRYING = "pan-frying",
    PANCAKES = "pancakes",
    PANEL_EWS = "panel-ews",
    PANEL_FIRE = "panel-fire",
    PANORAMA = "panorama",
    PAPER_PLANE = "paper-plane",
    PAPER_PLANE_TOP = "paper-plane-top",
    PAPERCLIP = "paperclip",
    PAPERCLIP_VERTICAL = "paperclip-vertical",
    PARACHUTE_BOX = "parachute-box",
    PARAGRAPH = "paragraph",
    PARAGRAPH_LEFT = "paragraph-left",
    PARTY_BELL = "party-bell",
    PARTY_HORN = "party-horn",
    PASSPORT = "passport",
    PASTE = "paste",
    PATREON = "patreon",
    PAUSE = "pause",
    PAW = "paw",
    PAW_CLAWS = "paw-claws",
    PAW_SIMPLE = "paw-simple",
    PAYPAL = "paypal",
    PEACE = "peace",
    PEACH = "peach",
    PEANUT = "peanut",
    PEANUTS = "peanuts",
    PEAPOD = "peapod",
    PEAR = "pear",
    PEDESTAL = "pedestal",
    PEGASUS = "pegasus",
    PEN = "pen",
    PEN_CIRCLE = "pen-circle",
    PEN_CLIP = "pen-clip",
    PEN_CLIP_SLASH = "pen-clip-slash",
    PEN_FANCY = "pen-fancy",
    PEN_FANCY_SLASH = "pen-fancy-slash",
    PEN_FIELD = "pen-field",
    PEN_LINE = "pen-line",
    PEN_NIB = "pen-nib",
    PEN_NIB_SLASH = "pen-nib-slash",
    PEN_PAINTBRUSH = "pen-paintbrush",
    PEN_RULER = "pen-ruler",
    PEN_SLASH = "pen-slash",
    PEN_SWIRL = "pen-swirl",
    PEN_TO_SQUARE = "pen-to-square",
    PENCIL = "pencil",
    PENCIL_MECHANICAL = "pencil-mechanical",
    PENCIL_SLASH = "pencil-slash",
    PEOPLE = "people",
    PEOPLE_ARROWS = "people-arrows",
    PEOPLE_CARRY_BOX = "people-carry-box",
    PEOPLE_DRESS = "people-dress",
    PEOPLE_DRESS_SIMPLE = "people-dress-simple",
    PEOPLE_GROUP = "people-group",
    PEOPLE_LINE = "people-line",
    PEOPLE_PANTS = "people-pants",
    PEOPLE_PANTS_SIMPLE = "people-pants-simple",
    PEOPLE_PULLING = "people-pulling",
    PEOPLE_ROBBERY = "people-robbery",
    PEOPLE_ROOF = "people-roof",
    PEOPLE_SIMPLE = "people-simple",
    PEPPER = "pepper",
    PEPPER_HOT = "pepper-hot",
    PERBYTE = "perbyte",
    PERCENT = "percent",
    PERIOD = "period",
    PERISCOPE = "periscope",
    PERSON = "person",
    PERSON_ARROW_DOWN_TO_LINE = "person-arrow-down-to-line",
    PERSON_ARROW_UP_FROM_LINE = "person-arrow-up-from-line",
    PERSON_BIKING = "person-biking",
    PERSON_BIKING_MOUNTAIN = "person-biking-mountain",
    PERSON_BOOTH = "person-booth",
    PERSON_BREASTFEEDING = "person-breastfeeding",
    PERSON_BURST = "person-burst",
    PERSON_CANE = "person-cane",
    PERSON_CARRY_BOX = "person-carry-box",
    PERSON_CHALKBOARD = "person-chalkboard",
    PERSON_CIRCLE_CHECK = "person-circle-check",
    PERSON_CIRCLE_EXCLAMATION = "person-circle-exclamation",
    PERSON_CIRCLE_MINUS = "person-circle-minus",
    PERSON_CIRCLE_PLUS = "person-circle-plus",
    PERSON_CIRCLE_QUESTION = "person-circle-question",
    PERSON_CIRCLE_XMARK = "person-circle-xmark",
    PERSON_DIGGING = "person-digging",
    PERSON_DOLLY = "person-dolly",
    PERSON_DOLLY_EMPTY = "person-dolly-empty",
    PERSON_DOTS_FROM_LINE = "person-dots-from-line",
    PERSON_DRESS = "person-dress",
    PERSON_DRESS_BURST = "person-dress-burst",
    PERSON_DRESS_FAIRY = "person-dress-fairy",
    PERSON_DRESS_SIMPLE = "person-dress-simple",
    PERSON_DROWNING = "person-drowning",
    PERSON_FAIRY = "person-fairy",
    PERSON_FALLING = "person-falling",
    PERSON_FALLING_BURST = "person-falling-burst",
    PERSON_FROM_PORTAL = "person-from-portal",
    PERSON_HALF_DRESS = "person-half-dress",
    PERSON_HARASSING = "person-harassing",
    PERSON_HIKING = "person-hiking",
    PERSON_MILITARY_POINTING = "person-military-pointing",
    PERSON_MILITARY_RIFLE = "person-military-rifle",
    PERSON_MILITARY_TO_PERSON = "person-military-to-person",
    PERSON_PINBALL = "person-pinball",
    PERSON_PRAYING = "person-praying",
    PERSON_PREGNANT = "person-pregnant",
    PERSON_RAYS = "person-rays",
    PERSON_RIFLE = "person-rifle",
    PERSON_RUNNING = "person-running",
    PERSON_RUNNING_FAST = "person-running-fast",
    PERSON_SEAT = "person-seat",
    PERSON_SEAT_RECLINED = "person-seat-reclined",
    PERSON_SHELTER = "person-shelter",
    PERSON_SIGN = "person-sign",
    PERSON_SIMPLE = "person-simple",
    PERSON_SKATING = "person-skating",
    PERSON_SKI_JUMPING = "person-ski-jumping",
    PERSON_SKI_LIFT = "person-ski-lift",
    PERSON_SKIING = "person-skiing",
    PERSON_SKIING_NORDIC = "person-skiing-nordic",
    PERSON_SLEDDING = "person-sledding",
    PERSON_SNOWBOARDING = "person-snowboarding",
    PERSON_SNOWMOBILING = "person-snowmobiling",
    PERSON_SWIMMING = "person-swimming",
    PERSON_THROUGH_WINDOW = "person-through-window",
    PERSON_TO_DOOR = "person-to-door",
    PERSON_TO_PORTAL = "person-to-portal",
    PERSON_WALKING = "person-walking",
    PERSON_WALKING_ARROW_LOOP_LEFT = "person-walking-arrow-loop-left",
    PERSON_WALKING_ARROW_RIGHT = "person-walking-arrow-right",
    PERSON_WALKING_DASHED_LINE_ARROW_RIGHT = "person-walking-dashed-line-arrow-right",
    PERSON_WALKING_LUGGAGE = "person-walking-luggage",
    PERSON_WALKING_WITH_CANE = "person-walking-with-cane",
    PESETA_SIGN = "peseta-sign",
    PESO_SIGN = "peso-sign",
    PHABRICATOR = "phabricator",
    PHOENIX_FRAMEWORK = "phoenix-framework",
    PHOENIX_SQUADRON = "phoenix-squadron",
    PHONE = "phone",
    PHONE_ARROW_DOWN_LEFT = "phone-arrow-down-left",
    PHONE_ARROW_RIGHT = "phone-arrow-right",
    PHONE_ARROW_UP_RIGHT = "phone-arrow-up-right",
    PHONE_FLIP = "phone-flip",
    PHONE_HANGUP = "phone-hangup",
    PHONE_INTERCOM = "phone-intercom",
    PHONE_MISSED = "phone-missed",
    PHONE_OFFICE = "phone-office",
    PHONE_PLUS = "phone-plus",
    PHONE_ROTARY = "phone-rotary",
    PHONE_SLASH = "phone-slash",
    PHONE_VOLUME = "phone-volume",
    PHONE_XMARK = "phone-xmark",
    PHOTO_FILM = "photo-film",
    PHOTO_FILM_MUSIC = "photo-film-music",
    PHP = "php",
    PI = "pi",
    PIANO = "piano",
    PIANO_KEYBOARD = "piano-keyboard",
    PICKAXE = "pickaxe",
    PICKLEBALL = "pickleball",
    PIE = "pie",
    PIED_PIPER = "pied-piper",
    PIED_PIPER_ALT = "pied-piper-alt",
    PIED_PIPER_HAT = "pied-piper-hat",
    PIED_PIPER_PP = "pied-piper-pp",
    PIG = "pig",
    PIGGY_BANK = "piggy-bank",
    PILLS = "pills",
    PINATA = "pinata",
    PINBALL = "pinball",
    PINEAPPLE = "pineapple",
    PINTEREST = "pinterest",
    PINTEREST_P = "pinterest-p",
    PIPE = "pipe",
    PIPE_CIRCLE_CHECK = "pipe-circle-check",
    PIPE_COLLAR = "pipe-collar",
    PIPE_SECTION = "pipe-section",
    PIPE_SMOKING = "pipe-smoking",
    PIPE_VALVE = "pipe-valve",
    PIX = "pix",
    PIZZA = "pizza",
    PIZZA_SLICE = "pizza-slice",
    PLACE_OF_WORSHIP = "place-of-worship",
    PLANE = "plane",
    PLANE_ARRIVAL = "plane-arrival",
    PLANE_CIRCLE_CHECK = "plane-circle-check",
    PLANE_CIRCLE_EXCLAMATION = "plane-circle-exclamation",
    PLANE_CIRCLE_XMARK = "plane-circle-xmark",
    PLANE_DEPARTURE = "plane-departure",
    PLANE_ENGINES = "plane-engines",
    PLANE_LOCK = "plane-lock",
    PLANE_PROP = "plane-prop",
    PLANE_SLASH = "plane-slash",
    PLANE_TAIL = "plane-tail",
    PLANE_UP = "plane-up",
    PLANE_UP_SLASH = "plane-up-slash",
    PLANET_MOON = "planet-moon",
    PLANET_RINGED = "planet-ringed",
    PLANT_WILT = "plant-wilt",
    PLATE_UTENSILS = "plate-utensils",
    PLATE_WHEAT = "plate-wheat",
    PLAY = "play",
    PLAY_PAUSE = "play-pause",
    PLAYSTATION = "playstation",
    PLUG = "plug",
    PLUG_CIRCLE_BOLT = "plug-circle-bolt",
    PLUG_CIRCLE_CHECK = "plug-circle-check",
    PLUG_CIRCLE_EXCLAMATION = "plug-circle-exclamation",
    PLUG_CIRCLE_MINUS = "plug-circle-minus",
    PLUG_CIRCLE_PLUS = "plug-circle-plus",
    PLUG_CIRCLE_XMARK = "plug-circle-xmark",
    PLUS = "plus",
    PLUS_LARGE = "plus-large",
    PLUS_MINUS = "plus-minus",
    PODCAST = "podcast",
    PODIUM = "podium",
    PODIUM_STAR = "podium-star",
    POLICE_BOX = "police-box",
    POLL_PEOPLE = "poll-people",
    POMPEBLED = "pompebled",
    POO = "poo",
    POO_STORM = "poo-storm",
    POOL_8_BALL = "pool-8-ball",
    POOP = "poop",
    POPCORN = "popcorn",
    POPSICLE = "popsicle",
    POT_FOOD = "pot-food",
    POTATO = "potato",
    POWER_OFF = "power-off",
    PRESCRIPTION = "prescription",
    PRESCRIPTION_BOTTLE = "prescription-bottle",
    PRESCRIPTION_BOTTLE_MEDICAL = "prescription-bottle-medical",
    PRESCRIPTION_BOTTLE_PILL = "prescription-bottle-pill",
    PRESENTATION_SCREEN = "presentation-screen",
    PRETZEL = "pretzel",
    PRINT = "print",
    PRINT_MAGNIFYING_GLASS = "print-magnifying-glass",
    PRINT_SLASH = "print-slash",
    PRODUCT_HUNT = "product-hunt",
    PROJECTOR = "projector",
    PUMP = "pump",
    PUMP_MEDICAL = "pump-medical",
    PUMP_SOAP = "pump-soap",
    PUMPKIN = "pumpkin",
    PUSHED = "pushed",
    PUZZLE = "puzzle",
    PUZZLE_PIECE = "puzzle-piece",
    PUZZLE_PIECE_SIMPLE = "puzzle-piece-simple",
    PYTHON = "python",
    Q = "q",
    QQ = "qq",
    QRCODE = "qrcode",
    QUESTION = "question",
    QUINSCAPE = "quinscape",
    QUORA = "quora",
    QUOTE_LEFT = "quote-left",
    QUOTE_RIGHT = "quote-right",
    QUOTES = "quotes",
    R = "r",
    R_PROJECT = "r-project",
    RABBIT = "rabbit",
    RABBIT_RUNNING = "rabbit-running",
    RACCOON = "raccoon",
    RACQUET = "racquet",
    RADAR = "radar",
    RADIATION = "radiation",
    RADIO = "radio",
    RADIO_TUNER = "radio-tuner",
    RAINBOW = "rainbow",
    RAINDROPS = "raindrops",
    RAM = "ram",
    RAMP_LOADING = "ramp-loading",
    RANKING_STAR = "ranking-star",
    RASPBERRY_PI = "raspberry-pi",
    RAVELRY = "ravelry",
    RAYGUN = "raygun",
    REACT = "react",
    REACTEUROPE = "reacteurope",
    README = "readme",
    REBEL = "rebel",
    RECEIPT = "receipt",
    RECORD_VINYL = "record-vinyl",
    RECTANGLE = "rectangle",
    RECTANGLE_AD = "rectangle-ad",
    RECTANGLE_BARCODE = "rectangle-barcode",
    RECTANGLE_CODE = "rectangle-code",
    RECTANGLE_HISTORY = "rectangle-history",
    RECTANGLE_HISTORY_CIRCLE_PLUS = "rectangle-history-circle-plus",
    RECTANGLE_HISTORY_CIRCLE_USER = "rectangle-history-circle-user",
    RECTANGLE_LIST = "rectangle-list",
    RECTANGLE_PRO = "rectangle-pro",
    RECTANGLE_TERMINAL = "rectangle-terminal",
    RECTANGLE_VERTICAL = "rectangle-vertical",
    RECTANGLE_VERTICAL_HISTORY = "rectangle-vertical-history",
    RECTANGLE_WIDE = "rectangle-wide",
    RECTANGLE_XMARK = "rectangle-xmark",
    RECTANGLES_MIXED = "rectangles-mixed",
    RECYCLE = "recycle",
    RED_RIVER = "red-river",
    REDDIT = "reddit",
    REDDIT_ALIEN = "reddit-alien",
    REDHAT = "redhat",
    REEL = "reel",
    REFRIGERATOR = "refrigerator",
    REGISTERED = "registered",
    RENREN = "renren",
    REPEAT = "repeat",
    REPEAT_1 = "repeat-1",
    REPLY = "reply",
    REPLY_ALL = "reply-all",
    REPLY_CLOCK = "reply-clock",
    REPLYD = "replyd",
    REPUBLICAN = "republican",
    RESEARCHGATE = "researchgate",
    RESOLVING = "resolving",
    RESTROOM = "restroom",
    RESTROOM_SIMPLE = "restroom-simple",
    RETWEET = "retweet",
    REV = "rev",
    RHOMBUS = "rhombus",
    RIBBON = "ribbon",
    RIGHT = "right",
    RIGHT_FROM_BRACKET = "right-from-bracket",
    RIGHT_FROM_LINE = "right-from-line",
    RIGHT_LEFT = "right-left",
    RIGHT_LEFT_LARGE = "right-left-large",
    RIGHT_LONG = "right-long",
    RIGHT_LONG_TO_LINE = "right-long-to-line",
    RIGHT_TO_BRACKET = "right-to-bracket",
    RIGHT_TO_LINE = "right-to-line",
    RING = "ring",
    RING_DIAMOND = "ring-diamond",
    RINGS_WEDDING = "rings-wedding",
    ROAD = "road",
    ROAD_BARRIER = "road-barrier",
    ROAD_BRIDGE = "road-bridge",
    ROAD_CIRCLE_CHECK = "road-circle-check",
    ROAD_CIRCLE_EXCLAMATION = "road-circle-exclamation",
    ROAD_CIRCLE_XMARK = "road-circle-xmark",
    ROAD_LOCK = "road-lock",
    ROAD_SPIKES = "road-spikes",
    ROBOT = "robot",
    ROBOT_ASTROMECH = "robot-astromech",
    ROCKET = "rocket",
    ROCKET_LAUNCH = "rocket-launch",
    ROCKETCHAT = "rocketchat",
    ROCKRMS = "rockrms",
    ROLLER_COASTER = "roller-coaster",
    ROTATE = "rotate",
    ROTATE_EXCLAMATION = "rotate-exclamation",
    ROTATE_LEFT = "rotate-left",
    ROTATE_RIGHT = "rotate-right",
    ROUTE = "route",
    ROUTE_HIGHWAY = "route-highway",
    ROUTE_INTERSTATE = "route-interstate",
    ROUTER = "router",
    RSS = "rss",
    RUBLE_SIGN = "ruble-sign",
    RUG = "rug",
    RUGBY_BALL = "rugby-ball",
    RULER = "ruler",
    RULER_COMBINED = "ruler-combined",
    RULER_HORIZONTAL = "ruler-horizontal",
    RULER_TRIANGLE = "ruler-triangle",
    RULER_VERTICAL = "ruler-vertical",
    RUPEE_SIGN = "rupee-sign",
    RUPIAH_SIGN = "rupiah-sign",
    RUST = "rust",
    RV = "rv",
    S = "s",
    SACK = "sack",
    SACK_DOLLAR = "sack-dollar",
    SACK_XMARK = "sack-xmark",
    SAFARI = "safari",
    SAILBOAT = "sailboat",
    SALAD = "salad",
    SALESFORCE = "salesforce",
    SALT_SHAKER = "salt-shaker",
    SANDWICH = "sandwich",
    SASS = "sass",
    SATELLITE = "satellite",
    SATELLITE_DISH = "satellite-dish",
    SAUSAGE = "sausage",
    SAXOPHONE = "saxophone",
    SAXOPHONE_FIRE = "saxophone-fire",
    SCALE_BALANCED = "scale-balanced",
    SCALE_UNBALANCED = "scale-unbalanced",
    SCALE_UNBALANCED_FLIP = "scale-unbalanced-flip",
    SCALPEL = "scalpel",
    SCALPEL_LINE_DASHED = "scalpel-line-dashed",
    SCANNER_GUN = "scanner-gun",
    SCANNER_IMAGE = "scanner-image",
    SCANNER_KEYBOARD = "scanner-keyboard",
    SCANNER_TOUCHSCREEN = "scanner-touchscreen",
    SCARECROW = "scarecrow",
    SCARF = "scarf",
    SCHLIX = "schlix",
    SCHOOL = "school",
    SCHOOL_CIRCLE_CHECK = "school-circle-check",
    SCHOOL_CIRCLE_EXCLAMATION = "school-circle-exclamation",
    SCHOOL_CIRCLE_XMARK = "school-circle-xmark",
    SCHOOL_FLAG = "school-flag",
    SCHOOL_LOCK = "school-lock",
    SCISSORS = "scissors",
    SCREEN_USERS = "screen-users",
    SCREENCAST = "screencast",
    SCREENPAL = "screenpal",
    SCREWDRIVER = "screwdriver",
    SCREWDRIVER_WRENCH = "screwdriver-wrench",
    SCRIBBLE = "scribble",
    SCRIBD = "scribd",
    SCROLL = "scroll",
    SCROLL_OLD = "scroll-old",
    SCROLL_TORAH = "scroll-torah",
    SCRUBBER = "scrubber",
    SCYTHE = "scythe",
    SD_CARD = "sd-card",
    SD_CARDS = "sd-cards",
    SEAL = "seal",
    SEAL_EXCLAMATION = "seal-exclamation",
    SEAL_QUESTION = "seal-question",
    SEARCHENGIN = "searchengin",
    SEAT_AIRLINE = "seat-airline",
    SECTION = "section",
    SEEDLING = "seedling",
    SELLCAST = "sellcast",
    SELLSY = "sellsy",
    SEMICOLON = "semicolon",
    SEND_BACK = "send-back",
    SEND_BACKWARD = "send-backward",
    SENSOR = "sensor",
    SENSOR_CLOUD = "sensor-cloud",
    SENSOR_FIRE = "sensor-fire",
    SENSOR_ON = "sensor-on",
    SENSOR_TRIANGLE_EXCLAMATION = "sensor-triangle-exclamation",
    SERVER = "server",
    SERVICESTACK = "servicestack",
    SHAPES = "shapes",
    SHARE = "share",
    SHARE_ALL = "share-all",
    SHARE_FROM_SQUARE = "share-from-square",
    SHARE_NODES = "share-nodes",
    SHEEP = "sheep",
    SHEET_PLASTIC = "sheet-plastic",
    SHEKEL_SIGN = "shekel-sign",
    SHELVES = "shelves",
    SHELVES_EMPTY = "shelves-empty",
    SHIELD = "shield",
    SHIELD_CAT = "shield-cat",
    SHIELD_CHECK = "shield-check",
    SHIELD_CROSS = "shield-cross",
    SHIELD_DOG = "shield-dog",
    SHIELD_EXCLAMATION = "shield-exclamation",
    SHIELD_HALVED = "shield-halved",
    SHIELD_HEART = "shield-heart",
    SHIELD_KEYHOLE = "shield-keyhole",
    SHIELD_MINUS = "shield-minus",
    SHIELD_PLUS = "shield-plus",
    SHIELD_QUARTERED = "shield-quartered",
    SHIELD_SLASH = "shield-slash",
    SHIELD_VIRUS = "shield-virus",
    SHIELD_XMARK = "shield-xmark",
    SHIP = "ship",
    SHIRT = "shirt",
    SHIRT_LONG_SLEEVE = "shirt-long-sleeve",
    SHIRT_RUNNING = "shirt-running",
    SHIRT_TANK_TOP = "shirt-tank-top",
    SHIRTSINBULK = "shirtsinbulk",
    SHISH_KEBAB = "shish-kebab",
    SHOE_PRINTS = "shoe-prints",
    SHOELACE = "shoelace",
    SHOP = "shop",
    SHOP_LOCK = "shop-lock",
    SHOP_SLASH = "shop-slash",
    SHOPIFY = "shopify",
    SHOPWARE = "shopware",
    SHOVEL = "shovel",
    SHOVEL_SNOW = "shovel-snow",
    SHOWER = "shower",
    SHOWER_DOWN = "shower-down",
    SHREDDER = "shredder",
    SHRIMP = "shrimp",
    SHUFFLE = "shuffle",
    SHUTTERS = "shutters",
    SHUTTLE_SPACE = "shuttle-space",
    SHUTTLECOCK = "shuttlecock",
    SICKLE = "sickle",
    SIDEBAR = "sidebar",
    SIDEBAR_FLIP = "sidebar-flip",
    SIGMA = "sigma",
    SIGN_HANGING = "sign-hanging",
    SIGNAL = "signal",
    SIGNAL_BARS = "signal-bars",
    SIGNAL_BARS_FAIR = "signal-bars-fair",
    SIGNAL_BARS_GOOD = "signal-bars-good",
    SIGNAL_BARS_SLASH = "signal-bars-slash",
    SIGNAL_BARS_WEAK = "signal-bars-weak",
    SIGNAL_FAIR = "signal-fair",
    SIGNAL_GOOD = "signal-good",
    SIGNAL_SLASH = "signal-slash",
    SIGNAL_STREAM = "signal-stream",
    SIGNAL_STREAM_SLASH = "signal-stream-slash",
    SIGNAL_STRONG = "signal-strong",
    SIGNAL_WEAK = "signal-weak",
    SIGNATURE = "signature",
    SIGNATURE_LOCK = "signature-lock",
    SIGNATURE_SLASH = "signature-slash",
    SIGNS_POST = "signs-post",
    SIM_CARD = "sim-card",
    SIM_CARDS = "sim-cards",
    SIMPLYBUILT = "simplybuilt",
    SINK = "sink",
    SIREN = "siren",
    SIREN_ON = "siren-on",
    SISTRIX = "sistrix",
    SITEMAP = "sitemap",
    SITH = "sith",
    SITROX = "sitrox",
    SKELETON = "skeleton",
    SKELETON_RIBS = "skeleton-ribs",
    SKETCH = "sketch",
    SKI_BOOT = "ski-boot",
    SKI_BOOT_SKI = "ski-boot-ski",
    SKULL = "skull",
    SKULL_COW = "skull-cow",
    SKULL_CROSSBONES = "skull-crossbones",
    SKYATLAS = "skyatlas",
    SKYPE = "skype",
    SLACK = "slack",
    SLASH = "slash",
    SLASH_BACK = "slash-back",
    SLASH_FORWARD = "slash-forward",
    SLEIGH = "sleigh",
    SLIDER = "slider",
    SLIDERS = "sliders",
    SLIDERS_SIMPLE = "sliders-simple",
    SLIDERS_UP = "sliders-up",
    SLIDESHARE = "slideshare",
    SLOT_MACHINE = "slot-machine",
    SMOG = "smog",
    SMOKE = "smoke",
    SMOKING = "smoking",
    SNAKE = "snake",
    SNAPCHAT = "snapchat",
    SNOOZE = "snooze",
    SNOW_BLOWING = "snow-blowing",
    SNOWFLAKE = "snowflake",
    SNOWFLAKE_DROPLETS = "snowflake-droplets",
    SNOWFLAKES = "snowflakes",
    SNOWMAN = "snowman",
    SNOWMAN_HEAD = "snowman-head",
    SNOWPLOW = "snowplow",
    SOAP = "soap",
    SOCKS = "socks",
    SOFT_SERVE = "soft-serve",
    SOLAR_PANEL = "solar-panel",
    SOLAR_SYSTEM = "solar-system",
    SORT = "sort",
    SORT_DOWN = "sort-down",
    SORT_UP = "sort-up",
    SOUNDCLOUD = "soundcloud",
    SOURCETREE = "sourcetree",
    SPA = "spa",
    SPACE_AWESOME = "space-awesome",
    SPACE_STATION_MOON = "space-station-moon",
    SPACE_STATION_MOON_CONSTRUCTION = "space-station-moon-construction",
    SPADE = "spade",
    SPAGHETTI_MONSTER_FLYING = "spaghetti-monster-flying",
    SPARKLE = "sparkle",
    SPARKLES = "sparkles",
    SPEAKAP = "speakap",
    SPEAKER = "speaker",
    SPEAKER_DECK = "speaker-deck",
    SPEAKERS = "speakers",
    SPELL_CHECK = "spell-check",
    SPIDER = "spider",
    SPIDER_BLACK_WIDOW = "spider-black-widow",
    SPIDER_WEB = "spider-web",
    SPINNER = "spinner",
    SPINNER_THIRD = "spinner-third",
    SPLIT = "split",
    SPLOTCH = "splotch",
    SPOON = "spoon",
    SPORTSBALL = "sportsball",
    SPOTIFY = "spotify",
    SPRAY_CAN = "spray-can",
    SPRAY_CAN_SPARKLES = "spray-can-sparkles",
    SPRINKLER = "sprinkler",
    SPRINKLER_CEILING = "sprinkler-ceiling",
    SQUARE = "square",
    SQUARE_0 = "square-0",
    SQUARE_1 = "square-1",
    SQUARE_2 = "square-2",
    SQUARE_3 = "square-3",
    SQUARE_4 = "square-4",
    SQUARE_5 = "square-5",
    SQUARE_6 = "square-6",
    SQUARE_7 = "square-7",
    SQUARE_8 = "square-8",
    SQUARE_9 = "square-9",
    SQUARE_A = "square-a",
    SQUARE_A_LOCK = "square-a-lock",
    SQUARE_AMPERSAND = "square-ampersand",
    SQUARE_ARROW_DOWN = "square-arrow-down",
    SQUARE_ARROW_DOWN_LEFT = "square-arrow-down-left",
    SQUARE_ARROW_DOWN_RIGHT = "square-arrow-down-right",
    SQUARE_ARROW_LEFT = "square-arrow-left",
    SQUARE_ARROW_RIGHT = "square-arrow-right",
    SQUARE_ARROW_UP = "square-arrow-up",
    SQUARE_ARROW_UP_LEFT = "square-arrow-up-left",
    SQUARE_ARROW_UP_RIGHT = "square-arrow-up-right",
    SQUARE_B = "square-b",
    SQUARE_BEHANCE = "square-behance",
    SQUARE_BOLT = "square-bolt",
    SQUARE_C = "square-c",
    SQUARE_CARET_DOWN = "square-caret-down",
    SQUARE_CARET_LEFT = "square-caret-left",
    SQUARE_CARET_RIGHT = "square-caret-right",
    SQUARE_CARET_UP = "square-caret-up",
    SQUARE_CHECK = "square-check",
    SQUARE_CHEVRON_DOWN = "square-chevron-down",
    SQUARE_CHEVRON_LEFT = "square-chevron-left",
    SQUARE_CHEVRON_RIGHT = "square-chevron-right",
    SQUARE_CHEVRON_UP = "square-chevron-up",
    SQUARE_CODE = "square-code",
    SQUARE_D = "square-d",
    SQUARE_DASHED = "square-dashed",
    SQUARE_DASHED_CIRCLE_PLUS = "square-dashed-circle-plus",
    SQUARE_DIVIDE = "square-divide",
    SQUARE_DOLLAR = "square-dollar",
    SQUARE_DOWN = "square-down",
    SQUARE_DOWN_LEFT = "square-down-left",
    SQUARE_DOWN_RIGHT = "square-down-right",
    SQUARE_DRIBBBLE = "square-dribbble",
    SQUARE_E = "square-e",
    SQUARE_ELLIPSIS = "square-ellipsis",
    SQUARE_ELLIPSIS_VERTICAL = "square-ellipsis-vertical",
    SQUARE_ENVELOPE = "square-envelope",
    SQUARE_EXCLAMATION = "square-exclamation",
    SQUARE_F = "square-f",
    SQUARE_FACEBOOK = "square-facebook",
    SQUARE_FONT_AWESOME = "square-font-awesome",
    SQUARE_FONT_AWESOME_STROKE = "square-font-awesome-stroke",
    SQUARE_FRAGILE = "square-fragile",
    SQUARE_FULL = "square-full",
    SQUARE_G = "square-g",
    SQUARE_GIT = "square-git",
    SQUARE_GITHUB = "square-github",
    SQUARE_GITLAB = "square-gitlab",
    SQUARE_GOOGLE_PLUS = "square-google-plus",
    SQUARE_H = "square-h",
    SQUARE_HACKER_NEWS = "square-hacker-news",
    SQUARE_HEART = "square-heart",
    SQUARE_I = "square-i",
    SQUARE_INFO = "square-info",
    SQUARE_INSTAGRAM = "square-instagram",
    SQUARE_J = "square-j",
    SQUARE_JS = "square-js",
    SQUARE_K = "square-k",
    SQUARE_KANBAN = "square-kanban",
    SQUARE_L = "square-l",
    SQUARE_LASTFM = "square-lastfm",
    SQUARE_LEFT = "square-left",
    SQUARE_LIST = "square-list",
    SQUARE_M = "square-m",
    SQUARE_MINUS = "square-minus",
    SQUARE_N = "square-n",
    SQUARE_NFI = "square-nfi",
    SQUARE_O = "square-o",
    SQUARE_ODNOKLASSNIKI = "square-odnoklassniki",
    SQUARE_P = "square-p",
    SQUARE_PARKING = "square-parking",
    SQUARE_PARKING_SLASH = "square-parking-slash",
    SQUARE_PEN = "square-pen",
    SQUARE_PERSON_CONFINED = "square-person-confined",
    SQUARE_PHONE = "square-phone",
    SQUARE_PHONE_FLIP = "square-phone-flip",
    SQUARE_PHONE_HANGUP = "square-phone-hangup",
    SQUARE_PIED_PIPER = "square-pied-piper",
    SQUARE_PINTEREST = "square-pinterest",
    SQUARE_PLUS = "square-plus",
    SQUARE_POLL_HORIZONTAL = "square-poll-horizontal",
    SQUARE_POLL_VERTICAL = "square-poll-vertical",
    SQUARE_Q = "square-q",
    SQUARE_QUARTERS = "square-quarters",
    SQUARE_QUESTION = "square-question",
    SQUARE_QUOTE = "square-quote",
    SQUARE_R = "square-r",
    SQUARE_REDDIT = "square-reddit",
    SQUARE_RIGHT = "square-right",
    SQUARE_RING = "square-ring",
    SQUARE_ROOT = "square-root",
    SQUARE_ROOT_VARIABLE = "square-root-variable",
    SQUARE_RSS = "square-rss",
    SQUARE_S = "square-s",
    SQUARE_SHARE_NODES = "square-share-nodes",
    SQUARE_SLIDERS = "square-sliders",
    SQUARE_SLIDERS_VERTICAL = "square-sliders-vertical",
    SQUARE_SMALL = "square-small",
    SQUARE_SNAPCHAT = "square-snapchat",
    SQUARE_STAR = "square-star",
    SQUARE_STEAM = "square-steam",
    SQUARE_T = "square-t",
    SQUARE_TERMINAL = "square-terminal",
    SQUARE_THIS_WAY_UP = "square-this-way-up",
    SQUARE_THREADS = "square-threads",
    SQUARE_TWITTER = "square-twitter",
    SQUARE_U = "square-u",
    SQUARE_UP = "square-up",
    SQUARE_UP_LEFT = "square-up-left",
    SQUARE_UP_RIGHT = "square-up-right",
    SQUARE_USER = "square-user",
    SQUARE_V = "square-v",
    SQUARE_VIADEO = "square-viadeo",
    SQUARE_VIMEO = "square-vimeo",
    SQUARE_VIRUS = "square-virus",
    SQUARE_W = "square-w",
    SQUARE_WHATSAPP = "square-whatsapp",
    SQUARE_X = "square-x",
    SQUARE_X_TWITTER = "square-x-twitter",
    SQUARE_XING = "square-xing",
    SQUARE_XMARK = "square-xmark",
    SQUARE_Y = "square-y",
    SQUARE_YOUTUBE = "square-youtube",
    SQUARE_Z = "square-z",
    SQUARESPACE = "squarespace",
    SQUID = "squid",
    SQUIRREL = "squirrel",
    STACK_EXCHANGE = "stack-exchange",
    STACK_OVERFLOW = "stack-overflow",
    STACKPATH = "stackpath",
    STAFF = "staff",
    STAFF_SNAKE = "staff-snake",
    STAIRS = "stairs",
    STAMP = "stamp",
    STANDARD_DEFINITION = "standard-definition",
    STAPLER = "stapler",
    STAR = "star",
    STAR_AND_CRESCENT = "star-and-crescent",
    STAR_CHRISTMAS = "star-christmas",
    STAR_EXCLAMATION = "star-exclamation",
    STAR_HALF = "star-half",
    STAR_HALF_STROKE = "star-half-stroke",
    STAR_OF_DAVID = "star-of-david",
    STAR_OF_LIFE = "star-of-life",
    STAR_SHARP = "star-sharp",
    STAR_SHARP_HALF = "star-sharp-half",
    STAR_SHARP_HALF_STROKE = "star-sharp-half-stroke",
    STAR_SHOOTING = "star-shooting",
    STARFIGHTER = "starfighter",
    STARFIGHTER_TWIN_ION_ENGINE = "starfighter-twin-ion-engine",
    STARFIGHTER_TWIN_ION_ENGINE_ADVANCED = "starfighter-twin-ion-engine-advanced",
    STARS = "stars",
    STARSHIP = "starship",
    STARSHIP_FREIGHTER = "starship-freighter",
    STAYLINKED = "staylinked",
    STEAK = "steak",
    STEAM = "steam",
    STEAM_SYMBOL = "steam-symbol",
    STEERING_WHEEL = "steering-wheel",
    STERLING_SIGN = "sterling-sign",
    STETHOSCOPE = "stethoscope",
    STICKER_MULE = "sticker-mule",
    STOCKING = "stocking",
    STOMACH = "stomach",
    STOP = "stop",
    STOPWATCH = "stopwatch",
    STOPWATCH_20 = "stopwatch-20",
    STORE = "store",
    STORE_LOCK = "store-lock",
    STORE_SLASH = "store-slash",
    STRAVA = "strava",
    STRAWBERRY = "strawberry",
    STREET_VIEW = "street-view",
    STRETCHER = "stretcher",
    STRIKETHROUGH = "strikethrough",
    STRIPE = "stripe",
    STRIPE_S = "stripe-s",
    STROOPWAFEL = "stroopwafel",
    STUBBER = "stubber",
    STUDIOVINARI = "studiovinari",
    STUMBLEUPON = "stumbleupon",
    STUMBLEUPON_CIRCLE = "stumbleupon-circle",
    SUBSCRIPT = "subscript",
    SUBTITLES = "subtitles",
    SUBTITLES_SLASH = "subtitles-slash",
    SUITCASE = "suitcase",
    SUITCASE_MEDICAL = "suitcase-medical",
    SUITCASE_ROLLING = "suitcase-rolling",
    SUN = "sun",
    SUN_BRIGHT = "sun-bright",
    SUN_CLOUD = "sun-cloud",
    SUN_DUST = "sun-dust",
    SUN_HAZE = "sun-haze",
    SUN_PLANT_WILT = "sun-plant-wilt",
    SUNGLASSES = "sunglasses",
    SUNRISE = "sunrise",
    SUNSET = "sunset",
    SUPERPOWERS = "superpowers",
    SUPERSCRIPT = "superscript",
    SUPPLE = "supple",
    SUSE = "suse",
    SUSHI = "sushi",
    SUSHI_ROLL = "sushi-roll",
    SWAP = "swap",
    SWAP_ARROWS = "swap-arrows",
    SWATCHBOOK = "swatchbook",
    SWIFT = "swift",
    SWORD = "sword",
    SWORD_LASER = "sword-laser",
    SWORD_LASER_ALT = "sword-laser-alt",
    SWORDS = "swords",
    SWORDS_LASER = "swords-laser",
    SYMBOLS = "symbols",
    SYMFONY = "symfony",
    SYNAGOGUE = "synagogue",
    SYRINGE = "syringe",
    T = "t",
    TABLE = "table",
    TABLE_CELLS = "table-cells",
    TABLE_CELLS_LARGE = "table-cells-large",
    TABLE_COLUMNS = "table-columns",
    TABLE_LAYOUT = "table-layout",
    TABLE_LIST = "table-list",
    TABLE_PICNIC = "table-picnic",
    TABLE_PIVOT = "table-pivot",
    TABLE_ROWS = "table-rows",
    TABLE_TENNIS_PADDLE_BALL = "table-tennis-paddle-ball",
    TABLE_TREE = "table-tree",
    TABLET = "tablet",
    TABLET_BUTTON = "tablet-button",
    TABLET_RUGGED = "tablet-rugged",
    TABLET_SCREEN = "tablet-screen",
    TABLET_SCREEN_BUTTON = "tablet-screen-button",
    TABLETS = "tablets",
    TACHOGRAPH_DIGITAL = "tachograph-digital",
    TACO = "taco",
    TAG = "tag",
    TAGS = "tags",
    TALLY = "tally",
    TALLY_1 = "tally-1",
    TALLY_2 = "tally-2",
    TALLY_3 = "tally-3",
    TALLY_4 = "tally-4",
    TAMALE = "tamale",
    TANK_WATER = "tank-water",
    TAPE = "tape",
    TARP = "tarp",
    TARP_DROPLET = "tarp-droplet",
    TAXI = "taxi",
    TAXI_BUS = "taxi-bus",
    TEAMSPEAK = "teamspeak",
    TEDDY_BEAR = "teddy-bear",
    TEETH = "teeth",
    TEETH_OPEN = "teeth-open",
    TELEGRAM = "telegram",
    TELESCOPE = "telescope",
    TEMPERATURE_ARROW_DOWN = "temperature-arrow-down",
    TEMPERATURE_ARROW_UP = "temperature-arrow-up",
    TEMPERATURE_EMPTY = "temperature-empty",
    TEMPERATURE_FULL = "temperature-full",
    TEMPERATURE_HALF = "temperature-half",
    TEMPERATURE_HIGH = "temperature-high",
    TEMPERATURE_LIST = "temperature-list",
    TEMPERATURE_LOW = "temperature-low",
    TEMPERATURE_QUARTER = "temperature-quarter",
    TEMPERATURE_SNOW = "temperature-snow",
    TEMPERATURE_SUN = "temperature-sun",
    TEMPERATURE_THREE_QUARTERS = "temperature-three-quarters",
    TENCENT_WEIBO = "tencent-weibo",
    TENGE_SIGN = "tenge-sign",
    TENNIS_BALL = "tennis-ball",
    TENT = "tent",
    TENT_ARROW_DOWN_TO_LINE = "tent-arrow-down-to-line",
    TENT_ARROW_LEFT_RIGHT = "tent-arrow-left-right",
    TENT_ARROW_TURN_LEFT = "tent-arrow-turn-left",
    TENT_ARROWS_DOWN = "tent-arrows-down",
    TENTS = "tents",
    TERMINAL = "terminal",
    TEXT = "text",
    TEXT_HEIGHT = "text-height",
    TEXT_SIZE = "text-size",
    TEXT_SLASH = "text-slash",
    TEXT_WIDTH = "text-width",
    THE_RED_YETI = "the-red-yeti",
    THEMECO = "themeco",
    THEMEISLE = "themeisle",
    THERMOMETER = "thermometer",
    THETA = "theta",
    THINK_PEAKS = "think-peaks",
    THOUGHT_BUBBLE = "thought-bubble",
    THREADS = "threads",
    THUMBS_DOWN = "thumbs-down",
    THUMBS_UP = "thumbs-up",
    THUMBTACK = "thumbtack",
    TICK = "tick",
    TICKET = "ticket",
    TICKET_AIRLINE = "ticket-airline",
    TICKET_SIMPLE = "ticket-simple",
    TICKETS_AIRLINE = "tickets-airline",
    TIKTOK = "tiktok",
    TILDE = "tilde",
    TIMELINE = "timeline",
    TIMELINE_ARROW = "timeline-arrow",
    TIMER = "timer",
    TIRE = "tire",
    TIRE_FLAT = "tire-flat",
    TIRE_PRESSURE_WARNING = "tire-pressure-warning",
    TIRE_RUGGED = "tire-rugged",
    TOGGLE_LARGE_OFF = "toggle-large-off",
    TOGGLE_LARGE_ON = "toggle-large-on",
    TOGGLE_OFF = "toggle-off",
    TOGGLE_ON = "toggle-on",
    TOILET = "toilet",
    TOILET_PAPER = "toilet-paper",
    TOILET_PAPER_BLANK = "toilet-paper-blank",
    TOILET_PAPER_BLANK_UNDER = "toilet-paper-blank-under",
    TOILET_PAPER_CHECK = "toilet-paper-check",
    TOILET_PAPER_SLASH = "toilet-paper-slash",
    TOILET_PAPER_UNDER = "toilet-paper-under",
    TOILET_PAPER_UNDER_SLASH = "toilet-paper-under-slash",
    TOILET_PAPER_XMARK = "toilet-paper-xmark",
    TOILET_PORTABLE = "toilet-portable",
    TOILETS_PORTABLE = "toilets-portable",
    TOMATO = "tomato",
    TOMBSTONE = "tombstone",
    TOMBSTONE_BLANK = "tombstone-blank",
    TOOLBOX = "toolbox",
    TOOTH = "tooth",
    TOOTHBRUSH = "toothbrush",
    TORII_GATE = "torii-gate",
    TORNADO = "tornado",
    TOWER_BROADCAST = "tower-broadcast",
    TOWER_CELL = "tower-cell",
    TOWER_CONTROL = "tower-control",
    TOWER_OBSERVATION = "tower-observation",
    TRACTOR = "tractor",
    TRADE_FEDERATION = "trade-federation",
    TRADEMARK = "trademark",
    TRAFFIC_CONE = "traffic-cone",
    TRAFFIC_LIGHT = "traffic-light",
    TRAFFIC_LIGHT_GO = "traffic-light-go",
    TRAFFIC_LIGHT_SLOW = "traffic-light-slow",
    TRAFFIC_LIGHT_STOP = "traffic-light-stop",
    TRAILER = "trailer",
    TRAIN = "train",
    TRAIN_SUBWAY = "train-subway",
    TRAIN_SUBWAY_TUNNEL = "train-subway-tunnel",
    TRAIN_TRACK = "train-track",
    TRAIN_TRAM = "train-tram",
    TRAIN_TUNNEL = "train-tunnel",
    TRANSFORMER_BOLT = "transformer-bolt",
    TRANSGENDER = "transgender",
    TRANSPORTER = "transporter",
    TRANSPORTER_1 = "transporter-1",
    TRANSPORTER_2 = "transporter-2",
    TRANSPORTER_3 = "transporter-3",
    TRANSPORTER_4 = "transporter-4",
    TRANSPORTER_5 = "transporter-5",
    TRANSPORTER_6 = "transporter-6",
    TRANSPORTER_7 = "transporter-7",
    TRANSPORTER_EMPTY = "transporter-empty",
    TRASH = "trash",
    TRASH_ARROW_UP = "trash-arrow-up",
    TRASH_CAN = "trash-can",
    TRASH_CAN_ARROW_UP = "trash-can-arrow-up",
    TRASH_CAN_CHECK = "trash-can-check",
    TRASH_CAN_CLOCK = "trash-can-clock",
    TRASH_CAN_LIST = "trash-can-list",
    TRASH_CAN_PLUS = "trash-can-plus",
    TRASH_CAN_SLASH = "trash-can-slash",
    TRASH_CAN_UNDO = "trash-can-undo",
    TRASH_CAN_XMARK = "trash-can-xmark",
    TRASH_CHECK = "trash-check",
    TRASH_CLOCK = "trash-clock",
    TRASH_LIST = "trash-list",
    TRASH_PLUS = "trash-plus",
    TRASH_SLASH = "trash-slash",
    TRASH_UNDO = "trash-undo",
    TRASH_XMARK = "trash-xmark",
    TREASURE_CHEST = "treasure-chest",
    TREE = "tree",
    TREE_CHRISTMAS = "tree-christmas",
    TREE_CITY = "tree-city",
    TREE_DECIDUOUS = "tree-deciduous",
    TREE_DECORATED = "tree-decorated",
    TREE_LARGE = "tree-large",
    TREE_PALM = "tree-palm",
    TREES = "trees",
    TRELLO = "trello",
    TRIANGLE = "triangle",
    TRIANGLE_EXCLAMATION = "triangle-exclamation",
    TRIANGLE_INSTRUMENT = "triangle-instrument",
    TRIANGLE_PERSON_DIGGING = "triangle-person-digging",
    TRICYCLE = "tricycle",
    TRICYCLE_ADULT = "tricycle-adult",
    TRILLIUM = "trillium",
    TROPHY = "trophy",
    TROPHY_STAR = "trophy-star",
    TROWEL = "trowel",
    TROWEL_BRICKS = "trowel-bricks",
    TRUCK = "truck",
    TRUCK_ARROW_RIGHT = "truck-arrow-right",
    TRUCK_BOLT = "truck-bolt",
    TRUCK_CLOCK = "truck-clock",
    TRUCK_CONTAINER = "truck-container",
    TRUCK_CONTAINER_EMPTY = "truck-container-empty",
    TRUCK_DROPLET = "truck-droplet",
    TRUCK_FAST = "truck-fast",
    TRUCK_FIELD = "truck-field",
    TRUCK_FIELD_UN = "truck-field-un",
    TRUCK_FLATBED = "truck-flatbed",
    TRUCK_FRONT = "truck-front",
    TRUCK_MEDICAL = "truck-medical",
    TRUCK_MONSTER = "truck-monster",
    TRUCK_MOVING = "truck-moving",
    TRUCK_PICKUP = "truck-pickup",
    TRUCK_PLANE = "truck-plane",
    TRUCK_PLOW = "truck-plow",
    TRUCK_RAMP = "truck-ramp",
    TRUCK_RAMP_BOX = "truck-ramp-box",
    TRUCK_RAMP_COUCH = "truck-ramp-couch",
    TRUCK_TOW = "truck-tow",
    TRUMPET = "trumpet",
    TTY = "tty",
    TTY_ANSWER = "tty-answer",
    TUGRIK_SIGN = "tugrik-sign",
    TUMBLR = "tumblr",
    TURKEY = "turkey",
    TURKISH_LIRA_SIGN = "turkish-lira-sign",
    TURN_DOWN = "turn-down",
    TURN_DOWN_LEFT = "turn-down-left",
    TURN_DOWN_RIGHT = "turn-down-right",
    TURN_UP = "turn-up",
    TURNTABLE = "turntable",
    TURTLE = "turtle",
    TV = "tv",
    TV_MUSIC = "tv-music",
    TV_RETRO = "tv-retro",
    TWITCH = "twitch",
    TWITTER = "twitter",
    TYPEWRITER = "typewriter",
    TYPO3 = "typo3",
    U = "u",
    UBER = "uber",
    UBUNTU = "ubuntu",
    UFO = "ufo",
    UFO_BEAM = "ufo-beam",
    UIKIT = "uikit",
    UMBRACO = "umbraco",
    UMBRELLA = "umbrella",
    UMBRELLA_BEACH = "umbrella-beach",
    UMBRELLA_SIMPLE = "umbrella-simple",
    UNCHARTED = "uncharted",
    UNDERLINE = "underline",
    UNICORN = "unicorn",
    UNIFORM_MARTIAL_ARTS = "uniform-martial-arts",
    UNION = "union",
    UNIREGISTRY = "uniregistry",
    UNITY = "unity",
    UNIVERSAL_ACCESS = "universal-access",
    UNLOCK = "unlock",
    UNLOCK_KEYHOLE = "unlock-keyhole",
    UNSPLASH = "unsplash",
    UNTAPPD = "untappd",
    UP = "up",
    UP_DOWN = "up-down",
    UP_DOWN_LEFT_RIGHT = "up-down-left-right",
    UP_FROM_BRACKET = "up-from-bracket",
    UP_FROM_DOTTED_LINE = "up-from-dotted-line",
    UP_FROM_LINE = "up-from-line",
    UP_LEFT = "up-left",
    UP_LONG = "up-long",
    UP_RIGHT = "up-right",
    UP_RIGHT_AND_DOWN_LEFT_FROM_CENTER = "up-right-and-down-left-from-center",
    UP_RIGHT_FROM_SQUARE = "up-right-from-square",
    UP_TO_DOTTED_LINE = "up-to-dotted-line",
    UP_TO_LINE = "up-to-line",
    UPLOAD = "upload",
    UPS = "ups",
    USB = "usb",
    USB_DRIVE = "usb-drive",
    USER = "user",
    USER_ALIEN = "user-alien",
    USER_ASTRONAUT = "user-astronaut",
    USER_BOUNTY_HUNTER = "user-bounty-hunter",
    USER_CHECK = "user-check",
    USER_CHEF = "user-chef",
    USER_CLOCK = "user-clock",
    USER_COWBOY = "user-cowboy",
    USER_CROWN = "user-crown",
    USER_DOCTOR = "user-doctor",
    USER_DOCTOR_HAIR = "user-doctor-hair",
    USER_DOCTOR_HAIR_LONG = "user-doctor-hair-long",
    USER_DOCTOR_MESSAGE = "user-doctor-message",
    USER_GEAR = "user-gear",
    USER_GRADUATE = "user-graduate",
    USER_GROUP = "user-group",
    USER_GROUP_CROWN = "user-group-crown",
    USER_GROUP_SIMPLE = "user-group-simple",
    USER_HAIR = "user-hair",
    USER_HAIR_BUNS = "user-hair-buns",
    USER_HAIR_LONG = "user-hair-long",
    USER_HAIR_MULLET = "user-hair-mullet",
    USER_HEADSET = "user-headset",
    USER_HELMET_SAFETY = "user-helmet-safety",
    USER_INJURED = "user-injured",
    USER_LARGE = "user-large",
    USER_LARGE_SLASH = "user-large-slash",
    USER_LOCK = "user-lock",
    USER_MAGNIFYING_GLASS = "user-magnifying-glass",
    USER_MINUS = "user-minus",
    USER_MUSIC = "user-music",
    USER_NINJA = "user-ninja",
    USER_NURSE = "user-nurse",
    USER_NURSE_HAIR = "user-nurse-hair",
    USER_NURSE_HAIR_LONG = "user-nurse-hair-long",
    USER_PEN = "user-pen",
    USER_PILOT = "user-pilot",
    USER_PILOT_TIE = "user-pilot-tie",
    USER_PLUS = "user-plus",
    USER_POLICE = "user-police",
    USER_POLICE_TIE = "user-police-tie",
    USER_ROBOT = "user-robot",
    USER_ROBOT_XMARKS = "user-robot-xmarks",
    USER_SECRET = "user-secret",
    USER_SHAKESPEARE = "user-shakespeare",
    USER_SHIELD = "user-shield",
    USER_SLASH = "user-slash",
    USER_TAG = "user-tag",
    USER_TIE = "user-tie",
    USER_TIE_HAIR = "user-tie-hair",
    USER_TIE_HAIR_LONG = "user-tie-hair-long",
    USER_UNLOCK = "user-unlock",
    USER_VISOR = "user-visor",
    USER_VNECK = "user-vneck",
    USER_VNECK_HAIR = "user-vneck-hair",
    USER_VNECK_HAIR_LONG = "user-vneck-hair-long",
    USER_XMARK = "user-xmark",
    USERS = "users",
    USERS_BETWEEN_LINES = "users-between-lines",
    USERS_GEAR = "users-gear",
    USERS_LINE = "users-line",
    USERS_MEDICAL = "users-medical",
    USERS_RAYS = "users-rays",
    USERS_RECTANGLE = "users-rectangle",
    USERS_SLASH = "users-slash",
    USERS_VIEWFINDER = "users-viewfinder",
    USPS = "usps",
    USSUNNAH = "ussunnah",
    UTENSILS = "utensils",
    UTENSILS_SLASH = "utensils-slash",
    UTILITY_POLE = "utility-pole",
    UTILITY_POLE_DOUBLE = "utility-pole-double",
    V = "v",
    VAADIN = "vaadin",
    VACUUM = "vacuum",
    VACUUM_ROBOT = "vacuum-robot",
    VALUE_ABSOLUTE = "value-absolute",
    VAN_SHUTTLE = "van-shuttle",
    VAULT = "vault",
    VECTOR_CIRCLE = "vector-circle",
    VECTOR_POLYGON = "vector-polygon",
    VECTOR_SQUARE = "vector-square",
    VENT_DAMPER = "vent-damper",
    VENUS = "venus",
    VENUS_DOUBLE = "venus-double",
    VENUS_MARS = "venus-mars",
    VEST = "vest",
    VEST_PATCHES = "vest-patches",
    VIACOIN = "viacoin",
    VIADEO = "viadeo",
    VIAL = "vial",
    VIAL_CIRCLE_CHECK = "vial-circle-check",
    VIAL_VIRUS = "vial-virus",
    VIALS = "vials",
    VIBER = "viber",
    VIDEO = "video",
    VIDEO_ARROW_DOWN_LEFT = "video-arrow-down-left",
    VIDEO_ARROW_UP_RIGHT = "video-arrow-up-right",
    VIDEO_PLUS = "video-plus",
    VIDEO_SLASH = "video-slash",
    VIHARA = "vihara",
    VIMEO = "vimeo",
    VIMEO_V = "vimeo-v",
    VINE = "vine",
    VIOLIN = "violin",
    VIRUS = "virus",
    VIRUS_COVID = "virus-covid",
    VIRUS_COVID_SLASH = "virus-covid-slash",
    VIRUS_SLASH = "virus-slash",
    VIRUSES = "viruses",
    VK = "vk",
    VNV = "vnv",
    VOICEMAIL = "voicemail",
    VOLCANO = "volcano",
    VOLLEYBALL = "volleyball",
    VOLUME = "volume",
    VOLUME_HIGH = "volume-high",
    VOLUME_LOW = "volume-low",
    VOLUME_OFF = "volume-off",
    VOLUME_SLASH = "volume-slash",
    VOLUME_XMARK = "volume-xmark",
    VR_CARDBOARD = "vr-cardboard",
    VUEJS = "vuejs",
    W = "w",
    WAFFLE = "waffle",
    WAGON_COVERED = "wagon-covered",
    WALKER = "walker",
    WALKIE_TALKIE = "walkie-talkie",
    WALLET = "wallet",
    WAND = "wand",
    WAND_MAGIC = "wand-magic",
    WAND_MAGIC_SPARKLES = "wand-magic-sparkles",
    WAND_SPARKLES = "wand-sparkles",
    WAREHOUSE = "warehouse",
    WAREHOUSE_FULL = "warehouse-full",
    WASHING_MACHINE = "washing-machine",
    WATCH = "watch",
    WATCH_APPLE = "watch-apple",
    WATCH_CALCULATOR = "watch-calculator",
    WATCH_FITNESS = "watch-fitness",
    WATCH_SMART = "watch-smart",
    WATCHMAN_MONITORING = "watchman-monitoring",
    WATER = "water",
    WATER_ARROW_DOWN = "water-arrow-down",
    WATER_ARROW_UP = "water-arrow-up",
    WATER_LADDER = "water-ladder",
    WATERMELON_SLICE = "watermelon-slice",
    WAVE_PULSE = "wave-pulse",
    WAVE_SINE = "wave-sine",
    WAVE_SQUARE = "wave-square",
    WAVE_TRIANGLE = "wave-triangle",
    WAVEFORM = "waveform",
    WAVEFORM_LINES = "waveform-lines",
    WAZE = "waze",
    WEBHOOK = "webhook",
    WEEBLY = "weebly",
    WEIBO = "weibo",
    WEIGHT_HANGING = "weight-hanging",
    WEIGHT_SCALE = "weight-scale",
    WEIXIN = "weixin",
    WHALE = "whale",
    WHATSAPP = "whatsapp",
    WHEAT = "wheat",
    WHEAT_AWN = "wheat-awn",
    WHEAT_AWN_CIRCLE_EXCLAMATION = "wheat-awn-circle-exclamation",
    WHEAT_AWN_SLASH = "wheat-awn-slash",
    WHEAT_SLASH = "wheat-slash",
    WHEELCHAIR = "wheelchair",
    WHEELCHAIR_MOVE = "wheelchair-move",
    WHISKEY_GLASS = "whiskey-glass",
    WHISKEY_GLASS_ICE = "whiskey-glass-ice",
    WHISTLE = "whistle",
    WHMCS = "whmcs",
    WIFI = "wifi",
    WIFI_EXCLAMATION = "wifi-exclamation",
    WIFI_FAIR = "wifi-fair",
    WIFI_SLASH = "wifi-slash",
    WIFI_WEAK = "wifi-weak",
    WIKIPEDIA_W = "wikipedia-w",
    WIND = "wind",
    WIND_TURBINE = "wind-turbine",
    WIND_WARNING = "wind-warning",
    WINDOW = "window",
    WINDOW_FLIP = "window-flip",
    WINDOW_FRAME = "window-frame",
    WINDOW_FRAME_OPEN = "window-frame-open",
    WINDOW_MAXIMIZE = "window-maximize",
    WINDOW_MINIMIZE = "window-minimize",
    WINDOW_RESTORE = "window-restore",
    WINDOWS = "windows",
    WINDSOCK = "windsock",
    WINE_BOTTLE = "wine-bottle",
    WINE_GLASS = "wine-glass",
    WINE_GLASS_CRACK = "wine-glass-crack",
    WINE_GLASS_EMPTY = "wine-glass-empty",
    WIRSINDHANDWERK = "wirsindhandwerk",
    WIX = "wix",
    WIZARDS_OF_THE_COAST = "wizards-of-the-coast",
    WODU = "wodu",
    WOLF_PACK_BATTALION = "wolf-pack-battalion",
    WON_SIGN = "won-sign",
    WORDPRESS = "wordpress",
    WORDPRESS_SIMPLE = "wordpress-simple",
    WORM = "worm",
    WPBEGINNER = "wpbeginner",
    WPEXPLORER = "wpexplorer",
    WPFORMS = "wpforms",
    WPRESSR = "wpressr",
    WREATH = "wreath",
    WREATH_LAUREL = "wreath-laurel",
    WRENCH = "wrench",
    WRENCH_SIMPLE = "wrench-simple",
    X = "x",
    X_RAY = "x-ray",
    X_TWITTER = "x-twitter",
    XBOX = "xbox",
    XING = "xing",
    XMARK = "xmark",
    XMARK_LARGE = "xmark-large",
    XMARK_TO_SLOT = "xmark-to-slot",
    XMARKS_LINES = "xmarks-lines",
    Y = "y",
    Y_COMBINATOR = "y-combinator",
    YAHOO = "yahoo",
    YAMMER = "yammer",
    YANDEX = "yandex",
    YANDEX_INTERNATIONAL = "yandex-international",
    YARN = "yarn",
    YELP = "yelp",
    YEN_SIGN = "yen-sign",
    YIN_YANG = "yin-yang",
    YOAST = "yoast",
    YOUTUBE = "youtube",
    Z = "z",
    ZHIHU = "zhihu"
}